/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EditionsearchRouteImport } from './routes/_editionsearch'
import { Route as WorksearchRouteImport } from './routes/_worksearch'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ConceptsRouteImport } from './routes/concepts'
import { Route as ImportsRouteImport } from './routes/imports'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as MetadataRouteImport } from './routes/metadata'
import { Route as MydownloadsRouteImport } from './routes/mydownloads'
import { Route as MyworkRouteImport } from './routes/mywork'
import { Route as RoyaltyRouteImport } from './routes/royalty'
import { Route as UsersRouteImport } from './routes/users'
import { Route as WorksearchWorksRouteImport } from './routes/_worksearch/works'
import { Route as AdminCosttypesRouteImport } from './routes/admin/costtypes'
import { Route as AdminEanseriesRouteImport } from './routes/admin/eanseries'
import { Route as AdminEmailtemplatesRouteImport } from './routes/admin/emailtemplates'
import { Route as AdminPrinterpricesRouteImport } from './routes/admin/printerprices'
import { Route as AdminProductionPlansRouteImport } from './routes/admin/production-plans'
import { Route as AdminRoyaltyPriceRulesRouteImport } from './routes/admin/royaltyPriceRules'
import { Route as AdminRoyaltySalesChannelsRouteImport } from './routes/admin/royaltySalesChannels'
import { Route as AdminTagsRouteImport } from './routes/admin/tags'
import { Route as AdministrationIndexRouteImport } from './routes/administration/index'
import { Route as AdministrationCosttypesRouteImport } from './routes/administration/costtypes'
import { Route as AdministrationEanseriesRouteImport } from './routes/administration/eanseries'
import { Route as AdministrationEmailtemplatesRouteImport } from './routes/administration/emailtemplates'
import { Route as AdministrationIntegrationsRouteImport } from './routes/administration/integrations'
import { Route as AdministrationMetadataRouteImport } from './routes/administration/metadata'
import { Route as AdministrationPrinterpricesRouteImport } from './routes/administration/printerprices'
import { Route as AdministrationProductionPlansRouteImport } from './routes/administration/production-plans'
import { Route as AdministrationRoyaltyPriceRulesRouteImport } from './routes/administration/royaltyPriceRules'
import { Route as AdministrationRoyaltySalesChannelsRouteImport } from './routes/administration/royaltySalesChannels'
import { Route as AdministrationTagsRouteImport } from './routes/administration/tags'
import { Route as AssetsIndexRouteImport } from './routes/assets/index'
import { Route as AssetsIdRouteImport } from './routes/assets/$id'
import { Route as BundleMainRouteImport } from './routes/bundle/_main'
import { Route as BundleListRouteImport } from './routes/bundle/list'
import { Route as ConceptConceptIdRouteImport } from './routes/concept/$conceptId'
import { Route as ContactContactIdRouteImport } from './routes/contact/$contactId'
import { Route as ContactsIndexRouteImport } from './routes/contacts/index'
import { Route as ContactsListsRouteImport } from './routes/contacts/lists'
import { Route as ImportsCreateretailerordersRouteImport } from './routes/imports/createretailerorders'
import { Route as ImportsImportpricesRouteImport } from './routes/imports/importprices'
import { Route as ImportsImportstockchangesRouteImport } from './routes/imports/importstockchanges'
import { Route as ImportsImporttransactionRouteImport } from './routes/imports/importtransaction'
import { Route as IntegrationsWebhooksRouteImport } from './routes/integrations/_webhooks'
import { Route as IntegrationsDocumentationRouteImport } from './routes/integrations/documentation'
import { Route as MetadataMetaDataTypeIdRouteImport } from './routes/metadata/$metaDataTypeId'
import { Route as RoyaltyAgreementsRouteImport } from './routes/royalty/agreements'
import { Route as RoyaltyBackgroundjobsRouteImport } from './routes/royalty/backgroundjobs'
import { Route as RoyaltyErrorlistRouteImport } from './routes/royalty/errorlist'
import { Route as RoyaltyPaymentinformationRouteImport } from './routes/royalty/paymentinformation'
import { Route as RoyaltyReportsRouteImport } from './routes/royalty/reports'
import { Route as RoyaltyStatementsRouteImport } from './routes/royalty/statements'
import { Route as UserUserIdRouteImport } from './routes/user/$userId'
import { Route as WorkWorkIdRouteImport } from './routes/work/$workId'
import { Route as WorkWorksRouteImport } from './routes/work/works'
import { Route as EditionsearchWorkEditionsRouteImport } from './routes/_editionsearch/work.editions'
import { Route as EditionsearchWorkSalessheetRouteImport } from './routes/_editionsearch/work.salessheet'
import { Route as WorksearchWorkLaunchbriefRouteImport } from './routes/_worksearch/work.launchbrief'
import { Route as AdministrationClientsIndexRouteImport } from './routes/administration/clients/index'
import { Route as AdministrationClientsIdRouteImport } from './routes/administration/clients/$id'
import { Route as AdministrationImportsCreateretailerordersRouteImport } from './routes/administration/imports/createretailerorders'
import { Route as AdministrationImportsImportpricesRouteImport } from './routes/administration/imports/importprices'
import { Route as AdministrationImportsImportstockchangesRouteImport } from './routes/administration/imports/importstockchanges'
import { Route as AdministrationImportsImporttransactionRouteImport } from './routes/administration/imports/importtransaction'
import { Route as AdministrationIntegrationsWebhooksRouteImport } from './routes/administration/integrations/_webhooks'
import { Route as AdministrationIntegrationsDocumentationRouteImport } from './routes/administration/integrations/documentation'
import { Route as AdministrationUsersIndexRouteImport } from './routes/administration/users/index'
import { Route as AdministrationUsersIdRouteImport } from './routes/administration/users/$id'
import { Route as AssetsIdIndexRouteImport } from './routes/assets/$id/index'
import { Route as AssetsIdConnectionsRouteImport } from './routes/assets/$id/connections'
import { Route as AssetsIdGeneralRouteImport } from './routes/assets/$id/general'
import { Route as AssetsIdReplaceRouteImport } from './routes/assets/$id/replace'
import { Route as BookWorkIdIndexRouteImport } from './routes/book/$workId.index'
import { Route as BundleMainCreateRouteImport } from './routes/bundle/_main/create'
import { Route as ConceptConceptIdIndexRouteImport } from './routes/concept/$conceptId/index'
import { Route as ConceptConceptIdApprovalRouteImport } from './routes/concept/$conceptId/approval'
import { Route as ConceptConceptIdBaseInfoRouteImport } from './routes/concept/$conceptId/baseInfo'
import { Route as ConceptConceptIdCalculationsRouteImport } from './routes/concept/$conceptId/calculations'
import { Route as ConceptConceptIdCategorizationRouteImport } from './routes/concept/$conceptId/categorization'
import { Route as ConceptConceptIdCostRouteImport } from './routes/concept/$conceptId/cost'
import { Route as ConceptConceptIdDetailedInfoRouteImport } from './routes/concept/$conceptId/detailedInfo'
import { Route as ConceptConceptIdGeneralRouteImport } from './routes/concept/$conceptId/general'
import { Route as ConceptConceptIdMembersRouteImport } from './routes/concept/$conceptId/members'
import { Route as ConceptConceptIdNotesRouteImport } from './routes/concept/$conceptId/notes'
import { Route as ConceptConceptIdPreCalculationRouteImport } from './routes/concept/$conceptId/pre-calculation'
import { Route as ConceptConceptIdProfitabilityRouteImport } from './routes/concept/$conceptId/profitability'
import { Route as ContactContactIdIndexRouteImport } from './routes/contact/$contactId/index'
import { Route as ContactContactIdAddressesRouteImport } from './routes/contact/$contactId/addresses'
import { Route as ContactContactIdAgreementsRouteImport } from './routes/contact/$contactId/agreements'
import { Route as ContactContactIdAssetsRouteImport } from './routes/contact/$contactId/assets'
import { Route as ContactContactIdCompanycontactsRouteImport } from './routes/contact/$contactId/companycontacts'
import { Route as ContactContactIdConceptsRouteImport } from './routes/contact/$contactId/concepts'
import { Route as ContactContactIdDetailsRouteImport } from './routes/contact/$contactId/details'
import { Route as ContactContactIdLinksRouteImport } from './routes/contact/$contactId/links'
import { Route as ContactContactIdListsRouteImport } from './routes/contact/$contactId/lists'
import { Route as ContactContactIdNotesRouteImport } from './routes/contact/$contactId/notes'
import { Route as ContactContactIdProductionsRouteImport } from './routes/contact/$contactId/productions'
import { Route as ContactContactIdRetailerRouteImport } from './routes/contact/$contactId/retailer'
import { Route as ContactContactIdRoyaltyRouteImport } from './routes/contact/$contactId/royalty'
import { Route as ContactContactIdTextsRouteImport } from './routes/contact/$contactId/texts'
import { Route as ContactContactIdWorksRouteImport } from './routes/contact/$contactId/works'
import { Route as ContactsListIdRouteImport } from './routes/contacts/list.$id'
import { Route as RoyaltyErrorlistAgreementsRouteImport } from './routes/royalty/errorlist/agreements'
import { Route as RoyaltyErrorlistContactsRouteImport } from './routes/royalty/errorlist/contacts'
import { Route as RoyaltyErrorlistTermsRouteImport } from './routes/royalty/errorlist/terms'
import { Route as RoyaltyErrorlistTransactionsRouteImport } from './routes/royalty/errorlist/transactions'
import { Route as RoyaltyPaymentinformationHistoryRouteImport } from './routes/royalty/paymentinformation/history'
import { Route as RoyaltyPaymentinformationUpcomingRouteImport } from './routes/royalty/paymentinformation/upcoming'
import { Route as RoyaltyReportsAdvancesRouteImport } from './routes/royalty/reports/advances'
import { Route as RoyaltyReportsAgreementsRouteImport } from './routes/royalty/reports/agreements'
import { Route as RoyaltyReportsSettlementsRouteImport } from './routes/royalty/reports/settlements'
import { Route as RoyaltyReportsTermsRouteImport } from './routes/royalty/reports/terms'
import { Route as RoyaltyReportsUpcomingSettlementsRouteImport } from './routes/royalty/reports/upcoming-settlements'
import { Route as RoyaltyAgreementIdRouteImport } from './routes/royalty_/agreement/$id'
import { Route as SeriesListIndexRouteImport } from './routes/series/list/index'
import { Route as SeriesListSerieIdRouteImport } from './routes/series/list/$serieId'
import { Route as UserUserIdIndexRouteImport } from './routes/user/$userId/index'
import { Route as UserUserIdAccessRouteImport } from './routes/user/$userId/access'
import { Route as UserUserIdClaimsRouteImport } from './routes/user/$userId/claims'
import { Route as UserUserIdContactsRouteImport } from './routes/user/$userId/contacts'
import { Route as UserUserIdGeneralRouteImport } from './routes/user/$userId/general'
import { Route as WorkWorkIdIndexRouteImport } from './routes/work/$workId/index'
import { Route as WorkWorkIdAssetsRouteImport } from './routes/work/$workId/assets'
import { Route as WorkWorkIdCalculationRouteImport } from './routes/work/$workId/calculation'
import { Route as WorkWorkIdCategorizationRouteImport } from './routes/work/$workId/categorization'
import { Route as WorkWorkIdContractsRouteImport } from './routes/work/$workId/contracts'
import { Route as WorkWorkIdCorrectionsRouteImport } from './routes/work/$workId/corrections'
import { Route as WorkWorkIdCostsRouteImport } from './routes/work/$workId/costs'
import { Route as WorkWorkIdLaunchBriefRouteImport } from './routes/work/$workId/launch-brief'
import { Route as WorkWorkIdMiscRouteImport } from './routes/work/$workId/misc'
import { Route as WorkWorkIdProductionsRouteImport } from './routes/work/$workId/productions'
import { Route as WorkWorkIdProfitabilityRouteImport } from './routes/work/$workId/profitability'
import { Route as WorkWorkIdReviewQuotesRouteImport } from './routes/work/$workId/review-quotes'
import { Route as WorkWorkIdRightsRouteImport } from './routes/work/$workId/rights'
import { Route as WorkWorkIdRoyaltyRouteImport } from './routes/work/$workId/royalty'
import { Route as WorkWorkIdTeamRouteImport } from './routes/work/$workId/team'
import { Route as WorkActivitiesIndexRouteImport } from './routes/work/activities/index'
import { Route as WorkActivitiesActivityIdRouteImport } from './routes/work/activities/$activityId'
import { Route as AdministrationUsersIdIndexRouteImport } from './routes/administration/users/$id/index'
import { Route as AdministrationUsersIdAccessRouteImport } from './routes/administration/users/$id/access'
import { Route as AdministrationUsersIdGeneralRouteImport } from './routes/administration/users/$id/general'
import { Route as BookWorkIdEditionEditionIdRouteImport } from './routes/book/$workId.edition.$editionId'
import { Route as BundleMainEditProductIdRouteImport } from './routes/bundle/_main/edit.$productId'
import { Route as BundleMainErpProductIdRouteImport } from './routes/bundle/_main/erp.$productId'
import { Route as ConceptConceptIdProductionsIndexRouteImport } from './routes/concept/$conceptId/productions/index'
import { Route as ConceptConceptIdProductionsProductionIdRouteImport } from './routes/concept/$conceptId/productions/$productionId'
import { Route as IntegrationsWebhooksWebhookIndexRouteImport } from './routes/integrations/_webhooks/webhook.index'
import { Route as IntegrationsWebhooksWebhookEventsRouteImport } from './routes/integrations/_webhooks/webhook.events'
import { Route as IntegrationsWebhooksWebhookSubscribersRouteImport } from './routes/integrations/_webhooks/webhook.subscribers'
import { Route as IntegrationsWebhooksWebhookTokenConfigurationsRouteImport } from './routes/integrations/_webhooks/webhook.token-configurations'
import { Route as RoyaltyAgreementIdGeneralRouteImport } from './routes/royalty_/agreement/$id/general'
import { Route as RoyaltyAgreementIdTransactionsRouteImport } from './routes/royalty_/agreement/$id/transactions'
import { Route as WorkWorkIdLaunchPlanIndexRouteImport } from './routes/work/$workId/launch-plan/index'
import { Route as WorkWorkIdEditionEditionIdRouteImport } from './routes/work/$workId_/edition/$editionId'
import { Route as AdministrationIntegrationsWebhooksWebhookIndexRouteImport } from './routes/administration/integrations/_webhooks/webhook.index'
import { Route as AdministrationIntegrationsWebhooksWebhookEventsRouteImport } from './routes/administration/integrations/_webhooks/webhook.events'
import { Route as AdministrationIntegrationsWebhooksWebhookSubscribersRouteImport } from './routes/administration/integrations/_webhooks/webhook.subscribers'
import { Route as AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRouteImport } from './routes/administration/integrations/_webhooks/webhook.token-configurations'
import { Route as RoyaltyAgreementIdSettlementsIndexRouteImport } from './routes/royalty_/agreement/$id/settlements/index'
import { Route as RoyaltyAgreementIdTermsIndexRouteImport } from './routes/royalty_/agreement/$id/terms/index'
import { Route as WorkWorkIdLaunchPlanActivityActivityIdRouteImport } from './routes/work/$workId/launch-plan/activity.$activityId'
import { Route as WorkWorkIdEditionEditionIdIndexRouteImport } from './routes/work/$workId_/edition/$editionId/index'
import { Route as WorkWorkIdEditionEditionIdAssetsRouteImport } from './routes/work/$workId_/edition/$editionId/assets'
import { Route as WorkWorkIdEditionEditionIdCommentsRouteImport } from './routes/work/$workId_/edition/$editionId/comments'
import { Route as WorkWorkIdEditionEditionIdContentCategorizationRouteImport } from './routes/work/$workId_/edition/$editionId/content-categorization'
import { Route as WorkWorkIdEditionEditionIdContentEditorialRouteImport } from './routes/work/$workId_/edition/$editionId/content-editorial'
import { Route as WorkWorkIdEditionEditionIdContentEducationRouteImport } from './routes/work/$workId_/edition/$editionId/content-education'
import { Route as WorkWorkIdEditionEditionIdContentLinksRouteImport } from './routes/work/$workId_/edition/$editionId/content-links'
import { Route as WorkWorkIdEditionEditionIdContentPressSalesRouteImport } from './routes/work/$workId_/edition/$editionId/content-press-sales'
import { Route as WorkWorkIdEditionEditionIdContentTitlePortraitRouteImport } from './routes/work/$workId_/edition/$editionId/content-title-portrait'
import { Route as WorkWorkIdEditionEditionIdCopyproductionRouteImport } from './routes/work/$workId_/edition/$editionId/copyproduction'
import { Route as WorkWorkIdEditionEditionIdCopytechnicalproductionRouteImport } from './routes/work/$workId_/edition/$editionId/copytechnicalproduction'
import { Route as WorkWorkIdEditionEditionIdDistributionRouteImport } from './routes/work/$workId_/edition/$editionId/distribution'
import { Route as WorkWorkIdEditionEditionIdDistributionLogsRouteImport } from './routes/work/$workId_/edition/$editionId/distribution-logs'
import { Route as WorkWorkIdEditionEditionIdErpRouteImport } from './routes/work/$workId_/edition/$editionId/erp'
import { Route as WorkWorkIdEditionEditionIdGeneralBookclubsRouteImport } from './routes/work/$workId_/edition/$editionId/general-bookclubs'
import { Route as WorkWorkIdEditionEditionIdGeneralCostsRouteImport } from './routes/work/$workId_/edition/$editionId/general-costs'
import { Route as WorkWorkIdEditionEditionIdGeneralMiscRouteImport } from './routes/work/$workId_/edition/$editionId/general-misc'
import { Route as WorkWorkIdEditionEditionIdGeneralPriceAndCostRouteImport } from './routes/work/$workId_/edition/$editionId/general-price-and-cost'
import { Route as WorkWorkIdEditionEditionIdGeneralPrintrunRouteImport } from './routes/work/$workId_/edition/$editionId/general-printrun'
import { Route as WorkWorkIdEditionEditionIdGeneralRightsRouteImport } from './routes/work/$workId_/edition/$editionId/general-rights'
import { Route as WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRouteImport } from './routes/work/$workId_/edition/$editionId/general-royalty-levels'
import { Route as WorkWorkIdEditionEditionIdGeneralSalesRouteImport } from './routes/work/$workId_/edition/$editionId/general-sales'
import { Route as WorkWorkIdEditionEditionIdGeneralScheduleRouteImport } from './routes/work/$workId_/edition/$editionId/general-schedule'
import { Route as WorkWorkIdEditionEditionIdLayoutRouteImport } from './routes/work/$workId_/edition/$editionId/layout'
import { Route as WorkWorkIdEditionEditionIdLayoutBindingRouteImport } from './routes/work/$workId_/edition/$editionId/layout-binding'
import { Route as WorkWorkIdEditionEditionIdLayoutCompositionRouteImport } from './routes/work/$workId_/edition/$editionId/layout-composition'
import { Route as WorkWorkIdEditionEditionIdLayoutCoverRouteImport } from './routes/work/$workId_/edition/$editionId/layout-cover'
import { Route as WorkWorkIdEditionEditionIdLayoutInsideRouteImport } from './routes/work/$workId_/edition/$editionId/layout-inside'
import { Route as WorkWorkIdEditionEditionIdLayoutMeasurementsRouteImport } from './routes/work/$workId_/edition/$editionId/layout-measurements'
import { Route as WorkWorkIdEditionEditionIdLayoutTechnicalproductionRouteImport } from './routes/work/$workId_/edition/$editionId/layout-technicalproduction'
import { Route as WorkWorkIdEditionEditionIdPrintOrdersRouteImport } from './routes/work/$workId_/edition/$editionId/print-orders'
import { Route as WorkWorkIdEditionEditionIdPrintchangesRouteImport } from './routes/work/$workId_/edition/$editionId/printchanges'
import { Route as WorkWorkIdEditionEditionIdProfitabilityRouteImport } from './routes/work/$workId_/edition/$editionId/profitability'
import { Route as WorkWorkIdEditionEditionIdPublishRouteImport } from './routes/work/$workId_/edition/$editionId/publish'
import { Route as WorkWorkIdEditionEditionIdTeamRouteImport } from './routes/work/$workId_/edition/$editionId/team'
import { Route as WorkWorkIdEditionEditionIdTechnicaldescriptionRouteImport } from './routes/work/$workId_/edition/$editionId/technicaldescription'
import { Route as WorkWorkIdEditionEditionIdUnpublishRouteImport } from './routes/work/$workId_/edition/$editionId/unpublish'
import { Route as RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRouteImport } from './routes/royalty_/agreement/$id/terms/$ruleSetId.version.$ruleId'
import { Route as RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRouteImport } from './routes/royalty_/agreement/$id/settlements/$settlementId.receiver.$contactId.$status'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EditionsearchRoute = EditionsearchRouteImport.update({
  id: '/_editionsearch',
  getParentRoute: () => rootRouteImport,
} as any)
const WorksearchRoute = WorksearchRouteImport.update({
  id: '/_worksearch',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ConceptsRoute = ConceptsRouteImport.update({
  id: '/concepts',
  path: '/concepts',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsRoute = ImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const MetadataRoute = MetadataRouteImport.update({
  id: '/metadata',
  path: '/metadata',
  getParentRoute: () => rootRouteImport,
} as any)
const MydownloadsRoute = MydownloadsRouteImport.update({
  id: '/mydownloads',
  path: '/mydownloads',
  getParentRoute: () => rootRouteImport,
} as any)
const MyworkRoute = MyworkRouteImport.update({
  id: '/mywork',
  path: '/mywork',
  getParentRoute: () => rootRouteImport,
} as any)
const RoyaltyRoute = RoyaltyRouteImport.update({
  id: '/royalty',
  path: '/royalty',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const WorksearchWorksRoute = WorksearchWorksRouteImport.update({
  id: '/works',
  path: '/works',
  getParentRoute: () => WorksearchRoute,
} as any)
const AdminCosttypesRoute = AdminCosttypesRouteImport.update({
  id: '/costtypes',
  path: '/costtypes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEanseriesRoute = AdminEanseriesRouteImport.update({
  id: '/eanseries',
  path: '/eanseries',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailtemplatesRoute = AdminEmailtemplatesRouteImport.update({
  id: '/emailtemplates',
  path: '/emailtemplates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPrinterpricesRoute = AdminPrinterpricesRouteImport.update({
  id: '/printerprices',
  path: '/printerprices',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductionPlansRoute = AdminProductionPlansRouteImport.update({
  id: '/production-plans',
  path: '/production-plans',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoyaltyPriceRulesRoute = AdminRoyaltyPriceRulesRouteImport.update({
  id: '/royaltyPriceRules',
  path: '/royaltyPriceRules',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRoyaltySalesChannelsRoute =
  AdminRoyaltySalesChannelsRouteImport.update({
    id: '/royaltySalesChannels',
    path: '/royaltySalesChannels',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminTagsRoute = AdminTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AdminRoute,
} as any)
const AdministrationIndexRoute = AdministrationIndexRouteImport.update({
  id: '/administration/',
  path: '/administration/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationCosttypesRoute = AdministrationCosttypesRouteImport.update({
  id: '/administration/costtypes',
  path: '/administration/costtypes',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationEanseriesRoute = AdministrationEanseriesRouteImport.update({
  id: '/administration/eanseries',
  path: '/administration/eanseries',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationEmailtemplatesRoute =
  AdministrationEmailtemplatesRouteImport.update({
    id: '/administration/emailtemplates',
    path: '/administration/emailtemplates',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationIntegrationsRoute =
  AdministrationIntegrationsRouteImport.update({
    id: '/administration/integrations',
    path: '/administration/integrations',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationMetadataRoute = AdministrationMetadataRouteImport.update({
  id: '/administration/metadata',
  path: '/administration/metadata',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationPrinterpricesRoute =
  AdministrationPrinterpricesRouteImport.update({
    id: '/administration/printerprices',
    path: '/administration/printerprices',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationProductionPlansRoute =
  AdministrationProductionPlansRouteImport.update({
    id: '/administration/production-plans',
    path: '/administration/production-plans',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationRoyaltyPriceRulesRoute =
  AdministrationRoyaltyPriceRulesRouteImport.update({
    id: '/administration/royaltyPriceRules',
    path: '/administration/royaltyPriceRules',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationRoyaltySalesChannelsRoute =
  AdministrationRoyaltySalesChannelsRouteImport.update({
    id: '/administration/royaltySalesChannels',
    path: '/administration/royaltySalesChannels',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationTagsRoute = AdministrationTagsRouteImport.update({
  id: '/administration/tags',
  path: '/administration/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsIndexRoute = AssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsIdRoute = AssetsIdRouteImport.update({
  id: '/assets/$id',
  path: '/assets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BundleMainRoute = BundleMainRouteImport.update({
  id: '/bundle/_main',
  path: '/bundle',
  getParentRoute: () => rootRouteImport,
} as any)
const BundleListRoute = BundleListRouteImport.update({
  id: '/bundle/list',
  path: '/bundle/list',
  getParentRoute: () => rootRouteImport,
} as any)
const ConceptConceptIdRoute = ConceptConceptIdRouteImport.update({
  id: '/concept/$conceptId',
  path: '/concept/$conceptId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactContactIdRoute = ContactContactIdRouteImport.update({
  id: '/contact/$contactId',
  path: '/contact/$contactId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsIndexRoute = ContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsListsRoute = ContactsListsRouteImport.update({
  id: '/contacts/lists',
  path: '/contacts/lists',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsCreateretailerordersRoute =
  ImportsCreateretailerordersRouteImport.update({
    id: '/createretailerorders',
    path: '/createretailerorders',
    getParentRoute: () => ImportsRoute,
  } as any)
const ImportsImportpricesRoute = ImportsImportpricesRouteImport.update({
  id: '/importprices',
  path: '/importprices',
  getParentRoute: () => ImportsRoute,
} as any)
const ImportsImportstockchangesRoute =
  ImportsImportstockchangesRouteImport.update({
    id: '/importstockchanges',
    path: '/importstockchanges',
    getParentRoute: () => ImportsRoute,
  } as any)
const ImportsImporttransactionRoute =
  ImportsImporttransactionRouteImport.update({
    id: '/importtransaction',
    path: '/importtransaction',
    getParentRoute: () => ImportsRoute,
  } as any)
const IntegrationsWebhooksRoute = IntegrationsWebhooksRouteImport.update({
  id: '/_webhooks',
  getParentRoute: () => IntegrationsRoute,
} as any)
const IntegrationsDocumentationRoute =
  IntegrationsDocumentationRouteImport.update({
    id: '/documentation',
    path: '/documentation',
    getParentRoute: () => IntegrationsRoute,
  } as any)
const MetadataMetaDataTypeIdRoute = MetadataMetaDataTypeIdRouteImport.update({
  id: '/$metaDataTypeId',
  path: '/$metaDataTypeId',
  getParentRoute: () => MetadataRoute,
} as any)
const RoyaltyAgreementsRoute = RoyaltyAgreementsRouteImport.update({
  id: '/agreements',
  path: '/agreements',
  getParentRoute: () => RoyaltyRoute,
} as any)
const RoyaltyBackgroundjobsRoute = RoyaltyBackgroundjobsRouteImport.update({
  id: '/backgroundjobs',
  path: '/backgroundjobs',
  getParentRoute: () => RoyaltyRoute,
} as any)
const RoyaltyErrorlistRoute = RoyaltyErrorlistRouteImport.update({
  id: '/errorlist',
  path: '/errorlist',
  getParentRoute: () => RoyaltyRoute,
} as any)
const RoyaltyPaymentinformationRoute =
  RoyaltyPaymentinformationRouteImport.update({
    id: '/paymentinformation',
    path: '/paymentinformation',
    getParentRoute: () => RoyaltyRoute,
  } as any)
const RoyaltyReportsRoute = RoyaltyReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => RoyaltyRoute,
} as any)
const RoyaltyStatementsRoute = RoyaltyStatementsRouteImport.update({
  id: '/statements',
  path: '/statements',
  getParentRoute: () => RoyaltyRoute,
} as any)
const UserUserIdRoute = UserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkWorkIdRoute = WorkWorkIdRouteImport.update({
  id: '/work/$workId',
  path: '/work/$workId',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkWorksRoute = WorkWorksRouteImport.update({
  id: '/work/works',
  path: '/work/works',
  getParentRoute: () => rootRouteImport,
} as any)
const EditionsearchWorkEditionsRoute =
  EditionsearchWorkEditionsRouteImport.update({
    id: '/work/editions',
    path: '/work/editions',
    getParentRoute: () => EditionsearchRoute,
  } as any)
const EditionsearchWorkSalessheetRoute =
  EditionsearchWorkSalessheetRouteImport.update({
    id: '/work/salessheet',
    path: '/work/salessheet',
    getParentRoute: () => EditionsearchRoute,
  } as any)
const WorksearchWorkLaunchbriefRoute =
  WorksearchWorkLaunchbriefRouteImport.update({
    id: '/work/launchbrief',
    path: '/work/launchbrief',
    getParentRoute: () => WorksearchRoute,
  } as any)
const AdministrationClientsIndexRoute =
  AdministrationClientsIndexRouteImport.update({
    id: '/administration/clients/',
    path: '/administration/clients/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationClientsIdRoute = AdministrationClientsIdRouteImport.update({
  id: '/administration/clients/$id',
  path: '/administration/clients/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationImportsCreateretailerordersRoute =
  AdministrationImportsCreateretailerordersRouteImport.update({
    id: '/administration/imports/createretailerorders',
    path: '/administration/imports/createretailerorders',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationImportsImportpricesRoute =
  AdministrationImportsImportpricesRouteImport.update({
    id: '/administration/imports/importprices',
    path: '/administration/imports/importprices',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationImportsImportstockchangesRoute =
  AdministrationImportsImportstockchangesRouteImport.update({
    id: '/administration/imports/importstockchanges',
    path: '/administration/imports/importstockchanges',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationImportsImporttransactionRoute =
  AdministrationImportsImporttransactionRouteImport.update({
    id: '/administration/imports/importtransaction',
    path: '/administration/imports/importtransaction',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationIntegrationsWebhooksRoute =
  AdministrationIntegrationsWebhooksRouteImport.update({
    id: '/_webhooks',
    getParentRoute: () => AdministrationIntegrationsRoute,
  } as any)
const AdministrationIntegrationsDocumentationRoute =
  AdministrationIntegrationsDocumentationRouteImport.update({
    id: '/documentation',
    path: '/documentation',
    getParentRoute: () => AdministrationIntegrationsRoute,
  } as any)
const AdministrationUsersIndexRoute =
  AdministrationUsersIndexRouteImport.update({
    id: '/administration/users/',
    path: '/administration/users/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationUsersIdRoute = AdministrationUsersIdRouteImport.update({
  id: '/administration/users/$id',
  path: '/administration/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsIdIndexRoute = AssetsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AssetsIdRoute,
} as any)
const AssetsIdConnectionsRoute = AssetsIdConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AssetsIdRoute,
} as any)
const AssetsIdGeneralRoute = AssetsIdGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => AssetsIdRoute,
} as any)
const AssetsIdReplaceRoute = AssetsIdReplaceRouteImport.update({
  id: '/replace',
  path: '/replace',
  getParentRoute: () => AssetsIdRoute,
} as any)
const BookWorkIdIndexRoute = BookWorkIdIndexRouteImport.update({
  id: '/book/$workId/',
  path: '/book/$workId/',
  getParentRoute: () => rootRouteImport,
} as any)
const BundleMainCreateRoute = BundleMainCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => BundleMainRoute,
} as any)
const ConceptConceptIdIndexRoute = ConceptConceptIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConceptConceptIdRoute,
} as any)
const ConceptConceptIdApprovalRoute =
  ConceptConceptIdApprovalRouteImport.update({
    id: '/approval',
    path: '/approval',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ConceptConceptIdBaseInfoRoute =
  ConceptConceptIdBaseInfoRouteImport.update({
    id: '/baseInfo',
    path: '/baseInfo',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ConceptConceptIdCalculationsRoute =
  ConceptConceptIdCalculationsRouteImport.update({
    id: '/calculations',
    path: '/calculations',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ConceptConceptIdCategorizationRoute =
  ConceptConceptIdCategorizationRouteImport.update({
    id: '/categorization',
    path: '/categorization',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ConceptConceptIdCostRoute = ConceptConceptIdCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => ConceptConceptIdRoute,
} as any)
const ConceptConceptIdDetailedInfoRoute =
  ConceptConceptIdDetailedInfoRouteImport.update({
    id: '/detailedInfo',
    path: '/detailedInfo',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ConceptConceptIdGeneralRoute = ConceptConceptIdGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => ConceptConceptIdRoute,
} as any)
const ConceptConceptIdMembersRoute = ConceptConceptIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => ConceptConceptIdRoute,
} as any)
const ConceptConceptIdNotesRoute = ConceptConceptIdNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => ConceptConceptIdRoute,
} as any)
const ConceptConceptIdPreCalculationRoute =
  ConceptConceptIdPreCalculationRouteImport.update({
    id: '/pre-calculation',
    path: '/pre-calculation',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ConceptConceptIdProfitabilityRoute =
  ConceptConceptIdProfitabilityRouteImport.update({
    id: '/profitability',
    path: '/profitability',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ContactContactIdIndexRoute = ContactContactIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdAddressesRoute =
  ContactContactIdAddressesRouteImport.update({
    id: '/addresses',
    path: '/addresses',
    getParentRoute: () => ContactContactIdRoute,
  } as any)
const ContactContactIdAgreementsRoute =
  ContactContactIdAgreementsRouteImport.update({
    id: '/agreements',
    path: '/agreements',
    getParentRoute: () => ContactContactIdRoute,
  } as any)
const ContactContactIdAssetsRoute = ContactContactIdAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdCompanycontactsRoute =
  ContactContactIdCompanycontactsRouteImport.update({
    id: '/companycontacts',
    path: '/companycontacts',
    getParentRoute: () => ContactContactIdRoute,
  } as any)
const ContactContactIdConceptsRoute =
  ContactContactIdConceptsRouteImport.update({
    id: '/concepts',
    path: '/concepts',
    getParentRoute: () => ContactContactIdRoute,
  } as any)
const ContactContactIdDetailsRoute = ContactContactIdDetailsRouteImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdLinksRoute = ContactContactIdLinksRouteImport.update({
  id: '/links',
  path: '/links',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdListsRoute = ContactContactIdListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdNotesRoute = ContactContactIdNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdProductionsRoute =
  ContactContactIdProductionsRouteImport.update({
    id: '/productions',
    path: '/productions',
    getParentRoute: () => ContactContactIdRoute,
  } as any)
const ContactContactIdRetailerRoute =
  ContactContactIdRetailerRouteImport.update({
    id: '/retailer',
    path: '/retailer',
    getParentRoute: () => ContactContactIdRoute,
  } as any)
const ContactContactIdRoyaltyRoute = ContactContactIdRoyaltyRouteImport.update({
  id: '/royalty',
  path: '/royalty',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdTextsRoute = ContactContactIdTextsRouteImport.update({
  id: '/texts',
  path: '/texts',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactContactIdWorksRoute = ContactContactIdWorksRouteImport.update({
  id: '/works',
  path: '/works',
  getParentRoute: () => ContactContactIdRoute,
} as any)
const ContactsListIdRoute = ContactsListIdRouteImport.update({
  id: '/contacts/list/$id',
  path: '/contacts/list/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RoyaltyErrorlistAgreementsRoute =
  RoyaltyErrorlistAgreementsRouteImport.update({
    id: '/agreements',
    path: '/agreements',
    getParentRoute: () => RoyaltyErrorlistRoute,
  } as any)
const RoyaltyErrorlistContactsRoute =
  RoyaltyErrorlistContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => RoyaltyErrorlistRoute,
  } as any)
const RoyaltyErrorlistTermsRoute = RoyaltyErrorlistTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => RoyaltyErrorlistRoute,
} as any)
const RoyaltyErrorlistTransactionsRoute =
  RoyaltyErrorlistTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => RoyaltyErrorlistRoute,
  } as any)
const RoyaltyPaymentinformationHistoryRoute =
  RoyaltyPaymentinformationHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => RoyaltyPaymentinformationRoute,
  } as any)
const RoyaltyPaymentinformationUpcomingRoute =
  RoyaltyPaymentinformationUpcomingRouteImport.update({
    id: '/upcoming',
    path: '/upcoming',
    getParentRoute: () => RoyaltyPaymentinformationRoute,
  } as any)
const RoyaltyReportsAdvancesRoute = RoyaltyReportsAdvancesRouteImport.update({
  id: '/advances',
  path: '/advances',
  getParentRoute: () => RoyaltyReportsRoute,
} as any)
const RoyaltyReportsAgreementsRoute =
  RoyaltyReportsAgreementsRouteImport.update({
    id: '/agreements',
    path: '/agreements',
    getParentRoute: () => RoyaltyReportsRoute,
  } as any)
const RoyaltyReportsSettlementsRoute =
  RoyaltyReportsSettlementsRouteImport.update({
    id: '/settlements',
    path: '/settlements',
    getParentRoute: () => RoyaltyReportsRoute,
  } as any)
const RoyaltyReportsTermsRoute = RoyaltyReportsTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => RoyaltyReportsRoute,
} as any)
const RoyaltyReportsUpcomingSettlementsRoute =
  RoyaltyReportsUpcomingSettlementsRouteImport.update({
    id: '/upcoming-settlements',
    path: '/upcoming-settlements',
    getParentRoute: () => RoyaltyReportsRoute,
  } as any)
const RoyaltyAgreementIdRoute = RoyaltyAgreementIdRouteImport.update({
  id: '/royalty_/agreement/$id',
  path: '/royalty/agreement/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SeriesListIndexRoute = SeriesListIndexRouteImport.update({
  id: '/series/list/',
  path: '/series/list/',
  getParentRoute: () => rootRouteImport,
} as any)
const SeriesListSerieIdRoute = SeriesListSerieIdRouteImport.update({
  id: '/series/list/$serieId',
  path: '/series/list/$serieId',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdIndexRoute = UserUserIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserUserIdRoute,
} as any)
const UserUserIdAccessRoute = UserUserIdAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => UserUserIdRoute,
} as any)
const UserUserIdClaimsRoute = UserUserIdClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => UserUserIdRoute,
} as any)
const UserUserIdContactsRoute = UserUserIdContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => UserUserIdRoute,
} as any)
const UserUserIdGeneralRoute = UserUserIdGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => UserUserIdRoute,
} as any)
const WorkWorkIdIndexRoute = WorkWorkIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdAssetsRoute = WorkWorkIdAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdCalculationRoute = WorkWorkIdCalculationRouteImport.update({
  id: '/calculation',
  path: '/calculation',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdCategorizationRoute =
  WorkWorkIdCategorizationRouteImport.update({
    id: '/categorization',
    path: '/categorization',
    getParentRoute: () => WorkWorkIdRoute,
  } as any)
const WorkWorkIdContractsRoute = WorkWorkIdContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdCorrectionsRoute = WorkWorkIdCorrectionsRouteImport.update({
  id: '/corrections',
  path: '/corrections',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdCostsRoute = WorkWorkIdCostsRouteImport.update({
  id: '/costs',
  path: '/costs',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdLaunchBriefRoute = WorkWorkIdLaunchBriefRouteImport.update({
  id: '/launch-brief',
  path: '/launch-brief',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdMiscRoute = WorkWorkIdMiscRouteImport.update({
  id: '/misc',
  path: '/misc',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdProductionsRoute = WorkWorkIdProductionsRouteImport.update({
  id: '/productions',
  path: '/productions',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdProfitabilityRoute = WorkWorkIdProfitabilityRouteImport.update({
  id: '/profitability',
  path: '/profitability',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdReviewQuotesRoute = WorkWorkIdReviewQuotesRouteImport.update({
  id: '/review-quotes',
  path: '/review-quotes',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdRightsRoute = WorkWorkIdRightsRouteImport.update({
  id: '/rights',
  path: '/rights',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdRoyaltyRoute = WorkWorkIdRoyaltyRouteImport.update({
  id: '/royalty',
  path: '/royalty',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkWorkIdTeamRoute = WorkWorkIdTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => WorkWorkIdRoute,
} as any)
const WorkActivitiesIndexRoute = WorkActivitiesIndexRouteImport.update({
  id: '/work/activities/',
  path: '/work/activities/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkActivitiesActivityIdRoute =
  WorkActivitiesActivityIdRouteImport.update({
    id: '/work/activities/$activityId',
    path: '/work/activities/$activityId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationUsersIdIndexRoute =
  AdministrationUsersIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdministrationUsersIdRoute,
  } as any)
const AdministrationUsersIdAccessRoute =
  AdministrationUsersIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AdministrationUsersIdRoute,
  } as any)
const AdministrationUsersIdGeneralRoute =
  AdministrationUsersIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AdministrationUsersIdRoute,
  } as any)
const BookWorkIdEditionEditionIdRoute =
  BookWorkIdEditionEditionIdRouteImport.update({
    id: '/book/$workId/edition/$editionId',
    path: '/book/$workId/edition/$editionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BundleMainEditProductIdRoute = BundleMainEditProductIdRouteImport.update({
  id: '/edit/$productId',
  path: '/edit/$productId',
  getParentRoute: () => BundleMainRoute,
} as any)
const BundleMainErpProductIdRoute = BundleMainErpProductIdRouteImport.update({
  id: '/erp/$productId',
  path: '/erp/$productId',
  getParentRoute: () => BundleMainRoute,
} as any)
const ConceptConceptIdProductionsIndexRoute =
  ConceptConceptIdProductionsIndexRouteImport.update({
    id: '/productions/',
    path: '/productions/',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const ConceptConceptIdProductionsProductionIdRoute =
  ConceptConceptIdProductionsProductionIdRouteImport.update({
    id: '/productions/$productionId',
    path: '/productions/$productionId',
    getParentRoute: () => ConceptConceptIdRoute,
  } as any)
const IntegrationsWebhooksWebhookIndexRoute =
  IntegrationsWebhooksWebhookIndexRouteImport.update({
    id: '/webhook/',
    path: '/webhook/',
    getParentRoute: () => IntegrationsWebhooksRoute,
  } as any)
const IntegrationsWebhooksWebhookEventsRoute =
  IntegrationsWebhooksWebhookEventsRouteImport.update({
    id: '/webhook/events',
    path: '/webhook/events',
    getParentRoute: () => IntegrationsWebhooksRoute,
  } as any)
const IntegrationsWebhooksWebhookSubscribersRoute =
  IntegrationsWebhooksWebhookSubscribersRouteImport.update({
    id: '/webhook/subscribers',
    path: '/webhook/subscribers',
    getParentRoute: () => IntegrationsWebhooksRoute,
  } as any)
const IntegrationsWebhooksWebhookTokenConfigurationsRoute =
  IntegrationsWebhooksWebhookTokenConfigurationsRouteImport.update({
    id: '/webhook/token-configurations',
    path: '/webhook/token-configurations',
    getParentRoute: () => IntegrationsWebhooksRoute,
  } as any)
const RoyaltyAgreementIdGeneralRoute =
  RoyaltyAgreementIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => RoyaltyAgreementIdRoute,
  } as any)
const RoyaltyAgreementIdTransactionsRoute =
  RoyaltyAgreementIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => RoyaltyAgreementIdRoute,
  } as any)
const WorkWorkIdLaunchPlanIndexRoute =
  WorkWorkIdLaunchPlanIndexRouteImport.update({
    id: '/launch-plan/',
    path: '/launch-plan/',
    getParentRoute: () => WorkWorkIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdRoute =
  WorkWorkIdEditionEditionIdRouteImport.update({
    id: '/work/$workId_/edition/$editionId',
    path: '/work/$workId/edition/$editionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdministrationIntegrationsWebhooksWebhookIndexRoute =
  AdministrationIntegrationsWebhooksWebhookIndexRouteImport.update({
    id: '/webhook/',
    path: '/webhook/',
    getParentRoute: () => AdministrationIntegrationsWebhooksRoute,
  } as any)
const AdministrationIntegrationsWebhooksWebhookEventsRoute =
  AdministrationIntegrationsWebhooksWebhookEventsRouteImport.update({
    id: '/webhook/events',
    path: '/webhook/events',
    getParentRoute: () => AdministrationIntegrationsWebhooksRoute,
  } as any)
const AdministrationIntegrationsWebhooksWebhookSubscribersRoute =
  AdministrationIntegrationsWebhooksWebhookSubscribersRouteImport.update({
    id: '/webhook/subscribers',
    path: '/webhook/subscribers',
    getParentRoute: () => AdministrationIntegrationsWebhooksRoute,
  } as any)
const AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute =
  AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRouteImport.update(
    {
      id: '/webhook/token-configurations',
      path: '/webhook/token-configurations',
      getParentRoute: () => AdministrationIntegrationsWebhooksRoute,
    } as any,
  )
const RoyaltyAgreementIdSettlementsIndexRoute =
  RoyaltyAgreementIdSettlementsIndexRouteImport.update({
    id: '/settlements/',
    path: '/settlements/',
    getParentRoute: () => RoyaltyAgreementIdRoute,
  } as any)
const RoyaltyAgreementIdTermsIndexRoute =
  RoyaltyAgreementIdTermsIndexRouteImport.update({
    id: '/terms/',
    path: '/terms/',
    getParentRoute: () => RoyaltyAgreementIdRoute,
  } as any)
const WorkWorkIdLaunchPlanActivityActivityIdRoute =
  WorkWorkIdLaunchPlanActivityActivityIdRouteImport.update({
    id: '/launch-plan/activity/$activityId',
    path: '/launch-plan/activity/$activityId',
    getParentRoute: () => WorkWorkIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdIndexRoute =
  WorkWorkIdEditionEditionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdAssetsRoute =
  WorkWorkIdEditionEditionIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdCommentsRoute =
  WorkWorkIdEditionEditionIdCommentsRouteImport.update({
    id: '/comments',
    path: '/comments',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdContentCategorizationRoute =
  WorkWorkIdEditionEditionIdContentCategorizationRouteImport.update({
    id: '/content-categorization',
    path: '/content-categorization',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdContentEditorialRoute =
  WorkWorkIdEditionEditionIdContentEditorialRouteImport.update({
    id: '/content-editorial',
    path: '/content-editorial',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdContentEducationRoute =
  WorkWorkIdEditionEditionIdContentEducationRouteImport.update({
    id: '/content-education',
    path: '/content-education',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdContentLinksRoute =
  WorkWorkIdEditionEditionIdContentLinksRouteImport.update({
    id: '/content-links',
    path: '/content-links',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdContentPressSalesRoute =
  WorkWorkIdEditionEditionIdContentPressSalesRouteImport.update({
    id: '/content-press-sales',
    path: '/content-press-sales',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdContentTitlePortraitRoute =
  WorkWorkIdEditionEditionIdContentTitlePortraitRouteImport.update({
    id: '/content-title-portrait',
    path: '/content-title-portrait',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdCopyproductionRoute =
  WorkWorkIdEditionEditionIdCopyproductionRouteImport.update({
    id: '/copyproduction',
    path: '/copyproduction',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdCopytechnicalproductionRoute =
  WorkWorkIdEditionEditionIdCopytechnicalproductionRouteImport.update({
    id: '/copytechnicalproduction',
    path: '/copytechnicalproduction',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdDistributionRoute =
  WorkWorkIdEditionEditionIdDistributionRouteImport.update({
    id: '/distribution',
    path: '/distribution',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdDistributionLogsRoute =
  WorkWorkIdEditionEditionIdDistributionLogsRouteImport.update({
    id: '/distribution-logs',
    path: '/distribution-logs',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdErpRoute =
  WorkWorkIdEditionEditionIdErpRouteImport.update({
    id: '/erp',
    path: '/erp',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralBookclubsRoute =
  WorkWorkIdEditionEditionIdGeneralBookclubsRouteImport.update({
    id: '/general-bookclubs',
    path: '/general-bookclubs',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralCostsRoute =
  WorkWorkIdEditionEditionIdGeneralCostsRouteImport.update({
    id: '/general-costs',
    path: '/general-costs',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralMiscRoute =
  WorkWorkIdEditionEditionIdGeneralMiscRouteImport.update({
    id: '/general-misc',
    path: '/general-misc',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute =
  WorkWorkIdEditionEditionIdGeneralPriceAndCostRouteImport.update({
    id: '/general-price-and-cost',
    path: '/general-price-and-cost',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralPrintrunRoute =
  WorkWorkIdEditionEditionIdGeneralPrintrunRouteImport.update({
    id: '/general-printrun',
    path: '/general-printrun',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralRightsRoute =
  WorkWorkIdEditionEditionIdGeneralRightsRouteImport.update({
    id: '/general-rights',
    path: '/general-rights',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute =
  WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRouteImport.update({
    id: '/general-royalty-levels',
    path: '/general-royalty-levels',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralSalesRoute =
  WorkWorkIdEditionEditionIdGeneralSalesRouteImport.update({
    id: '/general-sales',
    path: '/general-sales',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdGeneralScheduleRoute =
  WorkWorkIdEditionEditionIdGeneralScheduleRouteImport.update({
    id: '/general-schedule',
    path: '/general-schedule',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdLayoutRoute =
  WorkWorkIdEditionEditionIdLayoutRouteImport.update({
    id: '/layout',
    path: '/layout',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdLayoutBindingRoute =
  WorkWorkIdEditionEditionIdLayoutBindingRouteImport.update({
    id: '/layout-binding',
    path: '/layout-binding',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdLayoutCompositionRoute =
  WorkWorkIdEditionEditionIdLayoutCompositionRouteImport.update({
    id: '/layout-composition',
    path: '/layout-composition',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdLayoutCoverRoute =
  WorkWorkIdEditionEditionIdLayoutCoverRouteImport.update({
    id: '/layout-cover',
    path: '/layout-cover',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdLayoutInsideRoute =
  WorkWorkIdEditionEditionIdLayoutInsideRouteImport.update({
    id: '/layout-inside',
    path: '/layout-inside',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdLayoutMeasurementsRoute =
  WorkWorkIdEditionEditionIdLayoutMeasurementsRouteImport.update({
    id: '/layout-measurements',
    path: '/layout-measurements',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute =
  WorkWorkIdEditionEditionIdLayoutTechnicalproductionRouteImport.update({
    id: '/layout-technicalproduction',
    path: '/layout-technicalproduction',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdPrintOrdersRoute =
  WorkWorkIdEditionEditionIdPrintOrdersRouteImport.update({
    id: '/print-orders',
    path: '/print-orders',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdPrintchangesRoute =
  WorkWorkIdEditionEditionIdPrintchangesRouteImport.update({
    id: '/printchanges',
    path: '/printchanges',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdProfitabilityRoute =
  WorkWorkIdEditionEditionIdProfitabilityRouteImport.update({
    id: '/profitability',
    path: '/profitability',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdPublishRoute =
  WorkWorkIdEditionEditionIdPublishRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdTeamRoute =
  WorkWorkIdEditionEditionIdTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdTechnicaldescriptionRoute =
  WorkWorkIdEditionEditionIdTechnicaldescriptionRouteImport.update({
    id: '/technicaldescription',
    path: '/technicaldescription',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const WorkWorkIdEditionEditionIdUnpublishRoute =
  WorkWorkIdEditionEditionIdUnpublishRouteImport.update({
    id: '/unpublish',
    path: '/unpublish',
    getParentRoute: () => WorkWorkIdEditionEditionIdRoute,
  } as any)
const RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute =
  RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRouteImport.update({
    id: '/terms/$ruleSetId/version/$ruleId',
    path: '/terms/$ruleSetId/version/$ruleId',
    getParentRoute: () => RoyaltyAgreementIdRoute,
  } as any)
const RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute =
  RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRouteImport.update(
    {
      id: '/settlements/$settlementId/receiver/$contactId/$status',
      path: '/settlements/$settlementId/receiver/$contactId/$status',
      getParentRoute: () => RoyaltyAgreementIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/concepts': typeof ConceptsRoute
  '/imports': typeof ImportsRouteWithChildren
  '/integrations': typeof IntegrationsRouteWithChildren
  '/metadata': typeof MetadataRouteWithChildren
  '/mydownloads': typeof MydownloadsRoute
  '/mywork': typeof MyworkRoute
  '/royalty': typeof RoyaltyRouteWithChildren
  '/users': typeof UsersRoute
  '/works': typeof WorksearchWorksRoute
  '/admin/costtypes': typeof AdminCosttypesRoute
  '/admin/eanseries': typeof AdminEanseriesRoute
  '/admin/emailtemplates': typeof AdminEmailtemplatesRoute
  '/admin/printerprices': typeof AdminPrinterpricesRoute
  '/admin/production-plans': typeof AdminProductionPlansRoute
  '/admin/royaltyPriceRules': typeof AdminRoyaltyPriceRulesRoute
  '/admin/royaltySalesChannels': typeof AdminRoyaltySalesChannelsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/administration/costtypes': typeof AdministrationCosttypesRoute
  '/administration/eanseries': typeof AdministrationEanseriesRoute
  '/administration/emailtemplates': typeof AdministrationEmailtemplatesRoute
  '/administration/integrations': typeof AdministrationIntegrationsRouteWithChildren
  '/administration/metadata': typeof AdministrationMetadataRoute
  '/administration/printerprices': typeof AdministrationPrinterpricesRoute
  '/administration/production-plans': typeof AdministrationProductionPlansRoute
  '/administration/royaltyPriceRules': typeof AdministrationRoyaltyPriceRulesRoute
  '/administration/royaltySalesChannels': typeof AdministrationRoyaltySalesChannelsRoute
  '/administration/tags': typeof AdministrationTagsRoute
  '/assets/$id': typeof AssetsIdRouteWithChildren
  '/bundle': typeof BundleMainRouteWithChildren
  '/bundle/list': typeof BundleListRoute
  '/concept/$conceptId': typeof ConceptConceptIdRouteWithChildren
  '/contact/$contactId': typeof ContactContactIdRouteWithChildren
  '/contacts/lists': typeof ContactsListsRoute
  '/imports/createretailerorders': typeof ImportsCreateretailerordersRoute
  '/imports/importprices': typeof ImportsImportpricesRoute
  '/imports/importstockchanges': typeof ImportsImportstockchangesRoute
  '/imports/importtransaction': typeof ImportsImporttransactionRoute
  '/integrations/documentation': typeof IntegrationsDocumentationRoute
  '/metadata/$metaDataTypeId': typeof MetadataMetaDataTypeIdRoute
  '/royalty/agreements': typeof RoyaltyAgreementsRoute
  '/royalty/backgroundjobs': typeof RoyaltyBackgroundjobsRoute
  '/royalty/errorlist': typeof RoyaltyErrorlistRouteWithChildren
  '/royalty/paymentinformation': typeof RoyaltyPaymentinformationRouteWithChildren
  '/royalty/reports': typeof RoyaltyReportsRouteWithChildren
  '/royalty/statements': typeof RoyaltyStatementsRoute
  '/user/$userId': typeof UserUserIdRouteWithChildren
  '/work/$workId': typeof WorkWorkIdRouteWithChildren
  '/work/works': typeof WorkWorksRoute
  '/administration/': typeof AdministrationIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/work/editions': typeof EditionsearchWorkEditionsRoute
  '/work/salessheet': typeof EditionsearchWorkSalessheetRoute
  '/work/launchbrief': typeof WorksearchWorkLaunchbriefRoute
  '/administration/clients/$id': typeof AdministrationClientsIdRoute
  '/administration/imports/createretailerorders': typeof AdministrationImportsCreateretailerordersRoute
  '/administration/imports/importprices': typeof AdministrationImportsImportpricesRoute
  '/administration/imports/importstockchanges': typeof AdministrationImportsImportstockchangesRoute
  '/administration/imports/importtransaction': typeof AdministrationImportsImporttransactionRoute
  '/administration/integrations/documentation': typeof AdministrationIntegrationsDocumentationRoute
  '/administration/users/$id': typeof AdministrationUsersIdRouteWithChildren
  '/assets/$id/connections': typeof AssetsIdConnectionsRoute
  '/assets/$id/general': typeof AssetsIdGeneralRoute
  '/assets/$id/replace': typeof AssetsIdReplaceRoute
  '/bundle/create': typeof BundleMainCreateRoute
  '/concept/$conceptId/approval': typeof ConceptConceptIdApprovalRoute
  '/concept/$conceptId/baseInfo': typeof ConceptConceptIdBaseInfoRoute
  '/concept/$conceptId/calculations': typeof ConceptConceptIdCalculationsRoute
  '/concept/$conceptId/categorization': typeof ConceptConceptIdCategorizationRoute
  '/concept/$conceptId/cost': typeof ConceptConceptIdCostRoute
  '/concept/$conceptId/detailedInfo': typeof ConceptConceptIdDetailedInfoRoute
  '/concept/$conceptId/general': typeof ConceptConceptIdGeneralRoute
  '/concept/$conceptId/members': typeof ConceptConceptIdMembersRoute
  '/concept/$conceptId/notes': typeof ConceptConceptIdNotesRoute
  '/concept/$conceptId/pre-calculation': typeof ConceptConceptIdPreCalculationRoute
  '/concept/$conceptId/profitability': typeof ConceptConceptIdProfitabilityRoute
  '/contact/$contactId/addresses': typeof ContactContactIdAddressesRoute
  '/contact/$contactId/agreements': typeof ContactContactIdAgreementsRoute
  '/contact/$contactId/assets': typeof ContactContactIdAssetsRoute
  '/contact/$contactId/companycontacts': typeof ContactContactIdCompanycontactsRoute
  '/contact/$contactId/concepts': typeof ContactContactIdConceptsRoute
  '/contact/$contactId/details': typeof ContactContactIdDetailsRoute
  '/contact/$contactId/links': typeof ContactContactIdLinksRoute
  '/contact/$contactId/lists': typeof ContactContactIdListsRoute
  '/contact/$contactId/notes': typeof ContactContactIdNotesRoute
  '/contact/$contactId/productions': typeof ContactContactIdProductionsRoute
  '/contact/$contactId/retailer': typeof ContactContactIdRetailerRoute
  '/contact/$contactId/royalty': typeof ContactContactIdRoyaltyRoute
  '/contact/$contactId/texts': typeof ContactContactIdTextsRoute
  '/contact/$contactId/works': typeof ContactContactIdWorksRoute
  '/contacts/list/$id': typeof ContactsListIdRoute
  '/royalty/errorlist/agreements': typeof RoyaltyErrorlistAgreementsRoute
  '/royalty/errorlist/contacts': typeof RoyaltyErrorlistContactsRoute
  '/royalty/errorlist/terms': typeof RoyaltyErrorlistTermsRoute
  '/royalty/errorlist/transactions': typeof RoyaltyErrorlistTransactionsRoute
  '/royalty/paymentinformation/history': typeof RoyaltyPaymentinformationHistoryRoute
  '/royalty/paymentinformation/upcoming': typeof RoyaltyPaymentinformationUpcomingRoute
  '/royalty/reports/advances': typeof RoyaltyReportsAdvancesRoute
  '/royalty/reports/agreements': typeof RoyaltyReportsAgreementsRoute
  '/royalty/reports/settlements': typeof RoyaltyReportsSettlementsRoute
  '/royalty/reports/terms': typeof RoyaltyReportsTermsRoute
  '/royalty/reports/upcoming-settlements': typeof RoyaltyReportsUpcomingSettlementsRoute
  '/royalty/agreement/$id': typeof RoyaltyAgreementIdRouteWithChildren
  '/series/list/$serieId': typeof SeriesListSerieIdRoute
  '/user/$userId/access': typeof UserUserIdAccessRoute
  '/user/$userId/claims': typeof UserUserIdClaimsRoute
  '/user/$userId/contacts': typeof UserUserIdContactsRoute
  '/user/$userId/general': typeof UserUserIdGeneralRoute
  '/work/$workId/assets': typeof WorkWorkIdAssetsRoute
  '/work/$workId/calculation': typeof WorkWorkIdCalculationRoute
  '/work/$workId/categorization': typeof WorkWorkIdCategorizationRoute
  '/work/$workId/contracts': typeof WorkWorkIdContractsRoute
  '/work/$workId/corrections': typeof WorkWorkIdCorrectionsRoute
  '/work/$workId/costs': typeof WorkWorkIdCostsRoute
  '/work/$workId/launch-brief': typeof WorkWorkIdLaunchBriefRoute
  '/work/$workId/misc': typeof WorkWorkIdMiscRoute
  '/work/$workId/productions': typeof WorkWorkIdProductionsRoute
  '/work/$workId/profitability': typeof WorkWorkIdProfitabilityRoute
  '/work/$workId/review-quotes': typeof WorkWorkIdReviewQuotesRoute
  '/work/$workId/rights': typeof WorkWorkIdRightsRoute
  '/work/$workId/royalty': typeof WorkWorkIdRoyaltyRoute
  '/work/$workId/team': typeof WorkWorkIdTeamRoute
  '/work/activities/$activityId': typeof WorkActivitiesActivityIdRoute
  '/administration/clients/': typeof AdministrationClientsIndexRoute
  '/administration/users/': typeof AdministrationUsersIndexRoute
  '/assets/$id/': typeof AssetsIdIndexRoute
  '/book/$workId/': typeof BookWorkIdIndexRoute
  '/concept/$conceptId/': typeof ConceptConceptIdIndexRoute
  '/contact/$contactId/': typeof ContactContactIdIndexRoute
  '/series/list/': typeof SeriesListIndexRoute
  '/user/$userId/': typeof UserUserIdIndexRoute
  '/work/$workId/': typeof WorkWorkIdIndexRoute
  '/work/activities/': typeof WorkActivitiesIndexRoute
  '/administration/users/$id/access': typeof AdministrationUsersIdAccessRoute
  '/administration/users/$id/general': typeof AdministrationUsersIdGeneralRoute
  '/book/$workId/edition/$editionId': typeof BookWorkIdEditionEditionIdRoute
  '/bundle/edit/$productId': typeof BundleMainEditProductIdRoute
  '/bundle/erp/$productId': typeof BundleMainErpProductIdRoute
  '/concept/$conceptId/productions/$productionId': typeof ConceptConceptIdProductionsProductionIdRoute
  '/integrations/webhook/events': typeof IntegrationsWebhooksWebhookEventsRoute
  '/integrations/webhook/subscribers': typeof IntegrationsWebhooksWebhookSubscribersRoute
  '/integrations/webhook/token-configurations': typeof IntegrationsWebhooksWebhookTokenConfigurationsRoute
  '/royalty/agreement/$id/general': typeof RoyaltyAgreementIdGeneralRoute
  '/royalty/agreement/$id/transactions': typeof RoyaltyAgreementIdTransactionsRoute
  '/work/$workId/edition/$editionId': typeof WorkWorkIdEditionEditionIdRouteWithChildren
  '/administration/users/$id/': typeof AdministrationUsersIdIndexRoute
  '/concept/$conceptId/productions/': typeof ConceptConceptIdProductionsIndexRoute
  '/integrations/webhook/': typeof IntegrationsWebhooksWebhookIndexRoute
  '/work/$workId/launch-plan/': typeof WorkWorkIdLaunchPlanIndexRoute
  '/administration/integrations/webhook/events': typeof AdministrationIntegrationsWebhooksWebhookEventsRoute
  '/administration/integrations/webhook/subscribers': typeof AdministrationIntegrationsWebhooksWebhookSubscribersRoute
  '/administration/integrations/webhook/token-configurations': typeof AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute
  '/work/$workId/launch-plan/activity/$activityId': typeof WorkWorkIdLaunchPlanActivityActivityIdRoute
  '/work/$workId/edition/$editionId/assets': typeof WorkWorkIdEditionEditionIdAssetsRoute
  '/work/$workId/edition/$editionId/comments': typeof WorkWorkIdEditionEditionIdCommentsRoute
  '/work/$workId/edition/$editionId/content-categorization': typeof WorkWorkIdEditionEditionIdContentCategorizationRoute
  '/work/$workId/edition/$editionId/content-editorial': typeof WorkWorkIdEditionEditionIdContentEditorialRoute
  '/work/$workId/edition/$editionId/content-education': typeof WorkWorkIdEditionEditionIdContentEducationRoute
  '/work/$workId/edition/$editionId/content-links': typeof WorkWorkIdEditionEditionIdContentLinksRoute
  '/work/$workId/edition/$editionId/content-press-sales': typeof WorkWorkIdEditionEditionIdContentPressSalesRoute
  '/work/$workId/edition/$editionId/content-title-portrait': typeof WorkWorkIdEditionEditionIdContentTitlePortraitRoute
  '/work/$workId/edition/$editionId/copyproduction': typeof WorkWorkIdEditionEditionIdCopyproductionRoute
  '/work/$workId/edition/$editionId/copytechnicalproduction': typeof WorkWorkIdEditionEditionIdCopytechnicalproductionRoute
  '/work/$workId/edition/$editionId/distribution': typeof WorkWorkIdEditionEditionIdDistributionRoute
  '/work/$workId/edition/$editionId/distribution-logs': typeof WorkWorkIdEditionEditionIdDistributionLogsRoute
  '/work/$workId/edition/$editionId/erp': typeof WorkWorkIdEditionEditionIdErpRoute
  '/work/$workId/edition/$editionId/general-bookclubs': typeof WorkWorkIdEditionEditionIdGeneralBookclubsRoute
  '/work/$workId/edition/$editionId/general-costs': typeof WorkWorkIdEditionEditionIdGeneralCostsRoute
  '/work/$workId/edition/$editionId/general-misc': typeof WorkWorkIdEditionEditionIdGeneralMiscRoute
  '/work/$workId/edition/$editionId/general-price-and-cost': typeof WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute
  '/work/$workId/edition/$editionId/general-printrun': typeof WorkWorkIdEditionEditionIdGeneralPrintrunRoute
  '/work/$workId/edition/$editionId/general-rights': typeof WorkWorkIdEditionEditionIdGeneralRightsRoute
  '/work/$workId/edition/$editionId/general-royalty-levels': typeof WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute
  '/work/$workId/edition/$editionId/general-sales': typeof WorkWorkIdEditionEditionIdGeneralSalesRoute
  '/work/$workId/edition/$editionId/general-schedule': typeof WorkWorkIdEditionEditionIdGeneralScheduleRoute
  '/work/$workId/edition/$editionId/layout': typeof WorkWorkIdEditionEditionIdLayoutRoute
  '/work/$workId/edition/$editionId/layout-binding': typeof WorkWorkIdEditionEditionIdLayoutBindingRoute
  '/work/$workId/edition/$editionId/layout-composition': typeof WorkWorkIdEditionEditionIdLayoutCompositionRoute
  '/work/$workId/edition/$editionId/layout-cover': typeof WorkWorkIdEditionEditionIdLayoutCoverRoute
  '/work/$workId/edition/$editionId/layout-inside': typeof WorkWorkIdEditionEditionIdLayoutInsideRoute
  '/work/$workId/edition/$editionId/layout-measurements': typeof WorkWorkIdEditionEditionIdLayoutMeasurementsRoute
  '/work/$workId/edition/$editionId/layout-technicalproduction': typeof WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute
  '/work/$workId/edition/$editionId/print-orders': typeof WorkWorkIdEditionEditionIdPrintOrdersRoute
  '/work/$workId/edition/$editionId/printchanges': typeof WorkWorkIdEditionEditionIdPrintchangesRoute
  '/work/$workId/edition/$editionId/profitability': typeof WorkWorkIdEditionEditionIdProfitabilityRoute
  '/work/$workId/edition/$editionId/publish': typeof WorkWorkIdEditionEditionIdPublishRoute
  '/work/$workId/edition/$editionId/team': typeof WorkWorkIdEditionEditionIdTeamRoute
  '/work/$workId/edition/$editionId/technicaldescription': typeof WorkWorkIdEditionEditionIdTechnicaldescriptionRoute
  '/work/$workId/edition/$editionId/unpublish': typeof WorkWorkIdEditionEditionIdUnpublishRoute
  '/administration/integrations/webhook/': typeof AdministrationIntegrationsWebhooksWebhookIndexRoute
  '/royalty/agreement/$id/settlements/': typeof RoyaltyAgreementIdSettlementsIndexRoute
  '/royalty/agreement/$id/terms/': typeof RoyaltyAgreementIdTermsIndexRoute
  '/work/$workId/edition/$editionId/': typeof WorkWorkIdEditionEditionIdIndexRoute
  '/royalty/agreement/$id/terms/$ruleSetId/version/$ruleId': typeof RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute
  '/royalty/agreement/$id/settlements/$settlementId/receiver/$contactId/$status': typeof RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/concepts': typeof ConceptsRoute
  '/imports': typeof ImportsRouteWithChildren
  '/integrations': typeof IntegrationsRouteWithChildren
  '/metadata': typeof MetadataRouteWithChildren
  '/mydownloads': typeof MydownloadsRoute
  '/mywork': typeof MyworkRoute
  '/royalty': typeof RoyaltyRouteWithChildren
  '/users': typeof UsersRoute
  '/works': typeof WorksearchWorksRoute
  '/admin/costtypes': typeof AdminCosttypesRoute
  '/admin/eanseries': typeof AdminEanseriesRoute
  '/admin/emailtemplates': typeof AdminEmailtemplatesRoute
  '/admin/printerprices': typeof AdminPrinterpricesRoute
  '/admin/production-plans': typeof AdminProductionPlansRoute
  '/admin/royaltyPriceRules': typeof AdminRoyaltyPriceRulesRoute
  '/admin/royaltySalesChannels': typeof AdminRoyaltySalesChannelsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/administration/costtypes': typeof AdministrationCosttypesRoute
  '/administration/eanseries': typeof AdministrationEanseriesRoute
  '/administration/emailtemplates': typeof AdministrationEmailtemplatesRoute
  '/administration/integrations': typeof AdministrationIntegrationsRouteWithChildren
  '/administration/metadata': typeof AdministrationMetadataRoute
  '/administration/printerprices': typeof AdministrationPrinterpricesRoute
  '/administration/production-plans': typeof AdministrationProductionPlansRoute
  '/administration/royaltyPriceRules': typeof AdministrationRoyaltyPriceRulesRoute
  '/administration/royaltySalesChannels': typeof AdministrationRoyaltySalesChannelsRoute
  '/administration/tags': typeof AdministrationTagsRoute
  '/bundle': typeof BundleMainRouteWithChildren
  '/bundle/list': typeof BundleListRoute
  '/contacts/lists': typeof ContactsListsRoute
  '/imports/createretailerorders': typeof ImportsCreateretailerordersRoute
  '/imports/importprices': typeof ImportsImportpricesRoute
  '/imports/importstockchanges': typeof ImportsImportstockchangesRoute
  '/imports/importtransaction': typeof ImportsImporttransactionRoute
  '/integrations/documentation': typeof IntegrationsDocumentationRoute
  '/metadata/$metaDataTypeId': typeof MetadataMetaDataTypeIdRoute
  '/royalty/agreements': typeof RoyaltyAgreementsRoute
  '/royalty/backgroundjobs': typeof RoyaltyBackgroundjobsRoute
  '/royalty/errorlist': typeof RoyaltyErrorlistRouteWithChildren
  '/royalty/paymentinformation': typeof RoyaltyPaymentinformationRouteWithChildren
  '/royalty/reports': typeof RoyaltyReportsRouteWithChildren
  '/royalty/statements': typeof RoyaltyStatementsRoute
  '/work/works': typeof WorkWorksRoute
  '/administration': typeof AdministrationIndexRoute
  '/assets': typeof AssetsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/work/editions': typeof EditionsearchWorkEditionsRoute
  '/work/salessheet': typeof EditionsearchWorkSalessheetRoute
  '/work/launchbrief': typeof WorksearchWorkLaunchbriefRoute
  '/administration/clients/$id': typeof AdministrationClientsIdRoute
  '/administration/imports/createretailerorders': typeof AdministrationImportsCreateretailerordersRoute
  '/administration/imports/importprices': typeof AdministrationImportsImportpricesRoute
  '/administration/imports/importstockchanges': typeof AdministrationImportsImportstockchangesRoute
  '/administration/imports/importtransaction': typeof AdministrationImportsImporttransactionRoute
  '/administration/integrations/documentation': typeof AdministrationIntegrationsDocumentationRoute
  '/assets/$id/connections': typeof AssetsIdConnectionsRoute
  '/assets/$id/general': typeof AssetsIdGeneralRoute
  '/assets/$id/replace': typeof AssetsIdReplaceRoute
  '/bundle/create': typeof BundleMainCreateRoute
  '/concept/$conceptId/approval': typeof ConceptConceptIdApprovalRoute
  '/concept/$conceptId/baseInfo': typeof ConceptConceptIdBaseInfoRoute
  '/concept/$conceptId/calculations': typeof ConceptConceptIdCalculationsRoute
  '/concept/$conceptId/categorization': typeof ConceptConceptIdCategorizationRoute
  '/concept/$conceptId/cost': typeof ConceptConceptIdCostRoute
  '/concept/$conceptId/detailedInfo': typeof ConceptConceptIdDetailedInfoRoute
  '/concept/$conceptId/general': typeof ConceptConceptIdGeneralRoute
  '/concept/$conceptId/members': typeof ConceptConceptIdMembersRoute
  '/concept/$conceptId/notes': typeof ConceptConceptIdNotesRoute
  '/concept/$conceptId/pre-calculation': typeof ConceptConceptIdPreCalculationRoute
  '/concept/$conceptId/profitability': typeof ConceptConceptIdProfitabilityRoute
  '/contact/$contactId/addresses': typeof ContactContactIdAddressesRoute
  '/contact/$contactId/agreements': typeof ContactContactIdAgreementsRoute
  '/contact/$contactId/assets': typeof ContactContactIdAssetsRoute
  '/contact/$contactId/companycontacts': typeof ContactContactIdCompanycontactsRoute
  '/contact/$contactId/concepts': typeof ContactContactIdConceptsRoute
  '/contact/$contactId/details': typeof ContactContactIdDetailsRoute
  '/contact/$contactId/links': typeof ContactContactIdLinksRoute
  '/contact/$contactId/lists': typeof ContactContactIdListsRoute
  '/contact/$contactId/notes': typeof ContactContactIdNotesRoute
  '/contact/$contactId/productions': typeof ContactContactIdProductionsRoute
  '/contact/$contactId/retailer': typeof ContactContactIdRetailerRoute
  '/contact/$contactId/royalty': typeof ContactContactIdRoyaltyRoute
  '/contact/$contactId/texts': typeof ContactContactIdTextsRoute
  '/contact/$contactId/works': typeof ContactContactIdWorksRoute
  '/contacts/list/$id': typeof ContactsListIdRoute
  '/royalty/errorlist/agreements': typeof RoyaltyErrorlistAgreementsRoute
  '/royalty/errorlist/contacts': typeof RoyaltyErrorlistContactsRoute
  '/royalty/errorlist/terms': typeof RoyaltyErrorlistTermsRoute
  '/royalty/errorlist/transactions': typeof RoyaltyErrorlistTransactionsRoute
  '/royalty/paymentinformation/history': typeof RoyaltyPaymentinformationHistoryRoute
  '/royalty/paymentinformation/upcoming': typeof RoyaltyPaymentinformationUpcomingRoute
  '/royalty/reports/advances': typeof RoyaltyReportsAdvancesRoute
  '/royalty/reports/agreements': typeof RoyaltyReportsAgreementsRoute
  '/royalty/reports/settlements': typeof RoyaltyReportsSettlementsRoute
  '/royalty/reports/terms': typeof RoyaltyReportsTermsRoute
  '/royalty/reports/upcoming-settlements': typeof RoyaltyReportsUpcomingSettlementsRoute
  '/royalty/agreement/$id': typeof RoyaltyAgreementIdRouteWithChildren
  '/series/list/$serieId': typeof SeriesListSerieIdRoute
  '/user/$userId/access': typeof UserUserIdAccessRoute
  '/user/$userId/claims': typeof UserUserIdClaimsRoute
  '/user/$userId/contacts': typeof UserUserIdContactsRoute
  '/user/$userId/general': typeof UserUserIdGeneralRoute
  '/work/$workId/assets': typeof WorkWorkIdAssetsRoute
  '/work/$workId/calculation': typeof WorkWorkIdCalculationRoute
  '/work/$workId/categorization': typeof WorkWorkIdCategorizationRoute
  '/work/$workId/contracts': typeof WorkWorkIdContractsRoute
  '/work/$workId/corrections': typeof WorkWorkIdCorrectionsRoute
  '/work/$workId/costs': typeof WorkWorkIdCostsRoute
  '/work/$workId/launch-brief': typeof WorkWorkIdLaunchBriefRoute
  '/work/$workId/misc': typeof WorkWorkIdMiscRoute
  '/work/$workId/productions': typeof WorkWorkIdProductionsRoute
  '/work/$workId/profitability': typeof WorkWorkIdProfitabilityRoute
  '/work/$workId/review-quotes': typeof WorkWorkIdReviewQuotesRoute
  '/work/$workId/rights': typeof WorkWorkIdRightsRoute
  '/work/$workId/royalty': typeof WorkWorkIdRoyaltyRoute
  '/work/$workId/team': typeof WorkWorkIdTeamRoute
  '/work/activities/$activityId': typeof WorkActivitiesActivityIdRoute
  '/administration/clients': typeof AdministrationClientsIndexRoute
  '/administration/users': typeof AdministrationUsersIndexRoute
  '/assets/$id': typeof AssetsIdIndexRoute
  '/book/$workId': typeof BookWorkIdIndexRoute
  '/concept/$conceptId': typeof ConceptConceptIdIndexRoute
  '/contact/$contactId': typeof ContactContactIdIndexRoute
  '/series/list': typeof SeriesListIndexRoute
  '/user/$userId': typeof UserUserIdIndexRoute
  '/work/$workId': typeof WorkWorkIdIndexRoute
  '/work/activities': typeof WorkActivitiesIndexRoute
  '/administration/users/$id/access': typeof AdministrationUsersIdAccessRoute
  '/administration/users/$id/general': typeof AdministrationUsersIdGeneralRoute
  '/book/$workId/edition/$editionId': typeof BookWorkIdEditionEditionIdRoute
  '/bundle/edit/$productId': typeof BundleMainEditProductIdRoute
  '/bundle/erp/$productId': typeof BundleMainErpProductIdRoute
  '/concept/$conceptId/productions/$productionId': typeof ConceptConceptIdProductionsProductionIdRoute
  '/integrations/webhook/events': typeof IntegrationsWebhooksWebhookEventsRoute
  '/integrations/webhook/subscribers': typeof IntegrationsWebhooksWebhookSubscribersRoute
  '/integrations/webhook/token-configurations': typeof IntegrationsWebhooksWebhookTokenConfigurationsRoute
  '/royalty/agreement/$id/general': typeof RoyaltyAgreementIdGeneralRoute
  '/royalty/agreement/$id/transactions': typeof RoyaltyAgreementIdTransactionsRoute
  '/administration/users/$id': typeof AdministrationUsersIdIndexRoute
  '/concept/$conceptId/productions': typeof ConceptConceptIdProductionsIndexRoute
  '/integrations/webhook': typeof IntegrationsWebhooksWebhookIndexRoute
  '/work/$workId/launch-plan': typeof WorkWorkIdLaunchPlanIndexRoute
  '/administration/integrations/webhook/events': typeof AdministrationIntegrationsWebhooksWebhookEventsRoute
  '/administration/integrations/webhook/subscribers': typeof AdministrationIntegrationsWebhooksWebhookSubscribersRoute
  '/administration/integrations/webhook/token-configurations': typeof AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute
  '/work/$workId/launch-plan/activity/$activityId': typeof WorkWorkIdLaunchPlanActivityActivityIdRoute
  '/work/$workId/edition/$editionId/assets': typeof WorkWorkIdEditionEditionIdAssetsRoute
  '/work/$workId/edition/$editionId/comments': typeof WorkWorkIdEditionEditionIdCommentsRoute
  '/work/$workId/edition/$editionId/content-categorization': typeof WorkWorkIdEditionEditionIdContentCategorizationRoute
  '/work/$workId/edition/$editionId/content-editorial': typeof WorkWorkIdEditionEditionIdContentEditorialRoute
  '/work/$workId/edition/$editionId/content-education': typeof WorkWorkIdEditionEditionIdContentEducationRoute
  '/work/$workId/edition/$editionId/content-links': typeof WorkWorkIdEditionEditionIdContentLinksRoute
  '/work/$workId/edition/$editionId/content-press-sales': typeof WorkWorkIdEditionEditionIdContentPressSalesRoute
  '/work/$workId/edition/$editionId/content-title-portrait': typeof WorkWorkIdEditionEditionIdContentTitlePortraitRoute
  '/work/$workId/edition/$editionId/copyproduction': typeof WorkWorkIdEditionEditionIdCopyproductionRoute
  '/work/$workId/edition/$editionId/copytechnicalproduction': typeof WorkWorkIdEditionEditionIdCopytechnicalproductionRoute
  '/work/$workId/edition/$editionId/distribution': typeof WorkWorkIdEditionEditionIdDistributionRoute
  '/work/$workId/edition/$editionId/distribution-logs': typeof WorkWorkIdEditionEditionIdDistributionLogsRoute
  '/work/$workId/edition/$editionId/erp': typeof WorkWorkIdEditionEditionIdErpRoute
  '/work/$workId/edition/$editionId/general-bookclubs': typeof WorkWorkIdEditionEditionIdGeneralBookclubsRoute
  '/work/$workId/edition/$editionId/general-costs': typeof WorkWorkIdEditionEditionIdGeneralCostsRoute
  '/work/$workId/edition/$editionId/general-misc': typeof WorkWorkIdEditionEditionIdGeneralMiscRoute
  '/work/$workId/edition/$editionId/general-price-and-cost': typeof WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute
  '/work/$workId/edition/$editionId/general-printrun': typeof WorkWorkIdEditionEditionIdGeneralPrintrunRoute
  '/work/$workId/edition/$editionId/general-rights': typeof WorkWorkIdEditionEditionIdGeneralRightsRoute
  '/work/$workId/edition/$editionId/general-royalty-levels': typeof WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute
  '/work/$workId/edition/$editionId/general-sales': typeof WorkWorkIdEditionEditionIdGeneralSalesRoute
  '/work/$workId/edition/$editionId/general-schedule': typeof WorkWorkIdEditionEditionIdGeneralScheduleRoute
  '/work/$workId/edition/$editionId/layout': typeof WorkWorkIdEditionEditionIdLayoutRoute
  '/work/$workId/edition/$editionId/layout-binding': typeof WorkWorkIdEditionEditionIdLayoutBindingRoute
  '/work/$workId/edition/$editionId/layout-composition': typeof WorkWorkIdEditionEditionIdLayoutCompositionRoute
  '/work/$workId/edition/$editionId/layout-cover': typeof WorkWorkIdEditionEditionIdLayoutCoverRoute
  '/work/$workId/edition/$editionId/layout-inside': typeof WorkWorkIdEditionEditionIdLayoutInsideRoute
  '/work/$workId/edition/$editionId/layout-measurements': typeof WorkWorkIdEditionEditionIdLayoutMeasurementsRoute
  '/work/$workId/edition/$editionId/layout-technicalproduction': typeof WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute
  '/work/$workId/edition/$editionId/print-orders': typeof WorkWorkIdEditionEditionIdPrintOrdersRoute
  '/work/$workId/edition/$editionId/printchanges': typeof WorkWorkIdEditionEditionIdPrintchangesRoute
  '/work/$workId/edition/$editionId/profitability': typeof WorkWorkIdEditionEditionIdProfitabilityRoute
  '/work/$workId/edition/$editionId/publish': typeof WorkWorkIdEditionEditionIdPublishRoute
  '/work/$workId/edition/$editionId/team': typeof WorkWorkIdEditionEditionIdTeamRoute
  '/work/$workId/edition/$editionId/technicaldescription': typeof WorkWorkIdEditionEditionIdTechnicaldescriptionRoute
  '/work/$workId/edition/$editionId/unpublish': typeof WorkWorkIdEditionEditionIdUnpublishRoute
  '/administration/integrations/webhook': typeof AdministrationIntegrationsWebhooksWebhookIndexRoute
  '/royalty/agreement/$id/settlements': typeof RoyaltyAgreementIdSettlementsIndexRoute
  '/royalty/agreement/$id/terms': typeof RoyaltyAgreementIdTermsIndexRoute
  '/work/$workId/edition/$editionId': typeof WorkWorkIdEditionEditionIdIndexRoute
  '/royalty/agreement/$id/terms/$ruleSetId/version/$ruleId': typeof RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute
  '/royalty/agreement/$id/settlements/$settlementId/receiver/$contactId/$status': typeof RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_editionsearch': typeof EditionsearchRouteWithChildren
  '/_worksearch': typeof WorksearchRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/concepts': typeof ConceptsRoute
  '/imports': typeof ImportsRouteWithChildren
  '/integrations': typeof IntegrationsRouteWithChildren
  '/metadata': typeof MetadataRouteWithChildren
  '/mydownloads': typeof MydownloadsRoute
  '/mywork': typeof MyworkRoute
  '/royalty': typeof RoyaltyRouteWithChildren
  '/users': typeof UsersRoute
  '/_worksearch/works': typeof WorksearchWorksRoute
  '/admin/costtypes': typeof AdminCosttypesRoute
  '/admin/eanseries': typeof AdminEanseriesRoute
  '/admin/emailtemplates': typeof AdminEmailtemplatesRoute
  '/admin/printerprices': typeof AdminPrinterpricesRoute
  '/admin/production-plans': typeof AdminProductionPlansRoute
  '/admin/royaltyPriceRules': typeof AdminRoyaltyPriceRulesRoute
  '/admin/royaltySalesChannels': typeof AdminRoyaltySalesChannelsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/administration/costtypes': typeof AdministrationCosttypesRoute
  '/administration/eanseries': typeof AdministrationEanseriesRoute
  '/administration/emailtemplates': typeof AdministrationEmailtemplatesRoute
  '/administration/integrations': typeof AdministrationIntegrationsRouteWithChildren
  '/administration/metadata': typeof AdministrationMetadataRoute
  '/administration/printerprices': typeof AdministrationPrinterpricesRoute
  '/administration/production-plans': typeof AdministrationProductionPlansRoute
  '/administration/royaltyPriceRules': typeof AdministrationRoyaltyPriceRulesRoute
  '/administration/royaltySalesChannels': typeof AdministrationRoyaltySalesChannelsRoute
  '/administration/tags': typeof AdministrationTagsRoute
  '/assets/$id': typeof AssetsIdRouteWithChildren
  '/bundle/_main': typeof BundleMainRouteWithChildren
  '/bundle/list': typeof BundleListRoute
  '/concept/$conceptId': typeof ConceptConceptIdRouteWithChildren
  '/contact/$contactId': typeof ContactContactIdRouteWithChildren
  '/contacts/lists': typeof ContactsListsRoute
  '/imports/createretailerorders': typeof ImportsCreateretailerordersRoute
  '/imports/importprices': typeof ImportsImportpricesRoute
  '/imports/importstockchanges': typeof ImportsImportstockchangesRoute
  '/imports/importtransaction': typeof ImportsImporttransactionRoute
  '/integrations/_webhooks': typeof IntegrationsWebhooksRouteWithChildren
  '/integrations/documentation': typeof IntegrationsDocumentationRoute
  '/metadata/$metaDataTypeId': typeof MetadataMetaDataTypeIdRoute
  '/royalty/agreements': typeof RoyaltyAgreementsRoute
  '/royalty/backgroundjobs': typeof RoyaltyBackgroundjobsRoute
  '/royalty/errorlist': typeof RoyaltyErrorlistRouteWithChildren
  '/royalty/paymentinformation': typeof RoyaltyPaymentinformationRouteWithChildren
  '/royalty/reports': typeof RoyaltyReportsRouteWithChildren
  '/royalty/statements': typeof RoyaltyStatementsRoute
  '/user/$userId': typeof UserUserIdRouteWithChildren
  '/work/$workId': typeof WorkWorkIdRouteWithChildren
  '/work/works': typeof WorkWorksRoute
  '/administration/': typeof AdministrationIndexRoute
  '/assets/': typeof AssetsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/_editionsearch/work/editions': typeof EditionsearchWorkEditionsRoute
  '/_editionsearch/work/salessheet': typeof EditionsearchWorkSalessheetRoute
  '/_worksearch/work/launchbrief': typeof WorksearchWorkLaunchbriefRoute
  '/administration/clients/$id': typeof AdministrationClientsIdRoute
  '/administration/imports/createretailerorders': typeof AdministrationImportsCreateretailerordersRoute
  '/administration/imports/importprices': typeof AdministrationImportsImportpricesRoute
  '/administration/imports/importstockchanges': typeof AdministrationImportsImportstockchangesRoute
  '/administration/imports/importtransaction': typeof AdministrationImportsImporttransactionRoute
  '/administration/integrations/_webhooks': typeof AdministrationIntegrationsWebhooksRouteWithChildren
  '/administration/integrations/documentation': typeof AdministrationIntegrationsDocumentationRoute
  '/administration/users/$id': typeof AdministrationUsersIdRouteWithChildren
  '/assets/$id/connections': typeof AssetsIdConnectionsRoute
  '/assets/$id/general': typeof AssetsIdGeneralRoute
  '/assets/$id/replace': typeof AssetsIdReplaceRoute
  '/bundle/_main/create': typeof BundleMainCreateRoute
  '/concept/$conceptId/approval': typeof ConceptConceptIdApprovalRoute
  '/concept/$conceptId/baseInfo': typeof ConceptConceptIdBaseInfoRoute
  '/concept/$conceptId/calculations': typeof ConceptConceptIdCalculationsRoute
  '/concept/$conceptId/categorization': typeof ConceptConceptIdCategorizationRoute
  '/concept/$conceptId/cost': typeof ConceptConceptIdCostRoute
  '/concept/$conceptId/detailedInfo': typeof ConceptConceptIdDetailedInfoRoute
  '/concept/$conceptId/general': typeof ConceptConceptIdGeneralRoute
  '/concept/$conceptId/members': typeof ConceptConceptIdMembersRoute
  '/concept/$conceptId/notes': typeof ConceptConceptIdNotesRoute
  '/concept/$conceptId/pre-calculation': typeof ConceptConceptIdPreCalculationRoute
  '/concept/$conceptId/profitability': typeof ConceptConceptIdProfitabilityRoute
  '/contact/$contactId/addresses': typeof ContactContactIdAddressesRoute
  '/contact/$contactId/agreements': typeof ContactContactIdAgreementsRoute
  '/contact/$contactId/assets': typeof ContactContactIdAssetsRoute
  '/contact/$contactId/companycontacts': typeof ContactContactIdCompanycontactsRoute
  '/contact/$contactId/concepts': typeof ContactContactIdConceptsRoute
  '/contact/$contactId/details': typeof ContactContactIdDetailsRoute
  '/contact/$contactId/links': typeof ContactContactIdLinksRoute
  '/contact/$contactId/lists': typeof ContactContactIdListsRoute
  '/contact/$contactId/notes': typeof ContactContactIdNotesRoute
  '/contact/$contactId/productions': typeof ContactContactIdProductionsRoute
  '/contact/$contactId/retailer': typeof ContactContactIdRetailerRoute
  '/contact/$contactId/royalty': typeof ContactContactIdRoyaltyRoute
  '/contact/$contactId/texts': typeof ContactContactIdTextsRoute
  '/contact/$contactId/works': typeof ContactContactIdWorksRoute
  '/contacts/list/$id': typeof ContactsListIdRoute
  '/royalty/errorlist/agreements': typeof RoyaltyErrorlistAgreementsRoute
  '/royalty/errorlist/contacts': typeof RoyaltyErrorlistContactsRoute
  '/royalty/errorlist/terms': typeof RoyaltyErrorlistTermsRoute
  '/royalty/errorlist/transactions': typeof RoyaltyErrorlistTransactionsRoute
  '/royalty/paymentinformation/history': typeof RoyaltyPaymentinformationHistoryRoute
  '/royalty/paymentinformation/upcoming': typeof RoyaltyPaymentinformationUpcomingRoute
  '/royalty/reports/advances': typeof RoyaltyReportsAdvancesRoute
  '/royalty/reports/agreements': typeof RoyaltyReportsAgreementsRoute
  '/royalty/reports/settlements': typeof RoyaltyReportsSettlementsRoute
  '/royalty/reports/terms': typeof RoyaltyReportsTermsRoute
  '/royalty/reports/upcoming-settlements': typeof RoyaltyReportsUpcomingSettlementsRoute
  '/royalty_/agreement/$id': typeof RoyaltyAgreementIdRouteWithChildren
  '/series/list/$serieId': typeof SeriesListSerieIdRoute
  '/user/$userId/access': typeof UserUserIdAccessRoute
  '/user/$userId/claims': typeof UserUserIdClaimsRoute
  '/user/$userId/contacts': typeof UserUserIdContactsRoute
  '/user/$userId/general': typeof UserUserIdGeneralRoute
  '/work/$workId/assets': typeof WorkWorkIdAssetsRoute
  '/work/$workId/calculation': typeof WorkWorkIdCalculationRoute
  '/work/$workId/categorization': typeof WorkWorkIdCategorizationRoute
  '/work/$workId/contracts': typeof WorkWorkIdContractsRoute
  '/work/$workId/corrections': typeof WorkWorkIdCorrectionsRoute
  '/work/$workId/costs': typeof WorkWorkIdCostsRoute
  '/work/$workId/launch-brief': typeof WorkWorkIdLaunchBriefRoute
  '/work/$workId/misc': typeof WorkWorkIdMiscRoute
  '/work/$workId/productions': typeof WorkWorkIdProductionsRoute
  '/work/$workId/profitability': typeof WorkWorkIdProfitabilityRoute
  '/work/$workId/review-quotes': typeof WorkWorkIdReviewQuotesRoute
  '/work/$workId/rights': typeof WorkWorkIdRightsRoute
  '/work/$workId/royalty': typeof WorkWorkIdRoyaltyRoute
  '/work/$workId/team': typeof WorkWorkIdTeamRoute
  '/work/activities/$activityId': typeof WorkActivitiesActivityIdRoute
  '/administration/clients/': typeof AdministrationClientsIndexRoute
  '/administration/users/': typeof AdministrationUsersIndexRoute
  '/assets/$id/': typeof AssetsIdIndexRoute
  '/book/$workId/': typeof BookWorkIdIndexRoute
  '/concept/$conceptId/': typeof ConceptConceptIdIndexRoute
  '/contact/$contactId/': typeof ContactContactIdIndexRoute
  '/series/list/': typeof SeriesListIndexRoute
  '/user/$userId/': typeof UserUserIdIndexRoute
  '/work/$workId/': typeof WorkWorkIdIndexRoute
  '/work/activities/': typeof WorkActivitiesIndexRoute
  '/administration/users/$id/access': typeof AdministrationUsersIdAccessRoute
  '/administration/users/$id/general': typeof AdministrationUsersIdGeneralRoute
  '/book/$workId/edition/$editionId': typeof BookWorkIdEditionEditionIdRoute
  '/bundle/_main/edit/$productId': typeof BundleMainEditProductIdRoute
  '/bundle/_main/erp/$productId': typeof BundleMainErpProductIdRoute
  '/concept/$conceptId/productions/$productionId': typeof ConceptConceptIdProductionsProductionIdRoute
  '/integrations/_webhooks/webhook/events': typeof IntegrationsWebhooksWebhookEventsRoute
  '/integrations/_webhooks/webhook/subscribers': typeof IntegrationsWebhooksWebhookSubscribersRoute
  '/integrations/_webhooks/webhook/token-configurations': typeof IntegrationsWebhooksWebhookTokenConfigurationsRoute
  '/royalty_/agreement/$id/general': typeof RoyaltyAgreementIdGeneralRoute
  '/royalty_/agreement/$id/transactions': typeof RoyaltyAgreementIdTransactionsRoute
  '/work/$workId_/edition/$editionId': typeof WorkWorkIdEditionEditionIdRouteWithChildren
  '/administration/users/$id/': typeof AdministrationUsersIdIndexRoute
  '/concept/$conceptId/productions/': typeof ConceptConceptIdProductionsIndexRoute
  '/integrations/_webhooks/webhook/': typeof IntegrationsWebhooksWebhookIndexRoute
  '/work/$workId/launch-plan/': typeof WorkWorkIdLaunchPlanIndexRoute
  '/administration/integrations/_webhooks/webhook/events': typeof AdministrationIntegrationsWebhooksWebhookEventsRoute
  '/administration/integrations/_webhooks/webhook/subscribers': typeof AdministrationIntegrationsWebhooksWebhookSubscribersRoute
  '/administration/integrations/_webhooks/webhook/token-configurations': typeof AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute
  '/work/$workId/launch-plan/activity/$activityId': typeof WorkWorkIdLaunchPlanActivityActivityIdRoute
  '/work/$workId_/edition/$editionId/assets': typeof WorkWorkIdEditionEditionIdAssetsRoute
  '/work/$workId_/edition/$editionId/comments': typeof WorkWorkIdEditionEditionIdCommentsRoute
  '/work/$workId_/edition/$editionId/content-categorization': typeof WorkWorkIdEditionEditionIdContentCategorizationRoute
  '/work/$workId_/edition/$editionId/content-editorial': typeof WorkWorkIdEditionEditionIdContentEditorialRoute
  '/work/$workId_/edition/$editionId/content-education': typeof WorkWorkIdEditionEditionIdContentEducationRoute
  '/work/$workId_/edition/$editionId/content-links': typeof WorkWorkIdEditionEditionIdContentLinksRoute
  '/work/$workId_/edition/$editionId/content-press-sales': typeof WorkWorkIdEditionEditionIdContentPressSalesRoute
  '/work/$workId_/edition/$editionId/content-title-portrait': typeof WorkWorkIdEditionEditionIdContentTitlePortraitRoute
  '/work/$workId_/edition/$editionId/copyproduction': typeof WorkWorkIdEditionEditionIdCopyproductionRoute
  '/work/$workId_/edition/$editionId/copytechnicalproduction': typeof WorkWorkIdEditionEditionIdCopytechnicalproductionRoute
  '/work/$workId_/edition/$editionId/distribution': typeof WorkWorkIdEditionEditionIdDistributionRoute
  '/work/$workId_/edition/$editionId/distribution-logs': typeof WorkWorkIdEditionEditionIdDistributionLogsRoute
  '/work/$workId_/edition/$editionId/erp': typeof WorkWorkIdEditionEditionIdErpRoute
  '/work/$workId_/edition/$editionId/general-bookclubs': typeof WorkWorkIdEditionEditionIdGeneralBookclubsRoute
  '/work/$workId_/edition/$editionId/general-costs': typeof WorkWorkIdEditionEditionIdGeneralCostsRoute
  '/work/$workId_/edition/$editionId/general-misc': typeof WorkWorkIdEditionEditionIdGeneralMiscRoute
  '/work/$workId_/edition/$editionId/general-price-and-cost': typeof WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute
  '/work/$workId_/edition/$editionId/general-printrun': typeof WorkWorkIdEditionEditionIdGeneralPrintrunRoute
  '/work/$workId_/edition/$editionId/general-rights': typeof WorkWorkIdEditionEditionIdGeneralRightsRoute
  '/work/$workId_/edition/$editionId/general-royalty-levels': typeof WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute
  '/work/$workId_/edition/$editionId/general-sales': typeof WorkWorkIdEditionEditionIdGeneralSalesRoute
  '/work/$workId_/edition/$editionId/general-schedule': typeof WorkWorkIdEditionEditionIdGeneralScheduleRoute
  '/work/$workId_/edition/$editionId/layout': typeof WorkWorkIdEditionEditionIdLayoutRoute
  '/work/$workId_/edition/$editionId/layout-binding': typeof WorkWorkIdEditionEditionIdLayoutBindingRoute
  '/work/$workId_/edition/$editionId/layout-composition': typeof WorkWorkIdEditionEditionIdLayoutCompositionRoute
  '/work/$workId_/edition/$editionId/layout-cover': typeof WorkWorkIdEditionEditionIdLayoutCoverRoute
  '/work/$workId_/edition/$editionId/layout-inside': typeof WorkWorkIdEditionEditionIdLayoutInsideRoute
  '/work/$workId_/edition/$editionId/layout-measurements': typeof WorkWorkIdEditionEditionIdLayoutMeasurementsRoute
  '/work/$workId_/edition/$editionId/layout-technicalproduction': typeof WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute
  '/work/$workId_/edition/$editionId/print-orders': typeof WorkWorkIdEditionEditionIdPrintOrdersRoute
  '/work/$workId_/edition/$editionId/printchanges': typeof WorkWorkIdEditionEditionIdPrintchangesRoute
  '/work/$workId_/edition/$editionId/profitability': typeof WorkWorkIdEditionEditionIdProfitabilityRoute
  '/work/$workId_/edition/$editionId/publish': typeof WorkWorkIdEditionEditionIdPublishRoute
  '/work/$workId_/edition/$editionId/team': typeof WorkWorkIdEditionEditionIdTeamRoute
  '/work/$workId_/edition/$editionId/technicaldescription': typeof WorkWorkIdEditionEditionIdTechnicaldescriptionRoute
  '/work/$workId_/edition/$editionId/unpublish': typeof WorkWorkIdEditionEditionIdUnpublishRoute
  '/administration/integrations/_webhooks/webhook/': typeof AdministrationIntegrationsWebhooksWebhookIndexRoute
  '/royalty_/agreement/$id/settlements/': typeof RoyaltyAgreementIdSettlementsIndexRoute
  '/royalty_/agreement/$id/terms/': typeof RoyaltyAgreementIdTermsIndexRoute
  '/work/$workId_/edition/$editionId/': typeof WorkWorkIdEditionEditionIdIndexRoute
  '/royalty_/agreement/$id/terms/$ruleSetId/version/$ruleId': typeof RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute
  '/royalty_/agreement/$id/settlements/$settlementId/receiver/$contactId/$status': typeof RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/concepts'
    | '/imports'
    | '/integrations'
    | '/metadata'
    | '/mydownloads'
    | '/mywork'
    | '/royalty'
    | '/users'
    | '/works'
    | '/admin/costtypes'
    | '/admin/eanseries'
    | '/admin/emailtemplates'
    | '/admin/printerprices'
    | '/admin/production-plans'
    | '/admin/royaltyPriceRules'
    | '/admin/royaltySalesChannels'
    | '/admin/tags'
    | '/administration/costtypes'
    | '/administration/eanseries'
    | '/administration/emailtemplates'
    | '/administration/integrations'
    | '/administration/metadata'
    | '/administration/printerprices'
    | '/administration/production-plans'
    | '/administration/royaltyPriceRules'
    | '/administration/royaltySalesChannels'
    | '/administration/tags'
    | '/assets/$id'
    | '/bundle'
    | '/bundle/list'
    | '/concept/$conceptId'
    | '/contact/$contactId'
    | '/contacts/lists'
    | '/imports/createretailerorders'
    | '/imports/importprices'
    | '/imports/importstockchanges'
    | '/imports/importtransaction'
    | '/integrations/documentation'
    | '/metadata/$metaDataTypeId'
    | '/royalty/agreements'
    | '/royalty/backgroundjobs'
    | '/royalty/errorlist'
    | '/royalty/paymentinformation'
    | '/royalty/reports'
    | '/royalty/statements'
    | '/user/$userId'
    | '/work/$workId'
    | '/work/works'
    | '/administration/'
    | '/assets/'
    | '/contacts/'
    | '/work/editions'
    | '/work/salessheet'
    | '/work/launchbrief'
    | '/administration/clients/$id'
    | '/administration/imports/createretailerorders'
    | '/administration/imports/importprices'
    | '/administration/imports/importstockchanges'
    | '/administration/imports/importtransaction'
    | '/administration/integrations/documentation'
    | '/administration/users/$id'
    | '/assets/$id/connections'
    | '/assets/$id/general'
    | '/assets/$id/replace'
    | '/bundle/create'
    | '/concept/$conceptId/approval'
    | '/concept/$conceptId/baseInfo'
    | '/concept/$conceptId/calculations'
    | '/concept/$conceptId/categorization'
    | '/concept/$conceptId/cost'
    | '/concept/$conceptId/detailedInfo'
    | '/concept/$conceptId/general'
    | '/concept/$conceptId/members'
    | '/concept/$conceptId/notes'
    | '/concept/$conceptId/pre-calculation'
    | '/concept/$conceptId/profitability'
    | '/contact/$contactId/addresses'
    | '/contact/$contactId/agreements'
    | '/contact/$contactId/assets'
    | '/contact/$contactId/companycontacts'
    | '/contact/$contactId/concepts'
    | '/contact/$contactId/details'
    | '/contact/$contactId/links'
    | '/contact/$contactId/lists'
    | '/contact/$contactId/notes'
    | '/contact/$contactId/productions'
    | '/contact/$contactId/retailer'
    | '/contact/$contactId/royalty'
    | '/contact/$contactId/texts'
    | '/contact/$contactId/works'
    | '/contacts/list/$id'
    | '/royalty/errorlist/agreements'
    | '/royalty/errorlist/contacts'
    | '/royalty/errorlist/terms'
    | '/royalty/errorlist/transactions'
    | '/royalty/paymentinformation/history'
    | '/royalty/paymentinformation/upcoming'
    | '/royalty/reports/advances'
    | '/royalty/reports/agreements'
    | '/royalty/reports/settlements'
    | '/royalty/reports/terms'
    | '/royalty/reports/upcoming-settlements'
    | '/royalty/agreement/$id'
    | '/series/list/$serieId'
    | '/user/$userId/access'
    | '/user/$userId/claims'
    | '/user/$userId/contacts'
    | '/user/$userId/general'
    | '/work/$workId/assets'
    | '/work/$workId/calculation'
    | '/work/$workId/categorization'
    | '/work/$workId/contracts'
    | '/work/$workId/corrections'
    | '/work/$workId/costs'
    | '/work/$workId/launch-brief'
    | '/work/$workId/misc'
    | '/work/$workId/productions'
    | '/work/$workId/profitability'
    | '/work/$workId/review-quotes'
    | '/work/$workId/rights'
    | '/work/$workId/royalty'
    | '/work/$workId/team'
    | '/work/activities/$activityId'
    | '/administration/clients/'
    | '/administration/users/'
    | '/assets/$id/'
    | '/book/$workId/'
    | '/concept/$conceptId/'
    | '/contact/$contactId/'
    | '/series/list/'
    | '/user/$userId/'
    | '/work/$workId/'
    | '/work/activities/'
    | '/administration/users/$id/access'
    | '/administration/users/$id/general'
    | '/book/$workId/edition/$editionId'
    | '/bundle/edit/$productId'
    | '/bundle/erp/$productId'
    | '/concept/$conceptId/productions/$productionId'
    | '/integrations/webhook/events'
    | '/integrations/webhook/subscribers'
    | '/integrations/webhook/token-configurations'
    | '/royalty/agreement/$id/general'
    | '/royalty/agreement/$id/transactions'
    | '/work/$workId/edition/$editionId'
    | '/administration/users/$id/'
    | '/concept/$conceptId/productions/'
    | '/integrations/webhook/'
    | '/work/$workId/launch-plan/'
    | '/administration/integrations/webhook/events'
    | '/administration/integrations/webhook/subscribers'
    | '/administration/integrations/webhook/token-configurations'
    | '/work/$workId/launch-plan/activity/$activityId'
    | '/work/$workId/edition/$editionId/assets'
    | '/work/$workId/edition/$editionId/comments'
    | '/work/$workId/edition/$editionId/content-categorization'
    | '/work/$workId/edition/$editionId/content-editorial'
    | '/work/$workId/edition/$editionId/content-education'
    | '/work/$workId/edition/$editionId/content-links'
    | '/work/$workId/edition/$editionId/content-press-sales'
    | '/work/$workId/edition/$editionId/content-title-portrait'
    | '/work/$workId/edition/$editionId/copyproduction'
    | '/work/$workId/edition/$editionId/copytechnicalproduction'
    | '/work/$workId/edition/$editionId/distribution'
    | '/work/$workId/edition/$editionId/distribution-logs'
    | '/work/$workId/edition/$editionId/erp'
    | '/work/$workId/edition/$editionId/general-bookclubs'
    | '/work/$workId/edition/$editionId/general-costs'
    | '/work/$workId/edition/$editionId/general-misc'
    | '/work/$workId/edition/$editionId/general-price-and-cost'
    | '/work/$workId/edition/$editionId/general-printrun'
    | '/work/$workId/edition/$editionId/general-rights'
    | '/work/$workId/edition/$editionId/general-royalty-levels'
    | '/work/$workId/edition/$editionId/general-sales'
    | '/work/$workId/edition/$editionId/general-schedule'
    | '/work/$workId/edition/$editionId/layout'
    | '/work/$workId/edition/$editionId/layout-binding'
    | '/work/$workId/edition/$editionId/layout-composition'
    | '/work/$workId/edition/$editionId/layout-cover'
    | '/work/$workId/edition/$editionId/layout-inside'
    | '/work/$workId/edition/$editionId/layout-measurements'
    | '/work/$workId/edition/$editionId/layout-technicalproduction'
    | '/work/$workId/edition/$editionId/print-orders'
    | '/work/$workId/edition/$editionId/printchanges'
    | '/work/$workId/edition/$editionId/profitability'
    | '/work/$workId/edition/$editionId/publish'
    | '/work/$workId/edition/$editionId/team'
    | '/work/$workId/edition/$editionId/technicaldescription'
    | '/work/$workId/edition/$editionId/unpublish'
    | '/administration/integrations/webhook/'
    | '/royalty/agreement/$id/settlements/'
    | '/royalty/agreement/$id/terms/'
    | '/work/$workId/edition/$editionId/'
    | '/royalty/agreement/$id/terms/$ruleSetId/version/$ruleId'
    | '/royalty/agreement/$id/settlements/$settlementId/receiver/$contactId/$status'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/concepts'
    | '/imports'
    | '/integrations'
    | '/metadata'
    | '/mydownloads'
    | '/mywork'
    | '/royalty'
    | '/users'
    | '/works'
    | '/admin/costtypes'
    | '/admin/eanseries'
    | '/admin/emailtemplates'
    | '/admin/printerprices'
    | '/admin/production-plans'
    | '/admin/royaltyPriceRules'
    | '/admin/royaltySalesChannels'
    | '/admin/tags'
    | '/administration/costtypes'
    | '/administration/eanseries'
    | '/administration/emailtemplates'
    | '/administration/integrations'
    | '/administration/metadata'
    | '/administration/printerprices'
    | '/administration/production-plans'
    | '/administration/royaltyPriceRules'
    | '/administration/royaltySalesChannels'
    | '/administration/tags'
    | '/bundle'
    | '/bundle/list'
    | '/contacts/lists'
    | '/imports/createretailerorders'
    | '/imports/importprices'
    | '/imports/importstockchanges'
    | '/imports/importtransaction'
    | '/integrations/documentation'
    | '/metadata/$metaDataTypeId'
    | '/royalty/agreements'
    | '/royalty/backgroundjobs'
    | '/royalty/errorlist'
    | '/royalty/paymentinformation'
    | '/royalty/reports'
    | '/royalty/statements'
    | '/work/works'
    | '/administration'
    | '/assets'
    | '/contacts'
    | '/work/editions'
    | '/work/salessheet'
    | '/work/launchbrief'
    | '/administration/clients/$id'
    | '/administration/imports/createretailerorders'
    | '/administration/imports/importprices'
    | '/administration/imports/importstockchanges'
    | '/administration/imports/importtransaction'
    | '/administration/integrations/documentation'
    | '/assets/$id/connections'
    | '/assets/$id/general'
    | '/assets/$id/replace'
    | '/bundle/create'
    | '/concept/$conceptId/approval'
    | '/concept/$conceptId/baseInfo'
    | '/concept/$conceptId/calculations'
    | '/concept/$conceptId/categorization'
    | '/concept/$conceptId/cost'
    | '/concept/$conceptId/detailedInfo'
    | '/concept/$conceptId/general'
    | '/concept/$conceptId/members'
    | '/concept/$conceptId/notes'
    | '/concept/$conceptId/pre-calculation'
    | '/concept/$conceptId/profitability'
    | '/contact/$contactId/addresses'
    | '/contact/$contactId/agreements'
    | '/contact/$contactId/assets'
    | '/contact/$contactId/companycontacts'
    | '/contact/$contactId/concepts'
    | '/contact/$contactId/details'
    | '/contact/$contactId/links'
    | '/contact/$contactId/lists'
    | '/contact/$contactId/notes'
    | '/contact/$contactId/productions'
    | '/contact/$contactId/retailer'
    | '/contact/$contactId/royalty'
    | '/contact/$contactId/texts'
    | '/contact/$contactId/works'
    | '/contacts/list/$id'
    | '/royalty/errorlist/agreements'
    | '/royalty/errorlist/contacts'
    | '/royalty/errorlist/terms'
    | '/royalty/errorlist/transactions'
    | '/royalty/paymentinformation/history'
    | '/royalty/paymentinformation/upcoming'
    | '/royalty/reports/advances'
    | '/royalty/reports/agreements'
    | '/royalty/reports/settlements'
    | '/royalty/reports/terms'
    | '/royalty/reports/upcoming-settlements'
    | '/royalty/agreement/$id'
    | '/series/list/$serieId'
    | '/user/$userId/access'
    | '/user/$userId/claims'
    | '/user/$userId/contacts'
    | '/user/$userId/general'
    | '/work/$workId/assets'
    | '/work/$workId/calculation'
    | '/work/$workId/categorization'
    | '/work/$workId/contracts'
    | '/work/$workId/corrections'
    | '/work/$workId/costs'
    | '/work/$workId/launch-brief'
    | '/work/$workId/misc'
    | '/work/$workId/productions'
    | '/work/$workId/profitability'
    | '/work/$workId/review-quotes'
    | '/work/$workId/rights'
    | '/work/$workId/royalty'
    | '/work/$workId/team'
    | '/work/activities/$activityId'
    | '/administration/clients'
    | '/administration/users'
    | '/assets/$id'
    | '/book/$workId'
    | '/concept/$conceptId'
    | '/contact/$contactId'
    | '/series/list'
    | '/user/$userId'
    | '/work/$workId'
    | '/work/activities'
    | '/administration/users/$id/access'
    | '/administration/users/$id/general'
    | '/book/$workId/edition/$editionId'
    | '/bundle/edit/$productId'
    | '/bundle/erp/$productId'
    | '/concept/$conceptId/productions/$productionId'
    | '/integrations/webhook/events'
    | '/integrations/webhook/subscribers'
    | '/integrations/webhook/token-configurations'
    | '/royalty/agreement/$id/general'
    | '/royalty/agreement/$id/transactions'
    | '/administration/users/$id'
    | '/concept/$conceptId/productions'
    | '/integrations/webhook'
    | '/work/$workId/launch-plan'
    | '/administration/integrations/webhook/events'
    | '/administration/integrations/webhook/subscribers'
    | '/administration/integrations/webhook/token-configurations'
    | '/work/$workId/launch-plan/activity/$activityId'
    | '/work/$workId/edition/$editionId/assets'
    | '/work/$workId/edition/$editionId/comments'
    | '/work/$workId/edition/$editionId/content-categorization'
    | '/work/$workId/edition/$editionId/content-editorial'
    | '/work/$workId/edition/$editionId/content-education'
    | '/work/$workId/edition/$editionId/content-links'
    | '/work/$workId/edition/$editionId/content-press-sales'
    | '/work/$workId/edition/$editionId/content-title-portrait'
    | '/work/$workId/edition/$editionId/copyproduction'
    | '/work/$workId/edition/$editionId/copytechnicalproduction'
    | '/work/$workId/edition/$editionId/distribution'
    | '/work/$workId/edition/$editionId/distribution-logs'
    | '/work/$workId/edition/$editionId/erp'
    | '/work/$workId/edition/$editionId/general-bookclubs'
    | '/work/$workId/edition/$editionId/general-costs'
    | '/work/$workId/edition/$editionId/general-misc'
    | '/work/$workId/edition/$editionId/general-price-and-cost'
    | '/work/$workId/edition/$editionId/general-printrun'
    | '/work/$workId/edition/$editionId/general-rights'
    | '/work/$workId/edition/$editionId/general-royalty-levels'
    | '/work/$workId/edition/$editionId/general-sales'
    | '/work/$workId/edition/$editionId/general-schedule'
    | '/work/$workId/edition/$editionId/layout'
    | '/work/$workId/edition/$editionId/layout-binding'
    | '/work/$workId/edition/$editionId/layout-composition'
    | '/work/$workId/edition/$editionId/layout-cover'
    | '/work/$workId/edition/$editionId/layout-inside'
    | '/work/$workId/edition/$editionId/layout-measurements'
    | '/work/$workId/edition/$editionId/layout-technicalproduction'
    | '/work/$workId/edition/$editionId/print-orders'
    | '/work/$workId/edition/$editionId/printchanges'
    | '/work/$workId/edition/$editionId/profitability'
    | '/work/$workId/edition/$editionId/publish'
    | '/work/$workId/edition/$editionId/team'
    | '/work/$workId/edition/$editionId/technicaldescription'
    | '/work/$workId/edition/$editionId/unpublish'
    | '/administration/integrations/webhook'
    | '/royalty/agreement/$id/settlements'
    | '/royalty/agreement/$id/terms'
    | '/work/$workId/edition/$editionId'
    | '/royalty/agreement/$id/terms/$ruleSetId/version/$ruleId'
    | '/royalty/agreement/$id/settlements/$settlementId/receiver/$contactId/$status'
  id:
    | '__root__'
    | '/'
    | '/_editionsearch'
    | '/_worksearch'
    | '/admin'
    | '/concepts'
    | '/imports'
    | '/integrations'
    | '/metadata'
    | '/mydownloads'
    | '/mywork'
    | '/royalty'
    | '/users'
    | '/_worksearch/works'
    | '/admin/costtypes'
    | '/admin/eanseries'
    | '/admin/emailtemplates'
    | '/admin/printerprices'
    | '/admin/production-plans'
    | '/admin/royaltyPriceRules'
    | '/admin/royaltySalesChannels'
    | '/admin/tags'
    | '/administration/costtypes'
    | '/administration/eanseries'
    | '/administration/emailtemplates'
    | '/administration/integrations'
    | '/administration/metadata'
    | '/administration/printerprices'
    | '/administration/production-plans'
    | '/administration/royaltyPriceRules'
    | '/administration/royaltySalesChannels'
    | '/administration/tags'
    | '/assets/$id'
    | '/bundle/_main'
    | '/bundle/list'
    | '/concept/$conceptId'
    | '/contact/$contactId'
    | '/contacts/lists'
    | '/imports/createretailerorders'
    | '/imports/importprices'
    | '/imports/importstockchanges'
    | '/imports/importtransaction'
    | '/integrations/_webhooks'
    | '/integrations/documentation'
    | '/metadata/$metaDataTypeId'
    | '/royalty/agreements'
    | '/royalty/backgroundjobs'
    | '/royalty/errorlist'
    | '/royalty/paymentinformation'
    | '/royalty/reports'
    | '/royalty/statements'
    | '/user/$userId'
    | '/work/$workId'
    | '/work/works'
    | '/administration/'
    | '/assets/'
    | '/contacts/'
    | '/_editionsearch/work/editions'
    | '/_editionsearch/work/salessheet'
    | '/_worksearch/work/launchbrief'
    | '/administration/clients/$id'
    | '/administration/imports/createretailerorders'
    | '/administration/imports/importprices'
    | '/administration/imports/importstockchanges'
    | '/administration/imports/importtransaction'
    | '/administration/integrations/_webhooks'
    | '/administration/integrations/documentation'
    | '/administration/users/$id'
    | '/assets/$id/connections'
    | '/assets/$id/general'
    | '/assets/$id/replace'
    | '/bundle/_main/create'
    | '/concept/$conceptId/approval'
    | '/concept/$conceptId/baseInfo'
    | '/concept/$conceptId/calculations'
    | '/concept/$conceptId/categorization'
    | '/concept/$conceptId/cost'
    | '/concept/$conceptId/detailedInfo'
    | '/concept/$conceptId/general'
    | '/concept/$conceptId/members'
    | '/concept/$conceptId/notes'
    | '/concept/$conceptId/pre-calculation'
    | '/concept/$conceptId/profitability'
    | '/contact/$contactId/addresses'
    | '/contact/$contactId/agreements'
    | '/contact/$contactId/assets'
    | '/contact/$contactId/companycontacts'
    | '/contact/$contactId/concepts'
    | '/contact/$contactId/details'
    | '/contact/$contactId/links'
    | '/contact/$contactId/lists'
    | '/contact/$contactId/notes'
    | '/contact/$contactId/productions'
    | '/contact/$contactId/retailer'
    | '/contact/$contactId/royalty'
    | '/contact/$contactId/texts'
    | '/contact/$contactId/works'
    | '/contacts/list/$id'
    | '/royalty/errorlist/agreements'
    | '/royalty/errorlist/contacts'
    | '/royalty/errorlist/terms'
    | '/royalty/errorlist/transactions'
    | '/royalty/paymentinformation/history'
    | '/royalty/paymentinformation/upcoming'
    | '/royalty/reports/advances'
    | '/royalty/reports/agreements'
    | '/royalty/reports/settlements'
    | '/royalty/reports/terms'
    | '/royalty/reports/upcoming-settlements'
    | '/royalty_/agreement/$id'
    | '/series/list/$serieId'
    | '/user/$userId/access'
    | '/user/$userId/claims'
    | '/user/$userId/contacts'
    | '/user/$userId/general'
    | '/work/$workId/assets'
    | '/work/$workId/calculation'
    | '/work/$workId/categorization'
    | '/work/$workId/contracts'
    | '/work/$workId/corrections'
    | '/work/$workId/costs'
    | '/work/$workId/launch-brief'
    | '/work/$workId/misc'
    | '/work/$workId/productions'
    | '/work/$workId/profitability'
    | '/work/$workId/review-quotes'
    | '/work/$workId/rights'
    | '/work/$workId/royalty'
    | '/work/$workId/team'
    | '/work/activities/$activityId'
    | '/administration/clients/'
    | '/administration/users/'
    | '/assets/$id/'
    | '/book/$workId/'
    | '/concept/$conceptId/'
    | '/contact/$contactId/'
    | '/series/list/'
    | '/user/$userId/'
    | '/work/$workId/'
    | '/work/activities/'
    | '/administration/users/$id/access'
    | '/administration/users/$id/general'
    | '/book/$workId/edition/$editionId'
    | '/bundle/_main/edit/$productId'
    | '/bundle/_main/erp/$productId'
    | '/concept/$conceptId/productions/$productionId'
    | '/integrations/_webhooks/webhook/events'
    | '/integrations/_webhooks/webhook/subscribers'
    | '/integrations/_webhooks/webhook/token-configurations'
    | '/royalty_/agreement/$id/general'
    | '/royalty_/agreement/$id/transactions'
    | '/work/$workId_/edition/$editionId'
    | '/administration/users/$id/'
    | '/concept/$conceptId/productions/'
    | '/integrations/_webhooks/webhook/'
    | '/work/$workId/launch-plan/'
    | '/administration/integrations/_webhooks/webhook/events'
    | '/administration/integrations/_webhooks/webhook/subscribers'
    | '/administration/integrations/_webhooks/webhook/token-configurations'
    | '/work/$workId/launch-plan/activity/$activityId'
    | '/work/$workId_/edition/$editionId/assets'
    | '/work/$workId_/edition/$editionId/comments'
    | '/work/$workId_/edition/$editionId/content-categorization'
    | '/work/$workId_/edition/$editionId/content-editorial'
    | '/work/$workId_/edition/$editionId/content-education'
    | '/work/$workId_/edition/$editionId/content-links'
    | '/work/$workId_/edition/$editionId/content-press-sales'
    | '/work/$workId_/edition/$editionId/content-title-portrait'
    | '/work/$workId_/edition/$editionId/copyproduction'
    | '/work/$workId_/edition/$editionId/copytechnicalproduction'
    | '/work/$workId_/edition/$editionId/distribution'
    | '/work/$workId_/edition/$editionId/distribution-logs'
    | '/work/$workId_/edition/$editionId/erp'
    | '/work/$workId_/edition/$editionId/general-bookclubs'
    | '/work/$workId_/edition/$editionId/general-costs'
    | '/work/$workId_/edition/$editionId/general-misc'
    | '/work/$workId_/edition/$editionId/general-price-and-cost'
    | '/work/$workId_/edition/$editionId/general-printrun'
    | '/work/$workId_/edition/$editionId/general-rights'
    | '/work/$workId_/edition/$editionId/general-royalty-levels'
    | '/work/$workId_/edition/$editionId/general-sales'
    | '/work/$workId_/edition/$editionId/general-schedule'
    | '/work/$workId_/edition/$editionId/layout'
    | '/work/$workId_/edition/$editionId/layout-binding'
    | '/work/$workId_/edition/$editionId/layout-composition'
    | '/work/$workId_/edition/$editionId/layout-cover'
    | '/work/$workId_/edition/$editionId/layout-inside'
    | '/work/$workId_/edition/$editionId/layout-measurements'
    | '/work/$workId_/edition/$editionId/layout-technicalproduction'
    | '/work/$workId_/edition/$editionId/print-orders'
    | '/work/$workId_/edition/$editionId/printchanges'
    | '/work/$workId_/edition/$editionId/profitability'
    | '/work/$workId_/edition/$editionId/publish'
    | '/work/$workId_/edition/$editionId/team'
    | '/work/$workId_/edition/$editionId/technicaldescription'
    | '/work/$workId_/edition/$editionId/unpublish'
    | '/administration/integrations/_webhooks/webhook/'
    | '/royalty_/agreement/$id/settlements/'
    | '/royalty_/agreement/$id/terms/'
    | '/work/$workId_/edition/$editionId/'
    | '/royalty_/agreement/$id/terms/$ruleSetId/version/$ruleId'
    | '/royalty_/agreement/$id/settlements/$settlementId/receiver/$contactId/$status'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EditionsearchRoute: typeof EditionsearchRouteWithChildren
  WorksearchRoute: typeof WorksearchRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  ConceptsRoute: typeof ConceptsRoute
  ImportsRoute: typeof ImportsRouteWithChildren
  IntegrationsRoute: typeof IntegrationsRouteWithChildren
  MetadataRoute: typeof MetadataRouteWithChildren
  MydownloadsRoute: typeof MydownloadsRoute
  MyworkRoute: typeof MyworkRoute
  RoyaltyRoute: typeof RoyaltyRouteWithChildren
  UsersRoute: typeof UsersRoute
  AdministrationCosttypesRoute: typeof AdministrationCosttypesRoute
  AdministrationEanseriesRoute: typeof AdministrationEanseriesRoute
  AdministrationEmailtemplatesRoute: typeof AdministrationEmailtemplatesRoute
  AdministrationIntegrationsRoute: typeof AdministrationIntegrationsRouteWithChildren
  AdministrationMetadataRoute: typeof AdministrationMetadataRoute
  AdministrationPrinterpricesRoute: typeof AdministrationPrinterpricesRoute
  AdministrationProductionPlansRoute: typeof AdministrationProductionPlansRoute
  AdministrationRoyaltyPriceRulesRoute: typeof AdministrationRoyaltyPriceRulesRoute
  AdministrationRoyaltySalesChannelsRoute: typeof AdministrationRoyaltySalesChannelsRoute
  AdministrationTagsRoute: typeof AdministrationTagsRoute
  AssetsIdRoute: typeof AssetsIdRouteWithChildren
  BundleMainRoute: typeof BundleMainRouteWithChildren
  BundleListRoute: typeof BundleListRoute
  ConceptConceptIdRoute: typeof ConceptConceptIdRouteWithChildren
  ContactContactIdRoute: typeof ContactContactIdRouteWithChildren
  ContactsListsRoute: typeof ContactsListsRoute
  UserUserIdRoute: typeof UserUserIdRouteWithChildren
  WorkWorkIdRoute: typeof WorkWorkIdRouteWithChildren
  WorkWorksRoute: typeof WorkWorksRoute
  AdministrationIndexRoute: typeof AdministrationIndexRoute
  AssetsIndexRoute: typeof AssetsIndexRoute
  ContactsIndexRoute: typeof ContactsIndexRoute
  AdministrationClientsIdRoute: typeof AdministrationClientsIdRoute
  AdministrationImportsCreateretailerordersRoute: typeof AdministrationImportsCreateretailerordersRoute
  AdministrationImportsImportpricesRoute: typeof AdministrationImportsImportpricesRoute
  AdministrationImportsImportstockchangesRoute: typeof AdministrationImportsImportstockchangesRoute
  AdministrationImportsImporttransactionRoute: typeof AdministrationImportsImporttransactionRoute
  AdministrationUsersIdRoute: typeof AdministrationUsersIdRouteWithChildren
  ContactsListIdRoute: typeof ContactsListIdRoute
  RoyaltyAgreementIdRoute: typeof RoyaltyAgreementIdRouteWithChildren
  SeriesListSerieIdRoute: typeof SeriesListSerieIdRoute
  WorkActivitiesActivityIdRoute: typeof WorkActivitiesActivityIdRoute
  AdministrationClientsIndexRoute: typeof AdministrationClientsIndexRoute
  AdministrationUsersIndexRoute: typeof AdministrationUsersIndexRoute
  BookWorkIdIndexRoute: typeof BookWorkIdIndexRoute
  SeriesListIndexRoute: typeof SeriesListIndexRoute
  WorkActivitiesIndexRoute: typeof WorkActivitiesIndexRoute
  BookWorkIdEditionEditionIdRoute: typeof BookWorkIdEditionEditionIdRoute
  WorkWorkIdEditionEditionIdRoute: typeof WorkWorkIdEditionEditionIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_editionsearch': {
      id: '/_editionsearch'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof EditionsearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_worksearch': {
      id: '/_worksearch'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WorksearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concepts': {
      id: '/concepts'
      path: '/concepts'
      fullPath: '/concepts'
      preLoaderRoute: typeof ConceptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports': {
      id: '/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof ImportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metadata': {
      id: '/metadata'
      path: '/metadata'
      fullPath: '/metadata'
      preLoaderRoute: typeof MetadataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mydownloads': {
      id: '/mydownloads'
      path: '/mydownloads'
      fullPath: '/mydownloads'
      preLoaderRoute: typeof MydownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mywork': {
      id: '/mywork'
      path: '/mywork'
      fullPath: '/mywork'
      preLoaderRoute: typeof MyworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/royalty': {
      id: '/royalty'
      path: '/royalty'
      fullPath: '/royalty'
      preLoaderRoute: typeof RoyaltyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_worksearch/works': {
      id: '/_worksearch/works'
      path: '/works'
      fullPath: '/works'
      preLoaderRoute: typeof WorksearchWorksRouteImport
      parentRoute: typeof WorksearchRoute
    }
    '/admin/costtypes': {
      id: '/admin/costtypes'
      path: '/costtypes'
      fullPath: '/admin/costtypes'
      preLoaderRoute: typeof AdminCosttypesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/eanseries': {
      id: '/admin/eanseries'
      path: '/eanseries'
      fullPath: '/admin/eanseries'
      preLoaderRoute: typeof AdminEanseriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/emailtemplates': {
      id: '/admin/emailtemplates'
      path: '/emailtemplates'
      fullPath: '/admin/emailtemplates'
      preLoaderRoute: typeof AdminEmailtemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/printerprices': {
      id: '/admin/printerprices'
      path: '/printerprices'
      fullPath: '/admin/printerprices'
      preLoaderRoute: typeof AdminPrinterpricesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/production-plans': {
      id: '/admin/production-plans'
      path: '/production-plans'
      fullPath: '/admin/production-plans'
      preLoaderRoute: typeof AdminProductionPlansRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/royaltyPriceRules': {
      id: '/admin/royaltyPriceRules'
      path: '/royaltyPriceRules'
      fullPath: '/admin/royaltyPriceRules'
      preLoaderRoute: typeof AdminRoyaltyPriceRulesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/royaltySalesChannels': {
      id: '/admin/royaltySalesChannels'
      path: '/royaltySalesChannels'
      fullPath: '/admin/royaltySalesChannels'
      preLoaderRoute: typeof AdminRoyaltySalesChannelsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tags': {
      id: '/admin/tags'
      path: '/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AdminTagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/administration/': {
      id: '/administration/'
      path: '/administration'
      fullPath: '/administration/'
      preLoaderRoute: typeof AdministrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/costtypes': {
      id: '/administration/costtypes'
      path: '/administration/costtypes'
      fullPath: '/administration/costtypes'
      preLoaderRoute: typeof AdministrationCosttypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/eanseries': {
      id: '/administration/eanseries'
      path: '/administration/eanseries'
      fullPath: '/administration/eanseries'
      preLoaderRoute: typeof AdministrationEanseriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/emailtemplates': {
      id: '/administration/emailtemplates'
      path: '/administration/emailtemplates'
      fullPath: '/administration/emailtemplates'
      preLoaderRoute: typeof AdministrationEmailtemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/integrations': {
      id: '/administration/integrations'
      path: '/administration/integrations'
      fullPath: '/administration/integrations'
      preLoaderRoute: typeof AdministrationIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/metadata': {
      id: '/administration/metadata'
      path: '/administration/metadata'
      fullPath: '/administration/metadata'
      preLoaderRoute: typeof AdministrationMetadataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/printerprices': {
      id: '/administration/printerprices'
      path: '/administration/printerprices'
      fullPath: '/administration/printerprices'
      preLoaderRoute: typeof AdministrationPrinterpricesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/production-plans': {
      id: '/administration/production-plans'
      path: '/administration/production-plans'
      fullPath: '/administration/production-plans'
      preLoaderRoute: typeof AdministrationProductionPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/royaltyPriceRules': {
      id: '/administration/royaltyPriceRules'
      path: '/administration/royaltyPriceRules'
      fullPath: '/administration/royaltyPriceRules'
      preLoaderRoute: typeof AdministrationRoyaltyPriceRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/royaltySalesChannels': {
      id: '/administration/royaltySalesChannels'
      path: '/administration/royaltySalesChannels'
      fullPath: '/administration/royaltySalesChannels'
      preLoaderRoute: typeof AdministrationRoyaltySalesChannelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/tags': {
      id: '/administration/tags'
      path: '/administration/tags'
      fullPath: '/administration/tags'
      preLoaderRoute: typeof AdministrationTagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/': {
      id: '/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AssetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/$id': {
      id: '/assets/$id'
      path: '/assets/$id'
      fullPath: '/assets/$id'
      preLoaderRoute: typeof AssetsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bundle/_main': {
      id: '/bundle/_main'
      path: '/bundle'
      fullPath: '/bundle'
      preLoaderRoute: typeof BundleMainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bundle/list': {
      id: '/bundle/list'
      path: '/bundle/list'
      fullPath: '/bundle/list'
      preLoaderRoute: typeof BundleListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concept/$conceptId': {
      id: '/concept/$conceptId'
      path: '/concept/$conceptId'
      fullPath: '/concept/$conceptId'
      preLoaderRoute: typeof ConceptConceptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact/$contactId': {
      id: '/contact/$contactId'
      path: '/contact/$contactId'
      fullPath: '/contact/$contactId'
      preLoaderRoute: typeof ContactContactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof ContactsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/lists': {
      id: '/contacts/lists'
      path: '/contacts/lists'
      fullPath: '/contacts/lists'
      preLoaderRoute: typeof ContactsListsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports/createretailerorders': {
      id: '/imports/createretailerorders'
      path: '/createretailerorders'
      fullPath: '/imports/createretailerorders'
      preLoaderRoute: typeof ImportsCreateretailerordersRouteImport
      parentRoute: typeof ImportsRoute
    }
    '/imports/importprices': {
      id: '/imports/importprices'
      path: '/importprices'
      fullPath: '/imports/importprices'
      preLoaderRoute: typeof ImportsImportpricesRouteImport
      parentRoute: typeof ImportsRoute
    }
    '/imports/importstockchanges': {
      id: '/imports/importstockchanges'
      path: '/importstockchanges'
      fullPath: '/imports/importstockchanges'
      preLoaderRoute: typeof ImportsImportstockchangesRouteImport
      parentRoute: typeof ImportsRoute
    }
    '/imports/importtransaction': {
      id: '/imports/importtransaction'
      path: '/importtransaction'
      fullPath: '/imports/importtransaction'
      preLoaderRoute: typeof ImportsImporttransactionRouteImport
      parentRoute: typeof ImportsRoute
    }
    '/integrations/_webhooks': {
      id: '/integrations/_webhooks'
      path: ''
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsWebhooksRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/integrations/documentation': {
      id: '/integrations/documentation'
      path: '/documentation'
      fullPath: '/integrations/documentation'
      preLoaderRoute: typeof IntegrationsDocumentationRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/metadata/$metaDataTypeId': {
      id: '/metadata/$metaDataTypeId'
      path: '/$metaDataTypeId'
      fullPath: '/metadata/$metaDataTypeId'
      preLoaderRoute: typeof MetadataMetaDataTypeIdRouteImport
      parentRoute: typeof MetadataRoute
    }
    '/royalty/agreements': {
      id: '/royalty/agreements'
      path: '/agreements'
      fullPath: '/royalty/agreements'
      preLoaderRoute: typeof RoyaltyAgreementsRouteImport
      parentRoute: typeof RoyaltyRoute
    }
    '/royalty/backgroundjobs': {
      id: '/royalty/backgroundjobs'
      path: '/backgroundjobs'
      fullPath: '/royalty/backgroundjobs'
      preLoaderRoute: typeof RoyaltyBackgroundjobsRouteImport
      parentRoute: typeof RoyaltyRoute
    }
    '/royalty/errorlist': {
      id: '/royalty/errorlist'
      path: '/errorlist'
      fullPath: '/royalty/errorlist'
      preLoaderRoute: typeof RoyaltyErrorlistRouteImport
      parentRoute: typeof RoyaltyRoute
    }
    '/royalty/paymentinformation': {
      id: '/royalty/paymentinformation'
      path: '/paymentinformation'
      fullPath: '/royalty/paymentinformation'
      preLoaderRoute: typeof RoyaltyPaymentinformationRouteImport
      parentRoute: typeof RoyaltyRoute
    }
    '/royalty/reports': {
      id: '/royalty/reports'
      path: '/reports'
      fullPath: '/royalty/reports'
      preLoaderRoute: typeof RoyaltyReportsRouteImport
      parentRoute: typeof RoyaltyRoute
    }
    '/royalty/statements': {
      id: '/royalty/statements'
      path: '/statements'
      fullPath: '/royalty/statements'
      preLoaderRoute: typeof RoyaltyStatementsRouteImport
      parentRoute: typeof RoyaltyRoute
    }
    '/user/$userId': {
      id: '/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof UserUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work/$workId': {
      id: '/work/$workId'
      path: '/work/$workId'
      fullPath: '/work/$workId'
      preLoaderRoute: typeof WorkWorkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work/works': {
      id: '/work/works'
      path: '/work/works'
      fullPath: '/work/works'
      preLoaderRoute: typeof WorkWorksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_editionsearch/work/editions': {
      id: '/_editionsearch/work/editions'
      path: '/work/editions'
      fullPath: '/work/editions'
      preLoaderRoute: typeof EditionsearchWorkEditionsRouteImport
      parentRoute: typeof EditionsearchRoute
    }
    '/_editionsearch/work/salessheet': {
      id: '/_editionsearch/work/salessheet'
      path: '/work/salessheet'
      fullPath: '/work/salessheet'
      preLoaderRoute: typeof EditionsearchWorkSalessheetRouteImport
      parentRoute: typeof EditionsearchRoute
    }
    '/_worksearch/work/launchbrief': {
      id: '/_worksearch/work/launchbrief'
      path: '/work/launchbrief'
      fullPath: '/work/launchbrief'
      preLoaderRoute: typeof WorksearchWorkLaunchbriefRouteImport
      parentRoute: typeof WorksearchRoute
    }
    '/administration/clients/': {
      id: '/administration/clients/'
      path: '/administration/clients'
      fullPath: '/administration/clients/'
      preLoaderRoute: typeof AdministrationClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/clients/$id': {
      id: '/administration/clients/$id'
      path: '/administration/clients/$id'
      fullPath: '/administration/clients/$id'
      preLoaderRoute: typeof AdministrationClientsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/imports/createretailerorders': {
      id: '/administration/imports/createretailerorders'
      path: '/administration/imports/createretailerorders'
      fullPath: '/administration/imports/createretailerorders'
      preLoaderRoute: typeof AdministrationImportsCreateretailerordersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/imports/importprices': {
      id: '/administration/imports/importprices'
      path: '/administration/imports/importprices'
      fullPath: '/administration/imports/importprices'
      preLoaderRoute: typeof AdministrationImportsImportpricesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/imports/importstockchanges': {
      id: '/administration/imports/importstockchanges'
      path: '/administration/imports/importstockchanges'
      fullPath: '/administration/imports/importstockchanges'
      preLoaderRoute: typeof AdministrationImportsImportstockchangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/imports/importtransaction': {
      id: '/administration/imports/importtransaction'
      path: '/administration/imports/importtransaction'
      fullPath: '/administration/imports/importtransaction'
      preLoaderRoute: typeof AdministrationImportsImporttransactionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/integrations/_webhooks': {
      id: '/administration/integrations/_webhooks'
      path: ''
      fullPath: '/administration/integrations'
      preLoaderRoute: typeof AdministrationIntegrationsWebhooksRouteImport
      parentRoute: typeof AdministrationIntegrationsRoute
    }
    '/administration/integrations/documentation': {
      id: '/administration/integrations/documentation'
      path: '/documentation'
      fullPath: '/administration/integrations/documentation'
      preLoaderRoute: typeof AdministrationIntegrationsDocumentationRouteImport
      parentRoute: typeof AdministrationIntegrationsRoute
    }
    '/administration/users/': {
      id: '/administration/users/'
      path: '/administration/users'
      fullPath: '/administration/users/'
      preLoaderRoute: typeof AdministrationUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/users/$id': {
      id: '/administration/users/$id'
      path: '/administration/users/$id'
      fullPath: '/administration/users/$id'
      preLoaderRoute: typeof AdministrationUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/$id/': {
      id: '/assets/$id/'
      path: '/'
      fullPath: '/assets/$id/'
      preLoaderRoute: typeof AssetsIdIndexRouteImport
      parentRoute: typeof AssetsIdRoute
    }
    '/assets/$id/connections': {
      id: '/assets/$id/connections'
      path: '/connections'
      fullPath: '/assets/$id/connections'
      preLoaderRoute: typeof AssetsIdConnectionsRouteImport
      parentRoute: typeof AssetsIdRoute
    }
    '/assets/$id/general': {
      id: '/assets/$id/general'
      path: '/general'
      fullPath: '/assets/$id/general'
      preLoaderRoute: typeof AssetsIdGeneralRouteImport
      parentRoute: typeof AssetsIdRoute
    }
    '/assets/$id/replace': {
      id: '/assets/$id/replace'
      path: '/replace'
      fullPath: '/assets/$id/replace'
      preLoaderRoute: typeof AssetsIdReplaceRouteImport
      parentRoute: typeof AssetsIdRoute
    }
    '/book/$workId/': {
      id: '/book/$workId/'
      path: '/book/$workId'
      fullPath: '/book/$workId/'
      preLoaderRoute: typeof BookWorkIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bundle/_main/create': {
      id: '/bundle/_main/create'
      path: '/create'
      fullPath: '/bundle/create'
      preLoaderRoute: typeof BundleMainCreateRouteImport
      parentRoute: typeof BundleMainRoute
    }
    '/concept/$conceptId/': {
      id: '/concept/$conceptId/'
      path: '/'
      fullPath: '/concept/$conceptId/'
      preLoaderRoute: typeof ConceptConceptIdIndexRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/approval': {
      id: '/concept/$conceptId/approval'
      path: '/approval'
      fullPath: '/concept/$conceptId/approval'
      preLoaderRoute: typeof ConceptConceptIdApprovalRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/baseInfo': {
      id: '/concept/$conceptId/baseInfo'
      path: '/baseInfo'
      fullPath: '/concept/$conceptId/baseInfo'
      preLoaderRoute: typeof ConceptConceptIdBaseInfoRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/calculations': {
      id: '/concept/$conceptId/calculations'
      path: '/calculations'
      fullPath: '/concept/$conceptId/calculations'
      preLoaderRoute: typeof ConceptConceptIdCalculationsRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/categorization': {
      id: '/concept/$conceptId/categorization'
      path: '/categorization'
      fullPath: '/concept/$conceptId/categorization'
      preLoaderRoute: typeof ConceptConceptIdCategorizationRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/cost': {
      id: '/concept/$conceptId/cost'
      path: '/cost'
      fullPath: '/concept/$conceptId/cost'
      preLoaderRoute: typeof ConceptConceptIdCostRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/detailedInfo': {
      id: '/concept/$conceptId/detailedInfo'
      path: '/detailedInfo'
      fullPath: '/concept/$conceptId/detailedInfo'
      preLoaderRoute: typeof ConceptConceptIdDetailedInfoRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/general': {
      id: '/concept/$conceptId/general'
      path: '/general'
      fullPath: '/concept/$conceptId/general'
      preLoaderRoute: typeof ConceptConceptIdGeneralRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/members': {
      id: '/concept/$conceptId/members'
      path: '/members'
      fullPath: '/concept/$conceptId/members'
      preLoaderRoute: typeof ConceptConceptIdMembersRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/notes': {
      id: '/concept/$conceptId/notes'
      path: '/notes'
      fullPath: '/concept/$conceptId/notes'
      preLoaderRoute: typeof ConceptConceptIdNotesRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/pre-calculation': {
      id: '/concept/$conceptId/pre-calculation'
      path: '/pre-calculation'
      fullPath: '/concept/$conceptId/pre-calculation'
      preLoaderRoute: typeof ConceptConceptIdPreCalculationRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/profitability': {
      id: '/concept/$conceptId/profitability'
      path: '/profitability'
      fullPath: '/concept/$conceptId/profitability'
      preLoaderRoute: typeof ConceptConceptIdProfitabilityRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/contact/$contactId/': {
      id: '/contact/$contactId/'
      path: '/'
      fullPath: '/contact/$contactId/'
      preLoaderRoute: typeof ContactContactIdIndexRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/addresses': {
      id: '/contact/$contactId/addresses'
      path: '/addresses'
      fullPath: '/contact/$contactId/addresses'
      preLoaderRoute: typeof ContactContactIdAddressesRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/agreements': {
      id: '/contact/$contactId/agreements'
      path: '/agreements'
      fullPath: '/contact/$contactId/agreements'
      preLoaderRoute: typeof ContactContactIdAgreementsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/assets': {
      id: '/contact/$contactId/assets'
      path: '/assets'
      fullPath: '/contact/$contactId/assets'
      preLoaderRoute: typeof ContactContactIdAssetsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/companycontacts': {
      id: '/contact/$contactId/companycontacts'
      path: '/companycontacts'
      fullPath: '/contact/$contactId/companycontacts'
      preLoaderRoute: typeof ContactContactIdCompanycontactsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/concepts': {
      id: '/contact/$contactId/concepts'
      path: '/concepts'
      fullPath: '/contact/$contactId/concepts'
      preLoaderRoute: typeof ContactContactIdConceptsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/details': {
      id: '/contact/$contactId/details'
      path: '/details'
      fullPath: '/contact/$contactId/details'
      preLoaderRoute: typeof ContactContactIdDetailsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/links': {
      id: '/contact/$contactId/links'
      path: '/links'
      fullPath: '/contact/$contactId/links'
      preLoaderRoute: typeof ContactContactIdLinksRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/lists': {
      id: '/contact/$contactId/lists'
      path: '/lists'
      fullPath: '/contact/$contactId/lists'
      preLoaderRoute: typeof ContactContactIdListsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/notes': {
      id: '/contact/$contactId/notes'
      path: '/notes'
      fullPath: '/contact/$contactId/notes'
      preLoaderRoute: typeof ContactContactIdNotesRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/productions': {
      id: '/contact/$contactId/productions'
      path: '/productions'
      fullPath: '/contact/$contactId/productions'
      preLoaderRoute: typeof ContactContactIdProductionsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/retailer': {
      id: '/contact/$contactId/retailer'
      path: '/retailer'
      fullPath: '/contact/$contactId/retailer'
      preLoaderRoute: typeof ContactContactIdRetailerRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/royalty': {
      id: '/contact/$contactId/royalty'
      path: '/royalty'
      fullPath: '/contact/$contactId/royalty'
      preLoaderRoute: typeof ContactContactIdRoyaltyRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/texts': {
      id: '/contact/$contactId/texts'
      path: '/texts'
      fullPath: '/contact/$contactId/texts'
      preLoaderRoute: typeof ContactContactIdTextsRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contact/$contactId/works': {
      id: '/contact/$contactId/works'
      path: '/works'
      fullPath: '/contact/$contactId/works'
      preLoaderRoute: typeof ContactContactIdWorksRouteImport
      parentRoute: typeof ContactContactIdRoute
    }
    '/contacts/list/$id': {
      id: '/contacts/list/$id'
      path: '/contacts/list/$id'
      fullPath: '/contacts/list/$id'
      preLoaderRoute: typeof ContactsListIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/royalty/errorlist/agreements': {
      id: '/royalty/errorlist/agreements'
      path: '/agreements'
      fullPath: '/royalty/errorlist/agreements'
      preLoaderRoute: typeof RoyaltyErrorlistAgreementsRouteImport
      parentRoute: typeof RoyaltyErrorlistRoute
    }
    '/royalty/errorlist/contacts': {
      id: '/royalty/errorlist/contacts'
      path: '/contacts'
      fullPath: '/royalty/errorlist/contacts'
      preLoaderRoute: typeof RoyaltyErrorlistContactsRouteImport
      parentRoute: typeof RoyaltyErrorlistRoute
    }
    '/royalty/errorlist/terms': {
      id: '/royalty/errorlist/terms'
      path: '/terms'
      fullPath: '/royalty/errorlist/terms'
      preLoaderRoute: typeof RoyaltyErrorlistTermsRouteImport
      parentRoute: typeof RoyaltyErrorlistRoute
    }
    '/royalty/errorlist/transactions': {
      id: '/royalty/errorlist/transactions'
      path: '/transactions'
      fullPath: '/royalty/errorlist/transactions'
      preLoaderRoute: typeof RoyaltyErrorlistTransactionsRouteImport
      parentRoute: typeof RoyaltyErrorlistRoute
    }
    '/royalty/paymentinformation/history': {
      id: '/royalty/paymentinformation/history'
      path: '/history'
      fullPath: '/royalty/paymentinformation/history'
      preLoaderRoute: typeof RoyaltyPaymentinformationHistoryRouteImport
      parentRoute: typeof RoyaltyPaymentinformationRoute
    }
    '/royalty/paymentinformation/upcoming': {
      id: '/royalty/paymentinformation/upcoming'
      path: '/upcoming'
      fullPath: '/royalty/paymentinformation/upcoming'
      preLoaderRoute: typeof RoyaltyPaymentinformationUpcomingRouteImport
      parentRoute: typeof RoyaltyPaymentinformationRoute
    }
    '/royalty/reports/advances': {
      id: '/royalty/reports/advances'
      path: '/advances'
      fullPath: '/royalty/reports/advances'
      preLoaderRoute: typeof RoyaltyReportsAdvancesRouteImport
      parentRoute: typeof RoyaltyReportsRoute
    }
    '/royalty/reports/agreements': {
      id: '/royalty/reports/agreements'
      path: '/agreements'
      fullPath: '/royalty/reports/agreements'
      preLoaderRoute: typeof RoyaltyReportsAgreementsRouteImport
      parentRoute: typeof RoyaltyReportsRoute
    }
    '/royalty/reports/settlements': {
      id: '/royalty/reports/settlements'
      path: '/settlements'
      fullPath: '/royalty/reports/settlements'
      preLoaderRoute: typeof RoyaltyReportsSettlementsRouteImport
      parentRoute: typeof RoyaltyReportsRoute
    }
    '/royalty/reports/terms': {
      id: '/royalty/reports/terms'
      path: '/terms'
      fullPath: '/royalty/reports/terms'
      preLoaderRoute: typeof RoyaltyReportsTermsRouteImport
      parentRoute: typeof RoyaltyReportsRoute
    }
    '/royalty/reports/upcoming-settlements': {
      id: '/royalty/reports/upcoming-settlements'
      path: '/upcoming-settlements'
      fullPath: '/royalty/reports/upcoming-settlements'
      preLoaderRoute: typeof RoyaltyReportsUpcomingSettlementsRouteImport
      parentRoute: typeof RoyaltyReportsRoute
    }
    '/royalty_/agreement/$id': {
      id: '/royalty_/agreement/$id'
      path: '/royalty/agreement/$id'
      fullPath: '/royalty/agreement/$id'
      preLoaderRoute: typeof RoyaltyAgreementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/series/list/': {
      id: '/series/list/'
      path: '/series/list'
      fullPath: '/series/list/'
      preLoaderRoute: typeof SeriesListIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/series/list/$serieId': {
      id: '/series/list/$serieId'
      path: '/series/list/$serieId'
      fullPath: '/series/list/$serieId'
      preLoaderRoute: typeof SeriesListSerieIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId/': {
      id: '/user/$userId/'
      path: '/'
      fullPath: '/user/$userId/'
      preLoaderRoute: typeof UserUserIdIndexRouteImport
      parentRoute: typeof UserUserIdRoute
    }
    '/user/$userId/access': {
      id: '/user/$userId/access'
      path: '/access'
      fullPath: '/user/$userId/access'
      preLoaderRoute: typeof UserUserIdAccessRouteImport
      parentRoute: typeof UserUserIdRoute
    }
    '/user/$userId/claims': {
      id: '/user/$userId/claims'
      path: '/claims'
      fullPath: '/user/$userId/claims'
      preLoaderRoute: typeof UserUserIdClaimsRouteImport
      parentRoute: typeof UserUserIdRoute
    }
    '/user/$userId/contacts': {
      id: '/user/$userId/contacts'
      path: '/contacts'
      fullPath: '/user/$userId/contacts'
      preLoaderRoute: typeof UserUserIdContactsRouteImport
      parentRoute: typeof UserUserIdRoute
    }
    '/user/$userId/general': {
      id: '/user/$userId/general'
      path: '/general'
      fullPath: '/user/$userId/general'
      preLoaderRoute: typeof UserUserIdGeneralRouteImport
      parentRoute: typeof UserUserIdRoute
    }
    '/work/$workId/': {
      id: '/work/$workId/'
      path: '/'
      fullPath: '/work/$workId/'
      preLoaderRoute: typeof WorkWorkIdIndexRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/assets': {
      id: '/work/$workId/assets'
      path: '/assets'
      fullPath: '/work/$workId/assets'
      preLoaderRoute: typeof WorkWorkIdAssetsRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/calculation': {
      id: '/work/$workId/calculation'
      path: '/calculation'
      fullPath: '/work/$workId/calculation'
      preLoaderRoute: typeof WorkWorkIdCalculationRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/categorization': {
      id: '/work/$workId/categorization'
      path: '/categorization'
      fullPath: '/work/$workId/categorization'
      preLoaderRoute: typeof WorkWorkIdCategorizationRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/contracts': {
      id: '/work/$workId/contracts'
      path: '/contracts'
      fullPath: '/work/$workId/contracts'
      preLoaderRoute: typeof WorkWorkIdContractsRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/corrections': {
      id: '/work/$workId/corrections'
      path: '/corrections'
      fullPath: '/work/$workId/corrections'
      preLoaderRoute: typeof WorkWorkIdCorrectionsRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/costs': {
      id: '/work/$workId/costs'
      path: '/costs'
      fullPath: '/work/$workId/costs'
      preLoaderRoute: typeof WorkWorkIdCostsRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/launch-brief': {
      id: '/work/$workId/launch-brief'
      path: '/launch-brief'
      fullPath: '/work/$workId/launch-brief'
      preLoaderRoute: typeof WorkWorkIdLaunchBriefRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/misc': {
      id: '/work/$workId/misc'
      path: '/misc'
      fullPath: '/work/$workId/misc'
      preLoaderRoute: typeof WorkWorkIdMiscRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/productions': {
      id: '/work/$workId/productions'
      path: '/productions'
      fullPath: '/work/$workId/productions'
      preLoaderRoute: typeof WorkWorkIdProductionsRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/profitability': {
      id: '/work/$workId/profitability'
      path: '/profitability'
      fullPath: '/work/$workId/profitability'
      preLoaderRoute: typeof WorkWorkIdProfitabilityRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/review-quotes': {
      id: '/work/$workId/review-quotes'
      path: '/review-quotes'
      fullPath: '/work/$workId/review-quotes'
      preLoaderRoute: typeof WorkWorkIdReviewQuotesRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/rights': {
      id: '/work/$workId/rights'
      path: '/rights'
      fullPath: '/work/$workId/rights'
      preLoaderRoute: typeof WorkWorkIdRightsRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/royalty': {
      id: '/work/$workId/royalty'
      path: '/royalty'
      fullPath: '/work/$workId/royalty'
      preLoaderRoute: typeof WorkWorkIdRoyaltyRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId/team': {
      id: '/work/$workId/team'
      path: '/team'
      fullPath: '/work/$workId/team'
      preLoaderRoute: typeof WorkWorkIdTeamRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/activities/': {
      id: '/work/activities/'
      path: '/work/activities'
      fullPath: '/work/activities/'
      preLoaderRoute: typeof WorkActivitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work/activities/$activityId': {
      id: '/work/activities/$activityId'
      path: '/work/activities/$activityId'
      fullPath: '/work/activities/$activityId'
      preLoaderRoute: typeof WorkActivitiesActivityIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/users/$id/': {
      id: '/administration/users/$id/'
      path: '/'
      fullPath: '/administration/users/$id/'
      preLoaderRoute: typeof AdministrationUsersIdIndexRouteImport
      parentRoute: typeof AdministrationUsersIdRoute
    }
    '/administration/users/$id/access': {
      id: '/administration/users/$id/access'
      path: '/access'
      fullPath: '/administration/users/$id/access'
      preLoaderRoute: typeof AdministrationUsersIdAccessRouteImport
      parentRoute: typeof AdministrationUsersIdRoute
    }
    '/administration/users/$id/general': {
      id: '/administration/users/$id/general'
      path: '/general'
      fullPath: '/administration/users/$id/general'
      preLoaderRoute: typeof AdministrationUsersIdGeneralRouteImport
      parentRoute: typeof AdministrationUsersIdRoute
    }
    '/book/$workId/edition/$editionId': {
      id: '/book/$workId/edition/$editionId'
      path: '/book/$workId/edition/$editionId'
      fullPath: '/book/$workId/edition/$editionId'
      preLoaderRoute: typeof BookWorkIdEditionEditionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bundle/_main/edit/$productId': {
      id: '/bundle/_main/edit/$productId'
      path: '/edit/$productId'
      fullPath: '/bundle/edit/$productId'
      preLoaderRoute: typeof BundleMainEditProductIdRouteImport
      parentRoute: typeof BundleMainRoute
    }
    '/bundle/_main/erp/$productId': {
      id: '/bundle/_main/erp/$productId'
      path: '/erp/$productId'
      fullPath: '/bundle/erp/$productId'
      preLoaderRoute: typeof BundleMainErpProductIdRouteImport
      parentRoute: typeof BundleMainRoute
    }
    '/concept/$conceptId/productions/': {
      id: '/concept/$conceptId/productions/'
      path: '/productions'
      fullPath: '/concept/$conceptId/productions/'
      preLoaderRoute: typeof ConceptConceptIdProductionsIndexRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/concept/$conceptId/productions/$productionId': {
      id: '/concept/$conceptId/productions/$productionId'
      path: '/productions/$productionId'
      fullPath: '/concept/$conceptId/productions/$productionId'
      preLoaderRoute: typeof ConceptConceptIdProductionsProductionIdRouteImport
      parentRoute: typeof ConceptConceptIdRoute
    }
    '/integrations/_webhooks/webhook/': {
      id: '/integrations/_webhooks/webhook/'
      path: '/webhook'
      fullPath: '/integrations/webhook/'
      preLoaderRoute: typeof IntegrationsWebhooksWebhookIndexRouteImport
      parentRoute: typeof IntegrationsWebhooksRoute
    }
    '/integrations/_webhooks/webhook/events': {
      id: '/integrations/_webhooks/webhook/events'
      path: '/webhook/events'
      fullPath: '/integrations/webhook/events'
      preLoaderRoute: typeof IntegrationsWebhooksWebhookEventsRouteImport
      parentRoute: typeof IntegrationsWebhooksRoute
    }
    '/integrations/_webhooks/webhook/subscribers': {
      id: '/integrations/_webhooks/webhook/subscribers'
      path: '/webhook/subscribers'
      fullPath: '/integrations/webhook/subscribers'
      preLoaderRoute: typeof IntegrationsWebhooksWebhookSubscribersRouteImport
      parentRoute: typeof IntegrationsWebhooksRoute
    }
    '/integrations/_webhooks/webhook/token-configurations': {
      id: '/integrations/_webhooks/webhook/token-configurations'
      path: '/webhook/token-configurations'
      fullPath: '/integrations/webhook/token-configurations'
      preLoaderRoute: typeof IntegrationsWebhooksWebhookTokenConfigurationsRouteImport
      parentRoute: typeof IntegrationsWebhooksRoute
    }
    '/royalty_/agreement/$id/general': {
      id: '/royalty_/agreement/$id/general'
      path: '/general'
      fullPath: '/royalty/agreement/$id/general'
      preLoaderRoute: typeof RoyaltyAgreementIdGeneralRouteImport
      parentRoute: typeof RoyaltyAgreementIdRoute
    }
    '/royalty_/agreement/$id/transactions': {
      id: '/royalty_/agreement/$id/transactions'
      path: '/transactions'
      fullPath: '/royalty/agreement/$id/transactions'
      preLoaderRoute: typeof RoyaltyAgreementIdTransactionsRouteImport
      parentRoute: typeof RoyaltyAgreementIdRoute
    }
    '/work/$workId/launch-plan/': {
      id: '/work/$workId/launch-plan/'
      path: '/launch-plan'
      fullPath: '/work/$workId/launch-plan/'
      preLoaderRoute: typeof WorkWorkIdLaunchPlanIndexRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId_/edition/$editionId': {
      id: '/work/$workId_/edition/$editionId'
      path: '/work/$workId/edition/$editionId'
      fullPath: '/work/$workId/edition/$editionId'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/integrations/_webhooks/webhook/': {
      id: '/administration/integrations/_webhooks/webhook/'
      path: '/webhook'
      fullPath: '/administration/integrations/webhook/'
      preLoaderRoute: typeof AdministrationIntegrationsWebhooksWebhookIndexRouteImport
      parentRoute: typeof AdministrationIntegrationsWebhooksRoute
    }
    '/administration/integrations/_webhooks/webhook/events': {
      id: '/administration/integrations/_webhooks/webhook/events'
      path: '/webhook/events'
      fullPath: '/administration/integrations/webhook/events'
      preLoaderRoute: typeof AdministrationIntegrationsWebhooksWebhookEventsRouteImport
      parentRoute: typeof AdministrationIntegrationsWebhooksRoute
    }
    '/administration/integrations/_webhooks/webhook/subscribers': {
      id: '/administration/integrations/_webhooks/webhook/subscribers'
      path: '/webhook/subscribers'
      fullPath: '/administration/integrations/webhook/subscribers'
      preLoaderRoute: typeof AdministrationIntegrationsWebhooksWebhookSubscribersRouteImport
      parentRoute: typeof AdministrationIntegrationsWebhooksRoute
    }
    '/administration/integrations/_webhooks/webhook/token-configurations': {
      id: '/administration/integrations/_webhooks/webhook/token-configurations'
      path: '/webhook/token-configurations'
      fullPath: '/administration/integrations/webhook/token-configurations'
      preLoaderRoute: typeof AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRouteImport
      parentRoute: typeof AdministrationIntegrationsWebhooksRoute
    }
    '/royalty_/agreement/$id/settlements/': {
      id: '/royalty_/agreement/$id/settlements/'
      path: '/settlements'
      fullPath: '/royalty/agreement/$id/settlements/'
      preLoaderRoute: typeof RoyaltyAgreementIdSettlementsIndexRouteImport
      parentRoute: typeof RoyaltyAgreementIdRoute
    }
    '/royalty_/agreement/$id/terms/': {
      id: '/royalty_/agreement/$id/terms/'
      path: '/terms'
      fullPath: '/royalty/agreement/$id/terms/'
      preLoaderRoute: typeof RoyaltyAgreementIdTermsIndexRouteImport
      parentRoute: typeof RoyaltyAgreementIdRoute
    }
    '/work/$workId/launch-plan/activity/$activityId': {
      id: '/work/$workId/launch-plan/activity/$activityId'
      path: '/launch-plan/activity/$activityId'
      fullPath: '/work/$workId/launch-plan/activity/$activityId'
      preLoaderRoute: typeof WorkWorkIdLaunchPlanActivityActivityIdRouteImport
      parentRoute: typeof WorkWorkIdRoute
    }
    '/work/$workId_/edition/$editionId/': {
      id: '/work/$workId_/edition/$editionId/'
      path: '/'
      fullPath: '/work/$workId/edition/$editionId/'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdIndexRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/assets': {
      id: '/work/$workId_/edition/$editionId/assets'
      path: '/assets'
      fullPath: '/work/$workId/edition/$editionId/assets'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdAssetsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/comments': {
      id: '/work/$workId_/edition/$editionId/comments'
      path: '/comments'
      fullPath: '/work/$workId/edition/$editionId/comments'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdCommentsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/content-categorization': {
      id: '/work/$workId_/edition/$editionId/content-categorization'
      path: '/content-categorization'
      fullPath: '/work/$workId/edition/$editionId/content-categorization'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdContentCategorizationRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/content-editorial': {
      id: '/work/$workId_/edition/$editionId/content-editorial'
      path: '/content-editorial'
      fullPath: '/work/$workId/edition/$editionId/content-editorial'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdContentEditorialRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/content-education': {
      id: '/work/$workId_/edition/$editionId/content-education'
      path: '/content-education'
      fullPath: '/work/$workId/edition/$editionId/content-education'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdContentEducationRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/content-links': {
      id: '/work/$workId_/edition/$editionId/content-links'
      path: '/content-links'
      fullPath: '/work/$workId/edition/$editionId/content-links'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdContentLinksRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/content-press-sales': {
      id: '/work/$workId_/edition/$editionId/content-press-sales'
      path: '/content-press-sales'
      fullPath: '/work/$workId/edition/$editionId/content-press-sales'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdContentPressSalesRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/content-title-portrait': {
      id: '/work/$workId_/edition/$editionId/content-title-portrait'
      path: '/content-title-portrait'
      fullPath: '/work/$workId/edition/$editionId/content-title-portrait'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdContentTitlePortraitRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/copyproduction': {
      id: '/work/$workId_/edition/$editionId/copyproduction'
      path: '/copyproduction'
      fullPath: '/work/$workId/edition/$editionId/copyproduction'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdCopyproductionRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/copytechnicalproduction': {
      id: '/work/$workId_/edition/$editionId/copytechnicalproduction'
      path: '/copytechnicalproduction'
      fullPath: '/work/$workId/edition/$editionId/copytechnicalproduction'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdCopytechnicalproductionRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/distribution': {
      id: '/work/$workId_/edition/$editionId/distribution'
      path: '/distribution'
      fullPath: '/work/$workId/edition/$editionId/distribution'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdDistributionRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/distribution-logs': {
      id: '/work/$workId_/edition/$editionId/distribution-logs'
      path: '/distribution-logs'
      fullPath: '/work/$workId/edition/$editionId/distribution-logs'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdDistributionLogsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/erp': {
      id: '/work/$workId_/edition/$editionId/erp'
      path: '/erp'
      fullPath: '/work/$workId/edition/$editionId/erp'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdErpRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-bookclubs': {
      id: '/work/$workId_/edition/$editionId/general-bookclubs'
      path: '/general-bookclubs'
      fullPath: '/work/$workId/edition/$editionId/general-bookclubs'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralBookclubsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-costs': {
      id: '/work/$workId_/edition/$editionId/general-costs'
      path: '/general-costs'
      fullPath: '/work/$workId/edition/$editionId/general-costs'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralCostsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-misc': {
      id: '/work/$workId_/edition/$editionId/general-misc'
      path: '/general-misc'
      fullPath: '/work/$workId/edition/$editionId/general-misc'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralMiscRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-price-and-cost': {
      id: '/work/$workId_/edition/$editionId/general-price-and-cost'
      path: '/general-price-and-cost'
      fullPath: '/work/$workId/edition/$editionId/general-price-and-cost'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralPriceAndCostRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-printrun': {
      id: '/work/$workId_/edition/$editionId/general-printrun'
      path: '/general-printrun'
      fullPath: '/work/$workId/edition/$editionId/general-printrun'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralPrintrunRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-rights': {
      id: '/work/$workId_/edition/$editionId/general-rights'
      path: '/general-rights'
      fullPath: '/work/$workId/edition/$editionId/general-rights'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralRightsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-royalty-levels': {
      id: '/work/$workId_/edition/$editionId/general-royalty-levels'
      path: '/general-royalty-levels'
      fullPath: '/work/$workId/edition/$editionId/general-royalty-levels'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-sales': {
      id: '/work/$workId_/edition/$editionId/general-sales'
      path: '/general-sales'
      fullPath: '/work/$workId/edition/$editionId/general-sales'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralSalesRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/general-schedule': {
      id: '/work/$workId_/edition/$editionId/general-schedule'
      path: '/general-schedule'
      fullPath: '/work/$workId/edition/$editionId/general-schedule'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdGeneralScheduleRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/layout': {
      id: '/work/$workId_/edition/$editionId/layout'
      path: '/layout'
      fullPath: '/work/$workId/edition/$editionId/layout'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdLayoutRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/layout-binding': {
      id: '/work/$workId_/edition/$editionId/layout-binding'
      path: '/layout-binding'
      fullPath: '/work/$workId/edition/$editionId/layout-binding'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdLayoutBindingRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/layout-composition': {
      id: '/work/$workId_/edition/$editionId/layout-composition'
      path: '/layout-composition'
      fullPath: '/work/$workId/edition/$editionId/layout-composition'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdLayoutCompositionRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/layout-cover': {
      id: '/work/$workId_/edition/$editionId/layout-cover'
      path: '/layout-cover'
      fullPath: '/work/$workId/edition/$editionId/layout-cover'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdLayoutCoverRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/layout-inside': {
      id: '/work/$workId_/edition/$editionId/layout-inside'
      path: '/layout-inside'
      fullPath: '/work/$workId/edition/$editionId/layout-inside'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdLayoutInsideRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/layout-measurements': {
      id: '/work/$workId_/edition/$editionId/layout-measurements'
      path: '/layout-measurements'
      fullPath: '/work/$workId/edition/$editionId/layout-measurements'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdLayoutMeasurementsRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/layout-technicalproduction': {
      id: '/work/$workId_/edition/$editionId/layout-technicalproduction'
      path: '/layout-technicalproduction'
      fullPath: '/work/$workId/edition/$editionId/layout-technicalproduction'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdLayoutTechnicalproductionRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/print-orders': {
      id: '/work/$workId_/edition/$editionId/print-orders'
      path: '/print-orders'
      fullPath: '/work/$workId/edition/$editionId/print-orders'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdPrintOrdersRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/printchanges': {
      id: '/work/$workId_/edition/$editionId/printchanges'
      path: '/printchanges'
      fullPath: '/work/$workId/edition/$editionId/printchanges'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdPrintchangesRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/profitability': {
      id: '/work/$workId_/edition/$editionId/profitability'
      path: '/profitability'
      fullPath: '/work/$workId/edition/$editionId/profitability'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdProfitabilityRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/publish': {
      id: '/work/$workId_/edition/$editionId/publish'
      path: '/publish'
      fullPath: '/work/$workId/edition/$editionId/publish'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdPublishRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/team': {
      id: '/work/$workId_/edition/$editionId/team'
      path: '/team'
      fullPath: '/work/$workId/edition/$editionId/team'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdTeamRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/technicaldescription': {
      id: '/work/$workId_/edition/$editionId/technicaldescription'
      path: '/technicaldescription'
      fullPath: '/work/$workId/edition/$editionId/technicaldescription'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdTechnicaldescriptionRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/work/$workId_/edition/$editionId/unpublish': {
      id: '/work/$workId_/edition/$editionId/unpublish'
      path: '/unpublish'
      fullPath: '/work/$workId/edition/$editionId/unpublish'
      preLoaderRoute: typeof WorkWorkIdEditionEditionIdUnpublishRouteImport
      parentRoute: typeof WorkWorkIdEditionEditionIdRoute
    }
    '/royalty_/agreement/$id/terms/$ruleSetId/version/$ruleId': {
      id: '/royalty_/agreement/$id/terms/$ruleSetId/version/$ruleId'
      path: '/terms/$ruleSetId/version/$ruleId'
      fullPath: '/royalty/agreement/$id/terms/$ruleSetId/version/$ruleId'
      preLoaderRoute: typeof RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRouteImport
      parentRoute: typeof RoyaltyAgreementIdRoute
    }
    '/royalty_/agreement/$id/settlements/$settlementId/receiver/$contactId/$status': {
      id: '/royalty_/agreement/$id/settlements/$settlementId/receiver/$contactId/$status'
      path: '/settlements/$settlementId/receiver/$contactId/$status'
      fullPath: '/royalty/agreement/$id/settlements/$settlementId/receiver/$contactId/$status'
      preLoaderRoute: typeof RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRouteImport
      parentRoute: typeof RoyaltyAgreementIdRoute
    }
  }
}

interface EditionsearchRouteChildren {
  EditionsearchWorkEditionsRoute: typeof EditionsearchWorkEditionsRoute
  EditionsearchWorkSalessheetRoute: typeof EditionsearchWorkSalessheetRoute
}

const EditionsearchRouteChildren: EditionsearchRouteChildren = {
  EditionsearchWorkEditionsRoute: EditionsearchWorkEditionsRoute,
  EditionsearchWorkSalessheetRoute: EditionsearchWorkSalessheetRoute,
}

const EditionsearchRouteWithChildren = EditionsearchRoute._addFileChildren(
  EditionsearchRouteChildren,
)

interface WorksearchRouteChildren {
  WorksearchWorksRoute: typeof WorksearchWorksRoute
  WorksearchWorkLaunchbriefRoute: typeof WorksearchWorkLaunchbriefRoute
}

const WorksearchRouteChildren: WorksearchRouteChildren = {
  WorksearchWorksRoute: WorksearchWorksRoute,
  WorksearchWorkLaunchbriefRoute: WorksearchWorkLaunchbriefRoute,
}

const WorksearchRouteWithChildren = WorksearchRoute._addFileChildren(
  WorksearchRouteChildren,
)

interface AdminRouteChildren {
  AdminCosttypesRoute: typeof AdminCosttypesRoute
  AdminEanseriesRoute: typeof AdminEanseriesRoute
  AdminEmailtemplatesRoute: typeof AdminEmailtemplatesRoute
  AdminPrinterpricesRoute: typeof AdminPrinterpricesRoute
  AdminProductionPlansRoute: typeof AdminProductionPlansRoute
  AdminRoyaltyPriceRulesRoute: typeof AdminRoyaltyPriceRulesRoute
  AdminRoyaltySalesChannelsRoute: typeof AdminRoyaltySalesChannelsRoute
  AdminTagsRoute: typeof AdminTagsRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCosttypesRoute: AdminCosttypesRoute,
  AdminEanseriesRoute: AdminEanseriesRoute,
  AdminEmailtemplatesRoute: AdminEmailtemplatesRoute,
  AdminPrinterpricesRoute: AdminPrinterpricesRoute,
  AdminProductionPlansRoute: AdminProductionPlansRoute,
  AdminRoyaltyPriceRulesRoute: AdminRoyaltyPriceRulesRoute,
  AdminRoyaltySalesChannelsRoute: AdminRoyaltySalesChannelsRoute,
  AdminTagsRoute: AdminTagsRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ImportsRouteChildren {
  ImportsCreateretailerordersRoute: typeof ImportsCreateretailerordersRoute
  ImportsImportpricesRoute: typeof ImportsImportpricesRoute
  ImportsImportstockchangesRoute: typeof ImportsImportstockchangesRoute
  ImportsImporttransactionRoute: typeof ImportsImporttransactionRoute
}

const ImportsRouteChildren: ImportsRouteChildren = {
  ImportsCreateretailerordersRoute: ImportsCreateretailerordersRoute,
  ImportsImportpricesRoute: ImportsImportpricesRoute,
  ImportsImportstockchangesRoute: ImportsImportstockchangesRoute,
  ImportsImporttransactionRoute: ImportsImporttransactionRoute,
}

const ImportsRouteWithChildren =
  ImportsRoute._addFileChildren(ImportsRouteChildren)

interface IntegrationsWebhooksRouteChildren {
  IntegrationsWebhooksWebhookEventsRoute: typeof IntegrationsWebhooksWebhookEventsRoute
  IntegrationsWebhooksWebhookSubscribersRoute: typeof IntegrationsWebhooksWebhookSubscribersRoute
  IntegrationsWebhooksWebhookTokenConfigurationsRoute: typeof IntegrationsWebhooksWebhookTokenConfigurationsRoute
  IntegrationsWebhooksWebhookIndexRoute: typeof IntegrationsWebhooksWebhookIndexRoute
}

const IntegrationsWebhooksRouteChildren: IntegrationsWebhooksRouteChildren = {
  IntegrationsWebhooksWebhookEventsRoute:
    IntegrationsWebhooksWebhookEventsRoute,
  IntegrationsWebhooksWebhookSubscribersRoute:
    IntegrationsWebhooksWebhookSubscribersRoute,
  IntegrationsWebhooksWebhookTokenConfigurationsRoute:
    IntegrationsWebhooksWebhookTokenConfigurationsRoute,
  IntegrationsWebhooksWebhookIndexRoute: IntegrationsWebhooksWebhookIndexRoute,
}

const IntegrationsWebhooksRouteWithChildren =
  IntegrationsWebhooksRoute._addFileChildren(IntegrationsWebhooksRouteChildren)

interface IntegrationsRouteChildren {
  IntegrationsWebhooksRoute: typeof IntegrationsWebhooksRouteWithChildren
  IntegrationsDocumentationRoute: typeof IntegrationsDocumentationRoute
}

const IntegrationsRouteChildren: IntegrationsRouteChildren = {
  IntegrationsWebhooksRoute: IntegrationsWebhooksRouteWithChildren,
  IntegrationsDocumentationRoute: IntegrationsDocumentationRoute,
}

const IntegrationsRouteWithChildren = IntegrationsRoute._addFileChildren(
  IntegrationsRouteChildren,
)

interface MetadataRouteChildren {
  MetadataMetaDataTypeIdRoute: typeof MetadataMetaDataTypeIdRoute
}

const MetadataRouteChildren: MetadataRouteChildren = {
  MetadataMetaDataTypeIdRoute: MetadataMetaDataTypeIdRoute,
}

const MetadataRouteWithChildren = MetadataRoute._addFileChildren(
  MetadataRouteChildren,
)

interface RoyaltyErrorlistRouteChildren {
  RoyaltyErrorlistAgreementsRoute: typeof RoyaltyErrorlistAgreementsRoute
  RoyaltyErrorlistContactsRoute: typeof RoyaltyErrorlistContactsRoute
  RoyaltyErrorlistTermsRoute: typeof RoyaltyErrorlistTermsRoute
  RoyaltyErrorlistTransactionsRoute: typeof RoyaltyErrorlistTransactionsRoute
}

const RoyaltyErrorlistRouteChildren: RoyaltyErrorlistRouteChildren = {
  RoyaltyErrorlistAgreementsRoute: RoyaltyErrorlistAgreementsRoute,
  RoyaltyErrorlistContactsRoute: RoyaltyErrorlistContactsRoute,
  RoyaltyErrorlistTermsRoute: RoyaltyErrorlistTermsRoute,
  RoyaltyErrorlistTransactionsRoute: RoyaltyErrorlistTransactionsRoute,
}

const RoyaltyErrorlistRouteWithChildren =
  RoyaltyErrorlistRoute._addFileChildren(RoyaltyErrorlistRouteChildren)

interface RoyaltyPaymentinformationRouteChildren {
  RoyaltyPaymentinformationHistoryRoute: typeof RoyaltyPaymentinformationHistoryRoute
  RoyaltyPaymentinformationUpcomingRoute: typeof RoyaltyPaymentinformationUpcomingRoute
}

const RoyaltyPaymentinformationRouteChildren: RoyaltyPaymentinformationRouteChildren =
  {
    RoyaltyPaymentinformationHistoryRoute:
      RoyaltyPaymentinformationHistoryRoute,
    RoyaltyPaymentinformationUpcomingRoute:
      RoyaltyPaymentinformationUpcomingRoute,
  }

const RoyaltyPaymentinformationRouteWithChildren =
  RoyaltyPaymentinformationRoute._addFileChildren(
    RoyaltyPaymentinformationRouteChildren,
  )

interface RoyaltyReportsRouteChildren {
  RoyaltyReportsAdvancesRoute: typeof RoyaltyReportsAdvancesRoute
  RoyaltyReportsAgreementsRoute: typeof RoyaltyReportsAgreementsRoute
  RoyaltyReportsSettlementsRoute: typeof RoyaltyReportsSettlementsRoute
  RoyaltyReportsTermsRoute: typeof RoyaltyReportsTermsRoute
  RoyaltyReportsUpcomingSettlementsRoute: typeof RoyaltyReportsUpcomingSettlementsRoute
}

const RoyaltyReportsRouteChildren: RoyaltyReportsRouteChildren = {
  RoyaltyReportsAdvancesRoute: RoyaltyReportsAdvancesRoute,
  RoyaltyReportsAgreementsRoute: RoyaltyReportsAgreementsRoute,
  RoyaltyReportsSettlementsRoute: RoyaltyReportsSettlementsRoute,
  RoyaltyReportsTermsRoute: RoyaltyReportsTermsRoute,
  RoyaltyReportsUpcomingSettlementsRoute:
    RoyaltyReportsUpcomingSettlementsRoute,
}

const RoyaltyReportsRouteWithChildren = RoyaltyReportsRoute._addFileChildren(
  RoyaltyReportsRouteChildren,
)

interface RoyaltyRouteChildren {
  RoyaltyAgreementsRoute: typeof RoyaltyAgreementsRoute
  RoyaltyBackgroundjobsRoute: typeof RoyaltyBackgroundjobsRoute
  RoyaltyErrorlistRoute: typeof RoyaltyErrorlistRouteWithChildren
  RoyaltyPaymentinformationRoute: typeof RoyaltyPaymentinformationRouteWithChildren
  RoyaltyReportsRoute: typeof RoyaltyReportsRouteWithChildren
  RoyaltyStatementsRoute: typeof RoyaltyStatementsRoute
}

const RoyaltyRouteChildren: RoyaltyRouteChildren = {
  RoyaltyAgreementsRoute: RoyaltyAgreementsRoute,
  RoyaltyBackgroundjobsRoute: RoyaltyBackgroundjobsRoute,
  RoyaltyErrorlistRoute: RoyaltyErrorlistRouteWithChildren,
  RoyaltyPaymentinformationRoute: RoyaltyPaymentinformationRouteWithChildren,
  RoyaltyReportsRoute: RoyaltyReportsRouteWithChildren,
  RoyaltyStatementsRoute: RoyaltyStatementsRoute,
}

const RoyaltyRouteWithChildren =
  RoyaltyRoute._addFileChildren(RoyaltyRouteChildren)

interface AdministrationIntegrationsWebhooksRouteChildren {
  AdministrationIntegrationsWebhooksWebhookEventsRoute: typeof AdministrationIntegrationsWebhooksWebhookEventsRoute
  AdministrationIntegrationsWebhooksWebhookSubscribersRoute: typeof AdministrationIntegrationsWebhooksWebhookSubscribersRoute
  AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute: typeof AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute
  AdministrationIntegrationsWebhooksWebhookIndexRoute: typeof AdministrationIntegrationsWebhooksWebhookIndexRoute
}

const AdministrationIntegrationsWebhooksRouteChildren: AdministrationIntegrationsWebhooksRouteChildren =
  {
    AdministrationIntegrationsWebhooksWebhookEventsRoute:
      AdministrationIntegrationsWebhooksWebhookEventsRoute,
    AdministrationIntegrationsWebhooksWebhookSubscribersRoute:
      AdministrationIntegrationsWebhooksWebhookSubscribersRoute,
    AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute:
      AdministrationIntegrationsWebhooksWebhookTokenConfigurationsRoute,
    AdministrationIntegrationsWebhooksWebhookIndexRoute:
      AdministrationIntegrationsWebhooksWebhookIndexRoute,
  }

const AdministrationIntegrationsWebhooksRouteWithChildren =
  AdministrationIntegrationsWebhooksRoute._addFileChildren(
    AdministrationIntegrationsWebhooksRouteChildren,
  )

interface AdministrationIntegrationsRouteChildren {
  AdministrationIntegrationsWebhooksRoute: typeof AdministrationIntegrationsWebhooksRouteWithChildren
  AdministrationIntegrationsDocumentationRoute: typeof AdministrationIntegrationsDocumentationRoute
}

const AdministrationIntegrationsRouteChildren: AdministrationIntegrationsRouteChildren =
  {
    AdministrationIntegrationsWebhooksRoute:
      AdministrationIntegrationsWebhooksRouteWithChildren,
    AdministrationIntegrationsDocumentationRoute:
      AdministrationIntegrationsDocumentationRoute,
  }

const AdministrationIntegrationsRouteWithChildren =
  AdministrationIntegrationsRoute._addFileChildren(
    AdministrationIntegrationsRouteChildren,
  )

interface AssetsIdRouteChildren {
  AssetsIdConnectionsRoute: typeof AssetsIdConnectionsRoute
  AssetsIdGeneralRoute: typeof AssetsIdGeneralRoute
  AssetsIdReplaceRoute: typeof AssetsIdReplaceRoute
  AssetsIdIndexRoute: typeof AssetsIdIndexRoute
}

const AssetsIdRouteChildren: AssetsIdRouteChildren = {
  AssetsIdConnectionsRoute: AssetsIdConnectionsRoute,
  AssetsIdGeneralRoute: AssetsIdGeneralRoute,
  AssetsIdReplaceRoute: AssetsIdReplaceRoute,
  AssetsIdIndexRoute: AssetsIdIndexRoute,
}

const AssetsIdRouteWithChildren = AssetsIdRoute._addFileChildren(
  AssetsIdRouteChildren,
)

interface BundleMainRouteChildren {
  BundleMainCreateRoute: typeof BundleMainCreateRoute
  BundleMainEditProductIdRoute: typeof BundleMainEditProductIdRoute
  BundleMainErpProductIdRoute: typeof BundleMainErpProductIdRoute
}

const BundleMainRouteChildren: BundleMainRouteChildren = {
  BundleMainCreateRoute: BundleMainCreateRoute,
  BundleMainEditProductIdRoute: BundleMainEditProductIdRoute,
  BundleMainErpProductIdRoute: BundleMainErpProductIdRoute,
}

const BundleMainRouteWithChildren = BundleMainRoute._addFileChildren(
  BundleMainRouteChildren,
)

interface ConceptConceptIdRouteChildren {
  ConceptConceptIdApprovalRoute: typeof ConceptConceptIdApprovalRoute
  ConceptConceptIdBaseInfoRoute: typeof ConceptConceptIdBaseInfoRoute
  ConceptConceptIdCalculationsRoute: typeof ConceptConceptIdCalculationsRoute
  ConceptConceptIdCategorizationRoute: typeof ConceptConceptIdCategorizationRoute
  ConceptConceptIdCostRoute: typeof ConceptConceptIdCostRoute
  ConceptConceptIdDetailedInfoRoute: typeof ConceptConceptIdDetailedInfoRoute
  ConceptConceptIdGeneralRoute: typeof ConceptConceptIdGeneralRoute
  ConceptConceptIdMembersRoute: typeof ConceptConceptIdMembersRoute
  ConceptConceptIdNotesRoute: typeof ConceptConceptIdNotesRoute
  ConceptConceptIdPreCalculationRoute: typeof ConceptConceptIdPreCalculationRoute
  ConceptConceptIdProfitabilityRoute: typeof ConceptConceptIdProfitabilityRoute
  ConceptConceptIdIndexRoute: typeof ConceptConceptIdIndexRoute
  ConceptConceptIdProductionsProductionIdRoute: typeof ConceptConceptIdProductionsProductionIdRoute
  ConceptConceptIdProductionsIndexRoute: typeof ConceptConceptIdProductionsIndexRoute
}

const ConceptConceptIdRouteChildren: ConceptConceptIdRouteChildren = {
  ConceptConceptIdApprovalRoute: ConceptConceptIdApprovalRoute,
  ConceptConceptIdBaseInfoRoute: ConceptConceptIdBaseInfoRoute,
  ConceptConceptIdCalculationsRoute: ConceptConceptIdCalculationsRoute,
  ConceptConceptIdCategorizationRoute: ConceptConceptIdCategorizationRoute,
  ConceptConceptIdCostRoute: ConceptConceptIdCostRoute,
  ConceptConceptIdDetailedInfoRoute: ConceptConceptIdDetailedInfoRoute,
  ConceptConceptIdGeneralRoute: ConceptConceptIdGeneralRoute,
  ConceptConceptIdMembersRoute: ConceptConceptIdMembersRoute,
  ConceptConceptIdNotesRoute: ConceptConceptIdNotesRoute,
  ConceptConceptIdPreCalculationRoute: ConceptConceptIdPreCalculationRoute,
  ConceptConceptIdProfitabilityRoute: ConceptConceptIdProfitabilityRoute,
  ConceptConceptIdIndexRoute: ConceptConceptIdIndexRoute,
  ConceptConceptIdProductionsProductionIdRoute:
    ConceptConceptIdProductionsProductionIdRoute,
  ConceptConceptIdProductionsIndexRoute: ConceptConceptIdProductionsIndexRoute,
}

const ConceptConceptIdRouteWithChildren =
  ConceptConceptIdRoute._addFileChildren(ConceptConceptIdRouteChildren)

interface ContactContactIdRouteChildren {
  ContactContactIdAddressesRoute: typeof ContactContactIdAddressesRoute
  ContactContactIdAgreementsRoute: typeof ContactContactIdAgreementsRoute
  ContactContactIdAssetsRoute: typeof ContactContactIdAssetsRoute
  ContactContactIdCompanycontactsRoute: typeof ContactContactIdCompanycontactsRoute
  ContactContactIdConceptsRoute: typeof ContactContactIdConceptsRoute
  ContactContactIdDetailsRoute: typeof ContactContactIdDetailsRoute
  ContactContactIdLinksRoute: typeof ContactContactIdLinksRoute
  ContactContactIdListsRoute: typeof ContactContactIdListsRoute
  ContactContactIdNotesRoute: typeof ContactContactIdNotesRoute
  ContactContactIdProductionsRoute: typeof ContactContactIdProductionsRoute
  ContactContactIdRetailerRoute: typeof ContactContactIdRetailerRoute
  ContactContactIdRoyaltyRoute: typeof ContactContactIdRoyaltyRoute
  ContactContactIdTextsRoute: typeof ContactContactIdTextsRoute
  ContactContactIdWorksRoute: typeof ContactContactIdWorksRoute
  ContactContactIdIndexRoute: typeof ContactContactIdIndexRoute
}

const ContactContactIdRouteChildren: ContactContactIdRouteChildren = {
  ContactContactIdAddressesRoute: ContactContactIdAddressesRoute,
  ContactContactIdAgreementsRoute: ContactContactIdAgreementsRoute,
  ContactContactIdAssetsRoute: ContactContactIdAssetsRoute,
  ContactContactIdCompanycontactsRoute: ContactContactIdCompanycontactsRoute,
  ContactContactIdConceptsRoute: ContactContactIdConceptsRoute,
  ContactContactIdDetailsRoute: ContactContactIdDetailsRoute,
  ContactContactIdLinksRoute: ContactContactIdLinksRoute,
  ContactContactIdListsRoute: ContactContactIdListsRoute,
  ContactContactIdNotesRoute: ContactContactIdNotesRoute,
  ContactContactIdProductionsRoute: ContactContactIdProductionsRoute,
  ContactContactIdRetailerRoute: ContactContactIdRetailerRoute,
  ContactContactIdRoyaltyRoute: ContactContactIdRoyaltyRoute,
  ContactContactIdTextsRoute: ContactContactIdTextsRoute,
  ContactContactIdWorksRoute: ContactContactIdWorksRoute,
  ContactContactIdIndexRoute: ContactContactIdIndexRoute,
}

const ContactContactIdRouteWithChildren =
  ContactContactIdRoute._addFileChildren(ContactContactIdRouteChildren)

interface UserUserIdRouteChildren {
  UserUserIdAccessRoute: typeof UserUserIdAccessRoute
  UserUserIdClaimsRoute: typeof UserUserIdClaimsRoute
  UserUserIdContactsRoute: typeof UserUserIdContactsRoute
  UserUserIdGeneralRoute: typeof UserUserIdGeneralRoute
  UserUserIdIndexRoute: typeof UserUserIdIndexRoute
}

const UserUserIdRouteChildren: UserUserIdRouteChildren = {
  UserUserIdAccessRoute: UserUserIdAccessRoute,
  UserUserIdClaimsRoute: UserUserIdClaimsRoute,
  UserUserIdContactsRoute: UserUserIdContactsRoute,
  UserUserIdGeneralRoute: UserUserIdGeneralRoute,
  UserUserIdIndexRoute: UserUserIdIndexRoute,
}

const UserUserIdRouteWithChildren = UserUserIdRoute._addFileChildren(
  UserUserIdRouteChildren,
)

interface WorkWorkIdRouteChildren {
  WorkWorkIdAssetsRoute: typeof WorkWorkIdAssetsRoute
  WorkWorkIdCalculationRoute: typeof WorkWorkIdCalculationRoute
  WorkWorkIdCategorizationRoute: typeof WorkWorkIdCategorizationRoute
  WorkWorkIdContractsRoute: typeof WorkWorkIdContractsRoute
  WorkWorkIdCorrectionsRoute: typeof WorkWorkIdCorrectionsRoute
  WorkWorkIdCostsRoute: typeof WorkWorkIdCostsRoute
  WorkWorkIdLaunchBriefRoute: typeof WorkWorkIdLaunchBriefRoute
  WorkWorkIdMiscRoute: typeof WorkWorkIdMiscRoute
  WorkWorkIdProductionsRoute: typeof WorkWorkIdProductionsRoute
  WorkWorkIdProfitabilityRoute: typeof WorkWorkIdProfitabilityRoute
  WorkWorkIdReviewQuotesRoute: typeof WorkWorkIdReviewQuotesRoute
  WorkWorkIdRightsRoute: typeof WorkWorkIdRightsRoute
  WorkWorkIdRoyaltyRoute: typeof WorkWorkIdRoyaltyRoute
  WorkWorkIdTeamRoute: typeof WorkWorkIdTeamRoute
  WorkWorkIdIndexRoute: typeof WorkWorkIdIndexRoute
  WorkWorkIdLaunchPlanIndexRoute: typeof WorkWorkIdLaunchPlanIndexRoute
  WorkWorkIdLaunchPlanActivityActivityIdRoute: typeof WorkWorkIdLaunchPlanActivityActivityIdRoute
}

const WorkWorkIdRouteChildren: WorkWorkIdRouteChildren = {
  WorkWorkIdAssetsRoute: WorkWorkIdAssetsRoute,
  WorkWorkIdCalculationRoute: WorkWorkIdCalculationRoute,
  WorkWorkIdCategorizationRoute: WorkWorkIdCategorizationRoute,
  WorkWorkIdContractsRoute: WorkWorkIdContractsRoute,
  WorkWorkIdCorrectionsRoute: WorkWorkIdCorrectionsRoute,
  WorkWorkIdCostsRoute: WorkWorkIdCostsRoute,
  WorkWorkIdLaunchBriefRoute: WorkWorkIdLaunchBriefRoute,
  WorkWorkIdMiscRoute: WorkWorkIdMiscRoute,
  WorkWorkIdProductionsRoute: WorkWorkIdProductionsRoute,
  WorkWorkIdProfitabilityRoute: WorkWorkIdProfitabilityRoute,
  WorkWorkIdReviewQuotesRoute: WorkWorkIdReviewQuotesRoute,
  WorkWorkIdRightsRoute: WorkWorkIdRightsRoute,
  WorkWorkIdRoyaltyRoute: WorkWorkIdRoyaltyRoute,
  WorkWorkIdTeamRoute: WorkWorkIdTeamRoute,
  WorkWorkIdIndexRoute: WorkWorkIdIndexRoute,
  WorkWorkIdLaunchPlanIndexRoute: WorkWorkIdLaunchPlanIndexRoute,
  WorkWorkIdLaunchPlanActivityActivityIdRoute:
    WorkWorkIdLaunchPlanActivityActivityIdRoute,
}

const WorkWorkIdRouteWithChildren = WorkWorkIdRoute._addFileChildren(
  WorkWorkIdRouteChildren,
)

interface AdministrationUsersIdRouteChildren {
  AdministrationUsersIdAccessRoute: typeof AdministrationUsersIdAccessRoute
  AdministrationUsersIdGeneralRoute: typeof AdministrationUsersIdGeneralRoute
  AdministrationUsersIdIndexRoute: typeof AdministrationUsersIdIndexRoute
}

const AdministrationUsersIdRouteChildren: AdministrationUsersIdRouteChildren = {
  AdministrationUsersIdAccessRoute: AdministrationUsersIdAccessRoute,
  AdministrationUsersIdGeneralRoute: AdministrationUsersIdGeneralRoute,
  AdministrationUsersIdIndexRoute: AdministrationUsersIdIndexRoute,
}

const AdministrationUsersIdRouteWithChildren =
  AdministrationUsersIdRoute._addFileChildren(
    AdministrationUsersIdRouteChildren,
  )

interface RoyaltyAgreementIdRouteChildren {
  RoyaltyAgreementIdGeneralRoute: typeof RoyaltyAgreementIdGeneralRoute
  RoyaltyAgreementIdTransactionsRoute: typeof RoyaltyAgreementIdTransactionsRoute
  RoyaltyAgreementIdSettlementsIndexRoute: typeof RoyaltyAgreementIdSettlementsIndexRoute
  RoyaltyAgreementIdTermsIndexRoute: typeof RoyaltyAgreementIdTermsIndexRoute
  RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute: typeof RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute
  RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute: typeof RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute
}

const RoyaltyAgreementIdRouteChildren: RoyaltyAgreementIdRouteChildren = {
  RoyaltyAgreementIdGeneralRoute: RoyaltyAgreementIdGeneralRoute,
  RoyaltyAgreementIdTransactionsRoute: RoyaltyAgreementIdTransactionsRoute,
  RoyaltyAgreementIdSettlementsIndexRoute:
    RoyaltyAgreementIdSettlementsIndexRoute,
  RoyaltyAgreementIdTermsIndexRoute: RoyaltyAgreementIdTermsIndexRoute,
  RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute:
    RoyaltyAgreementIdTermsRuleSetIdVersionRuleIdRoute,
  RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute:
    RoyaltyAgreementIdSettlementsSettlementIdReceiverContactIdStatusRoute,
}

const RoyaltyAgreementIdRouteWithChildren =
  RoyaltyAgreementIdRoute._addFileChildren(RoyaltyAgreementIdRouteChildren)

interface WorkWorkIdEditionEditionIdRouteChildren {
  WorkWorkIdEditionEditionIdAssetsRoute: typeof WorkWorkIdEditionEditionIdAssetsRoute
  WorkWorkIdEditionEditionIdCommentsRoute: typeof WorkWorkIdEditionEditionIdCommentsRoute
  WorkWorkIdEditionEditionIdContentCategorizationRoute: typeof WorkWorkIdEditionEditionIdContentCategorizationRoute
  WorkWorkIdEditionEditionIdContentEditorialRoute: typeof WorkWorkIdEditionEditionIdContentEditorialRoute
  WorkWorkIdEditionEditionIdContentEducationRoute: typeof WorkWorkIdEditionEditionIdContentEducationRoute
  WorkWorkIdEditionEditionIdContentLinksRoute: typeof WorkWorkIdEditionEditionIdContentLinksRoute
  WorkWorkIdEditionEditionIdContentPressSalesRoute: typeof WorkWorkIdEditionEditionIdContentPressSalesRoute
  WorkWorkIdEditionEditionIdContentTitlePortraitRoute: typeof WorkWorkIdEditionEditionIdContentTitlePortraitRoute
  WorkWorkIdEditionEditionIdCopyproductionRoute: typeof WorkWorkIdEditionEditionIdCopyproductionRoute
  WorkWorkIdEditionEditionIdCopytechnicalproductionRoute: typeof WorkWorkIdEditionEditionIdCopytechnicalproductionRoute
  WorkWorkIdEditionEditionIdDistributionRoute: typeof WorkWorkIdEditionEditionIdDistributionRoute
  WorkWorkIdEditionEditionIdDistributionLogsRoute: typeof WorkWorkIdEditionEditionIdDistributionLogsRoute
  WorkWorkIdEditionEditionIdErpRoute: typeof WorkWorkIdEditionEditionIdErpRoute
  WorkWorkIdEditionEditionIdGeneralBookclubsRoute: typeof WorkWorkIdEditionEditionIdGeneralBookclubsRoute
  WorkWorkIdEditionEditionIdGeneralCostsRoute: typeof WorkWorkIdEditionEditionIdGeneralCostsRoute
  WorkWorkIdEditionEditionIdGeneralMiscRoute: typeof WorkWorkIdEditionEditionIdGeneralMiscRoute
  WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute: typeof WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute
  WorkWorkIdEditionEditionIdGeneralPrintrunRoute: typeof WorkWorkIdEditionEditionIdGeneralPrintrunRoute
  WorkWorkIdEditionEditionIdGeneralRightsRoute: typeof WorkWorkIdEditionEditionIdGeneralRightsRoute
  WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute: typeof WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute
  WorkWorkIdEditionEditionIdGeneralSalesRoute: typeof WorkWorkIdEditionEditionIdGeneralSalesRoute
  WorkWorkIdEditionEditionIdGeneralScheduleRoute: typeof WorkWorkIdEditionEditionIdGeneralScheduleRoute
  WorkWorkIdEditionEditionIdLayoutRoute: typeof WorkWorkIdEditionEditionIdLayoutRoute
  WorkWorkIdEditionEditionIdLayoutBindingRoute: typeof WorkWorkIdEditionEditionIdLayoutBindingRoute
  WorkWorkIdEditionEditionIdLayoutCompositionRoute: typeof WorkWorkIdEditionEditionIdLayoutCompositionRoute
  WorkWorkIdEditionEditionIdLayoutCoverRoute: typeof WorkWorkIdEditionEditionIdLayoutCoverRoute
  WorkWorkIdEditionEditionIdLayoutInsideRoute: typeof WorkWorkIdEditionEditionIdLayoutInsideRoute
  WorkWorkIdEditionEditionIdLayoutMeasurementsRoute: typeof WorkWorkIdEditionEditionIdLayoutMeasurementsRoute
  WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute: typeof WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute
  WorkWorkIdEditionEditionIdPrintOrdersRoute: typeof WorkWorkIdEditionEditionIdPrintOrdersRoute
  WorkWorkIdEditionEditionIdPrintchangesRoute: typeof WorkWorkIdEditionEditionIdPrintchangesRoute
  WorkWorkIdEditionEditionIdProfitabilityRoute: typeof WorkWorkIdEditionEditionIdProfitabilityRoute
  WorkWorkIdEditionEditionIdPublishRoute: typeof WorkWorkIdEditionEditionIdPublishRoute
  WorkWorkIdEditionEditionIdTeamRoute: typeof WorkWorkIdEditionEditionIdTeamRoute
  WorkWorkIdEditionEditionIdTechnicaldescriptionRoute: typeof WorkWorkIdEditionEditionIdTechnicaldescriptionRoute
  WorkWorkIdEditionEditionIdUnpublishRoute: typeof WorkWorkIdEditionEditionIdUnpublishRoute
  WorkWorkIdEditionEditionIdIndexRoute: typeof WorkWorkIdEditionEditionIdIndexRoute
}

const WorkWorkIdEditionEditionIdRouteChildren: WorkWorkIdEditionEditionIdRouteChildren =
  {
    WorkWorkIdEditionEditionIdAssetsRoute:
      WorkWorkIdEditionEditionIdAssetsRoute,
    WorkWorkIdEditionEditionIdCommentsRoute:
      WorkWorkIdEditionEditionIdCommentsRoute,
    WorkWorkIdEditionEditionIdContentCategorizationRoute:
      WorkWorkIdEditionEditionIdContentCategorizationRoute,
    WorkWorkIdEditionEditionIdContentEditorialRoute:
      WorkWorkIdEditionEditionIdContentEditorialRoute,
    WorkWorkIdEditionEditionIdContentEducationRoute:
      WorkWorkIdEditionEditionIdContentEducationRoute,
    WorkWorkIdEditionEditionIdContentLinksRoute:
      WorkWorkIdEditionEditionIdContentLinksRoute,
    WorkWorkIdEditionEditionIdContentPressSalesRoute:
      WorkWorkIdEditionEditionIdContentPressSalesRoute,
    WorkWorkIdEditionEditionIdContentTitlePortraitRoute:
      WorkWorkIdEditionEditionIdContentTitlePortraitRoute,
    WorkWorkIdEditionEditionIdCopyproductionRoute:
      WorkWorkIdEditionEditionIdCopyproductionRoute,
    WorkWorkIdEditionEditionIdCopytechnicalproductionRoute:
      WorkWorkIdEditionEditionIdCopytechnicalproductionRoute,
    WorkWorkIdEditionEditionIdDistributionRoute:
      WorkWorkIdEditionEditionIdDistributionRoute,
    WorkWorkIdEditionEditionIdDistributionLogsRoute:
      WorkWorkIdEditionEditionIdDistributionLogsRoute,
    WorkWorkIdEditionEditionIdErpRoute: WorkWorkIdEditionEditionIdErpRoute,
    WorkWorkIdEditionEditionIdGeneralBookclubsRoute:
      WorkWorkIdEditionEditionIdGeneralBookclubsRoute,
    WorkWorkIdEditionEditionIdGeneralCostsRoute:
      WorkWorkIdEditionEditionIdGeneralCostsRoute,
    WorkWorkIdEditionEditionIdGeneralMiscRoute:
      WorkWorkIdEditionEditionIdGeneralMiscRoute,
    WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute:
      WorkWorkIdEditionEditionIdGeneralPriceAndCostRoute,
    WorkWorkIdEditionEditionIdGeneralPrintrunRoute:
      WorkWorkIdEditionEditionIdGeneralPrintrunRoute,
    WorkWorkIdEditionEditionIdGeneralRightsRoute:
      WorkWorkIdEditionEditionIdGeneralRightsRoute,
    WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute:
      WorkWorkIdEditionEditionIdGeneralRoyaltyLevelsRoute,
    WorkWorkIdEditionEditionIdGeneralSalesRoute:
      WorkWorkIdEditionEditionIdGeneralSalesRoute,
    WorkWorkIdEditionEditionIdGeneralScheduleRoute:
      WorkWorkIdEditionEditionIdGeneralScheduleRoute,
    WorkWorkIdEditionEditionIdLayoutRoute:
      WorkWorkIdEditionEditionIdLayoutRoute,
    WorkWorkIdEditionEditionIdLayoutBindingRoute:
      WorkWorkIdEditionEditionIdLayoutBindingRoute,
    WorkWorkIdEditionEditionIdLayoutCompositionRoute:
      WorkWorkIdEditionEditionIdLayoutCompositionRoute,
    WorkWorkIdEditionEditionIdLayoutCoverRoute:
      WorkWorkIdEditionEditionIdLayoutCoverRoute,
    WorkWorkIdEditionEditionIdLayoutInsideRoute:
      WorkWorkIdEditionEditionIdLayoutInsideRoute,
    WorkWorkIdEditionEditionIdLayoutMeasurementsRoute:
      WorkWorkIdEditionEditionIdLayoutMeasurementsRoute,
    WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute:
      WorkWorkIdEditionEditionIdLayoutTechnicalproductionRoute,
    WorkWorkIdEditionEditionIdPrintOrdersRoute:
      WorkWorkIdEditionEditionIdPrintOrdersRoute,
    WorkWorkIdEditionEditionIdPrintchangesRoute:
      WorkWorkIdEditionEditionIdPrintchangesRoute,
    WorkWorkIdEditionEditionIdProfitabilityRoute:
      WorkWorkIdEditionEditionIdProfitabilityRoute,
    WorkWorkIdEditionEditionIdPublishRoute:
      WorkWorkIdEditionEditionIdPublishRoute,
    WorkWorkIdEditionEditionIdTeamRoute: WorkWorkIdEditionEditionIdTeamRoute,
    WorkWorkIdEditionEditionIdTechnicaldescriptionRoute:
      WorkWorkIdEditionEditionIdTechnicaldescriptionRoute,
    WorkWorkIdEditionEditionIdUnpublishRoute:
      WorkWorkIdEditionEditionIdUnpublishRoute,
    WorkWorkIdEditionEditionIdIndexRoute: WorkWorkIdEditionEditionIdIndexRoute,
  }

const WorkWorkIdEditionEditionIdRouteWithChildren =
  WorkWorkIdEditionEditionIdRoute._addFileChildren(
    WorkWorkIdEditionEditionIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EditionsearchRoute: EditionsearchRouteWithChildren,
  WorksearchRoute: WorksearchRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  ConceptsRoute: ConceptsRoute,
  ImportsRoute: ImportsRouteWithChildren,
  IntegrationsRoute: IntegrationsRouteWithChildren,
  MetadataRoute: MetadataRouteWithChildren,
  MydownloadsRoute: MydownloadsRoute,
  MyworkRoute: MyworkRoute,
  RoyaltyRoute: RoyaltyRouteWithChildren,
  UsersRoute: UsersRoute,
  AdministrationCosttypesRoute: AdministrationCosttypesRoute,
  AdministrationEanseriesRoute: AdministrationEanseriesRoute,
  AdministrationEmailtemplatesRoute: AdministrationEmailtemplatesRoute,
  AdministrationIntegrationsRoute: AdministrationIntegrationsRouteWithChildren,
  AdministrationMetadataRoute: AdministrationMetadataRoute,
  AdministrationPrinterpricesRoute: AdministrationPrinterpricesRoute,
  AdministrationProductionPlansRoute: AdministrationProductionPlansRoute,
  AdministrationRoyaltyPriceRulesRoute: AdministrationRoyaltyPriceRulesRoute,
  AdministrationRoyaltySalesChannelsRoute:
    AdministrationRoyaltySalesChannelsRoute,
  AdministrationTagsRoute: AdministrationTagsRoute,
  AssetsIdRoute: AssetsIdRouteWithChildren,
  BundleMainRoute: BundleMainRouteWithChildren,
  BundleListRoute: BundleListRoute,
  ConceptConceptIdRoute: ConceptConceptIdRouteWithChildren,
  ContactContactIdRoute: ContactContactIdRouteWithChildren,
  ContactsListsRoute: ContactsListsRoute,
  UserUserIdRoute: UserUserIdRouteWithChildren,
  WorkWorkIdRoute: WorkWorkIdRouteWithChildren,
  WorkWorksRoute: WorkWorksRoute,
  AdministrationIndexRoute: AdministrationIndexRoute,
  AssetsIndexRoute: AssetsIndexRoute,
  ContactsIndexRoute: ContactsIndexRoute,
  AdministrationClientsIdRoute: AdministrationClientsIdRoute,
  AdministrationImportsCreateretailerordersRoute:
    AdministrationImportsCreateretailerordersRoute,
  AdministrationImportsImportpricesRoute:
    AdministrationImportsImportpricesRoute,
  AdministrationImportsImportstockchangesRoute:
    AdministrationImportsImportstockchangesRoute,
  AdministrationImportsImporttransactionRoute:
    AdministrationImportsImporttransactionRoute,
  AdministrationUsersIdRoute: AdministrationUsersIdRouteWithChildren,
  ContactsListIdRoute: ContactsListIdRoute,
  RoyaltyAgreementIdRoute: RoyaltyAgreementIdRouteWithChildren,
  SeriesListSerieIdRoute: SeriesListSerieIdRoute,
  WorkActivitiesActivityIdRoute: WorkActivitiesActivityIdRoute,
  AdministrationClientsIndexRoute: AdministrationClientsIndexRoute,
  AdministrationUsersIndexRoute: AdministrationUsersIndexRoute,
  BookWorkIdIndexRoute: BookWorkIdIndexRoute,
  SeriesListIndexRoute: SeriesListIndexRoute,
  WorkActivitiesIndexRoute: WorkActivitiesIndexRoute,
  BookWorkIdEditionEditionIdRoute: BookWorkIdEditionEditionIdRoute,
  WorkWorkIdEditionEditionIdRoute: WorkWorkIdEditionEditionIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
